/* tslint:disable */
/* eslint-disable */
/**
 * Hyper API Gateway
 * **Introduction** API Gateway for Hyper  This specification describes API endpoints that are available to the public internet via the API gateway. The different endpoints require different authentication schemes, see documentation for what applies to the operation you want to access.  **Errors** Uses conventional HTTP response codes to indicate success or failure. In general:   - `2xx` status codes indicate success. Codes in the - `4xx` range indicate a client error (e.g. required parameters, failed request etc.). - `5xx` status codes indicate a server error occurred.
 *
 * The version of the OpenAPI document: 2.0.3
 * Contact: techops@nestcoin.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 * Status of the activity
 * @export
 * @enum {string}
 */
export var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["PENDING"] = "PENDING";
    ActivityStatus["COMPLETED"] = "COMPLETED";
})(ActivityStatus || (ActivityStatus = {}));
/**
 * Types of activities
 * @export
 * @enum {string}
 */
export var ActivityType;
(function (ActivityType) {
    ActivityType["TOURNAMENT"] = "TOURNAMENT";
    ActivityType["REWARD"] = "REWARD";
    ActivityType["PRACTICE"] = "PRACTICE";
})(ActivityType || (ActivityType = {}));
/**
 * Combined reasons for canceling a tournament or an entry
 * @export
 * @enum {string}
 */
export var CancelReason;
(function (CancelReason) {
    CancelReason["DECLINED"] = "DECLINED";
    CancelReason["EXPIRED"] = "EXPIRED";
    CancelReason["RETREAT"] = "RETREAT";
    CancelReason["COULD_NOT_FIND_MATCH"] = "COULD_NOT_FIND_MATCH";
    CancelReason["GAME_DELETED"] = "GAME_DELETED";
    CancelReason["CLOSED_BY_ADMIN"] = "CLOSED_BY_ADMIN";
    CancelReason["MISSING_SCORE"] = "MISSING_SCORE";
    CancelReason["FORFEIT"] = "FORFEIT";
})(CancelReason || (CancelReason = {}));
/**
 * Status of challenge
 * @export
 * @enum {string}
 */
export var ChallengeStatus;
(function (ChallengeStatus) {
    ChallengeStatus["PENDING"] = "PENDING";
    ChallengeStatus["EXPIRED"] = "EXPIRED";
    ChallengeStatus["ACCEPTED"] = "ACCEPTED";
    ChallengeStatus["DECLINED"] = "DECLINED";
    ChallengeStatus["WITHDRAWN"] = "WITHDRAWN";
    ChallengeStatus["COMPLETED"] = "COMPLETED";
})(ChallengeStatus || (ChallengeStatus = {}));
/**
 * The sources that a connection is pulled from
 * @export
 * @enum {string}
 */
export var ConnectionSource;
(function (ConnectionSource) {
    ConnectionSource["GOOGLE"] = "GOOGLE";
    ConnectionSource["FACEBOOK"] = "FACEBOOK";
    ConnectionSource["APPLE"] = "APPLE";
    ConnectionSource["TWITTER"] = "TWITTER";
    ConnectionSource["PHONE"] = "PHONE";
})(ConnectionSource || (ConnectionSource = {}));
/**
 * Available currencies
 * @export
 * @enum {string}
 */
export var Currency;
(function (Currency) {
    Currency["HPR"] = "HPR";
    Currency["USD"] = "USD";
    Currency["GEM"] = "GEM";
})(Currency || (Currency = {}));
/**
 * Available fiat currencies
 * @export
 * @enum {string}
 */
export var FiatCurrency;
(function (FiatCurrency) {
    FiatCurrency["NGN"] = "NGN";
    FiatCurrency["USD"] = "USD";
})(FiatCurrency || (FiatCurrency = {}));
/**
 * File type
 * @export
 * @enum {string}
 */
export var FileType;
(function (FileType) {
    FileType["APK"] = "APK";
})(FileType || (FileType = {}));
/**
 * The game events
 * @export
 * @enum {string}
 */
export var GameEvent;
(function (GameEvent) {
    GameEvent["GAME_START"] = "GAME_START";
    GameEvent["GAME_PAUSE"] = "GAME_PAUSE";
    GameEvent["GAME_RESUME"] = "GAME_RESUME";
    GameEvent["GAME_END"] = "GAME_END";
    GameEvent["GAME_FAILED"] = "GAME_FAILED";
    GameEvent["SCORE_RECEIVED"] = "SCORE_RECEIVED";
})(GameEvent || (GameEvent = {}));
/**
 * Orientation of the game, defaults to PORTRAIT
 * @export
 * @enum {string}
 */
export var GameOrientation;
(function (GameOrientation) {
    GameOrientation["PORTRAIT"] = "PORTRAIT";
    GameOrientation["LANDSCAPE"] = "LANDSCAPE";
})(GameOrientation || (GameOrientation = {}));
/**
 * The game provider
 * @export
 * @enum {string}
 */
export var GameProvider;
(function (GameProvider) {
    GameProvider["MARKETJS"] = "MARKETJS";
    GameProvider["FREAKXAPPS"] = "FREAKXAPPS";
    GameProvider["DOONDOOK"] = "DOONDOOK";
    GameProvider["HYPERGSA"] = "HYPERGSA";
    GameProvider["HYPERGSB"] = "HYPERGSB";
    GameProvider["HYPERGSC"] = "HYPERGSC";
})(GameProvider || (GameProvider = {}));
/**
 * Status of the game, defaults to ACTIVE
 * @export
 * @enum {string}
 */
export var GameStatus;
(function (GameStatus) {
    GameStatus["ACTIVE"] = "ACTIVE";
    GameStatus["INACTIVE"] = "INACTIVE";
})(GameStatus || (GameStatus = {}));
/**
 * The type of the gameplay, if pvp is true the value will be TOURNAMENT otherwise PRACTICE
 * @export
 * @enum {string}
 */
export var GameplayType;
(function (GameplayType) {
    GameplayType["PRACTICE"] = "PRACTICE";
    GameplayType["TOURNAMENT"] = "TOURNAMENT";
})(GameplayType || (GameplayType = {}));
/**
 * Gender of user
 * @export
 * @enum {string}
 */
export var Gender;
(function (Gender) {
    Gender["M"] = "M";
    Gender["F"] = "F";
})(Gender || (Gender = {}));
/**
 * Verification ID types
 * @export
 * @enum {string}
 */
export var IdType;
(function (IdType) {
    IdType["PASSPORT"] = "PASSPORT";
    IdType["NATIONAL_ID"] = "NATIONAL_ID";
    IdType["VOTER_ID"] = "VOTER_ID";
    IdType["DRIVERS_LICENSE"] = "DRIVERS_LICENSE";
    IdType["RESIDENT_CARD"] = "RESIDENT_CARD";
    IdType["BVN"] = "BVN";
    IdType["OTHER"] = "OTHER";
})(IdType || (IdType = {}));
/**
 * Onboarding initialization source
 * @export
 * @enum {string}
 */
export var InitSource;
(function (InitSource) {
    InitSource["MOBILE"] = "MOBILE";
    InitSource["WEB"] = "WEB";
})(InitSource || (InitSource = {}));
/**
 * Available KYC and AML status
 * @export
 * @enum {string}
 */
export var KycAmlVerificationStatus;
(function (KycAmlVerificationStatus) {
    KycAmlVerificationStatus["AWAITING_INPUT"] = "AWAITING_INPUT";
    KycAmlVerificationStatus["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    KycAmlVerificationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    KycAmlVerificationStatus["REVIEW_REQUIRED"] = "REVIEW_REQUIRED";
    KycAmlVerificationStatus["UNVERIFIED"] = "UNVERIFIED";
    KycAmlVerificationStatus["VERIFIED"] = "VERIFIED";
})(KycAmlVerificationStatus || (KycAmlVerificationStatus = {}));
/**
 * Available job status for KYC
 * @export
 * @enum {string}
 */
export var KycJobStatus;
(function (KycJobStatus) {
    KycJobStatus["AWAITING_INPUT"] = "AWAITING_INPUT";
    KycJobStatus["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    KycJobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    KycJobStatus["REVIEW_REQUIRED"] = "REVIEW_REQUIRED";
    KycJobStatus["UNVERIFIED"] = "UNVERIFIED";
    KycJobStatus["VERIFICATION_TIMEOUT"] = "VERIFICATION_TIMEOUT";
    KycJobStatus["VERIFIED"] = "VERIFIED";
})(KycJobStatus || (KycJobStatus = {}));
/**
 * Groups of leaderboard
 * @export
 * @enum {string}
 */
export var LeaderboardGroup;
(function (LeaderboardGroup) {
    LeaderboardGroup["TODAY"] = "TODAY";
    LeaderboardGroup["THIS_WEEK"] = "THIS_WEEK";
    LeaderboardGroup["LAST_7_DAYS"] = "LAST_7_DAYS";
    LeaderboardGroup["LAST_30_DAYS"] = "LAST_30_DAYS";
    LeaderboardGroup["ALL_TIME"] = "ALL_TIME";
})(LeaderboardGroup || (LeaderboardGroup = {}));
/**
 * Transaction types for lift
 * @export
 * @enum {string}
 */
export var LiftTransactionType;
(function (LiftTransactionType) {
    LiftTransactionType["DEPOSIT"] = "DEPOSIT";
    LiftTransactionType["WITHDRAWAL"] = "WITHDRAWAL";
})(LiftTransactionType || (LiftTransactionType = {}));
/**
 * The provider that sponsors the user authentication
 * @export
 * @enum {string}
 */
export var OAuthProvider;
(function (OAuthProvider) {
    OAuthProvider["GOOGLE"] = "GOOGLE";
    OAuthProvider["FACEBOOK"] = "FACEBOOK";
    OAuthProvider["APPLE"] = "APPLE";
    OAuthProvider["TWITTER"] = "TWITTER";
})(OAuthProvider || (OAuthProvider = {}));
/**
 * The reason or category for OTP to be sent
 * @export
 * @enum {string}
 */
export var OtpPurpose;
(function (OtpPurpose) {
    OtpPurpose["WITHDRAWAL"] = "WITHDRAWAL";
    OtpPurpose["EMAIL_CHANGE"] = "EMAIL_CHANGE";
})(OtpPurpose || (OtpPurpose = {}));
/**
 * Payment provider
 * @export
 * @enum {string}
 */
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["PAYPAL"] = "PAYPAL";
    PaymentProvider["COINFLOW"] = "COINFLOW";
    PaymentProvider["VELLA"] = "VELLA";
    PaymentProvider["PAYSTACK"] = "PAYSTACK";
})(PaymentProvider || (PaymentProvider = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PaymentProviderQueryProviderEnum;
(function (PaymentProviderQueryProviderEnum) {
    PaymentProviderQueryProviderEnum["COINFLOW"] = "COINFLOW";
    PaymentProviderQueryProviderEnum["PAYPAL"] = "PAYPAL";
    PaymentProviderQueryProviderEnum["VELLA"] = "VELLA";
    PaymentProviderQueryProviderEnum["PAYSTACK"] = "PAYSTACK";
})(PaymentProviderQueryProviderEnum || (PaymentProviderQueryProviderEnum = {}));
/**
 * Payment type
 * @export
 * @enum {string}
 */
export var PaymentType;
(function (PaymentType) {
    PaymentType["PAYPAL"] = "PAYPAL";
    PaymentType["CARD"] = "CARD";
    PaymentType["ACH"] = "ACH";
    PaymentType["APPLE_PAY"] = "APPLE_PAY";
    PaymentType["GOOGLE_PAY"] = "GOOGLE_PAY";
})(PaymentType || (PaymentType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PayoutAccountTypeQueryPayoutAccountTypeEnum;
(function (PayoutAccountTypeQueryPayoutAccountTypeEnum) {
    PayoutAccountTypeQueryPayoutAccountTypeEnum["BANK"] = "BANK";
    PayoutAccountTypeQueryPayoutAccountTypeEnum["CARD"] = "CARD";
    PayoutAccountTypeQueryPayoutAccountTypeEnum["PAYPAL"] = "PAYPAL";
})(PayoutAccountTypeQueryPayoutAccountTypeEnum || (PayoutAccountTypeQueryPayoutAccountTypeEnum = {}));
/**
 * Order status.
 * @export
 * @enum {string}
 */
export var PaypalOrderStatus;
(function (PaypalOrderStatus) {
    PaypalOrderStatus["APPROVED"] = "APPROVED";
    PaypalOrderStatus["COMPLETED"] = "COMPLETED";
    PaypalOrderStatus["REVERSED"] = "REVERSED";
})(PaypalOrderStatus || (PaypalOrderStatus = {}));
/**
 * The state of fast-match for user preference
 * @export
 * @enum {string}
 */
export var PreferenceFastMatchState;
(function (PreferenceFastMatchState) {
    PreferenceFastMatchState["ON"] = "ON";
    PreferenceFastMatchState["OFF"] = "OFF";
    PreferenceFastMatchState["DISABLED"] = "DISABLED";
})(PreferenceFastMatchState || (PreferenceFastMatchState = {}));
/**
 * Currencies that require KYC
 * @export
 * @enum {string}
 */
export var RequireKYCCurrency;
(function (RequireKYCCurrency) {
    RequireKYCCurrency["USD"] = "USD";
    RequireKYCCurrency["NGN"] = "NGN";
    RequireKYCCurrency["HPR"] = "HPR";
})(RequireKYCCurrency || (RequireKYCCurrency = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var RestrictionLevel;
(function (RestrictionLevel) {
    RestrictionLevel["COUNTRY"] = "COUNTRY";
    RestrictionLevel["REGION"] = "REGION";
    RestrictionLevel["SUB_REGION"] = "SUB_REGION";
    RestrictionLevel["CITY"] = "CITY";
})(RestrictionLevel || (RestrictionLevel = {}));
/**
 * Currency type of reward
 * @export
 * @enum {string}
 */
export var RewardCurrency;
(function (RewardCurrency) {
    RewardCurrency["HPR"] = "HPR";
    RewardCurrency["GEM"] = "GEM";
})(RewardCurrency || (RewardCurrency = {}));
/**
 * Reward or prize style
 * @export
 * @enum {string}
 */
export var RewardStyle;
(function (RewardStyle) {
    RewardStyle["PP"] = "PP";
    RewardStyle["VP"] = "VP";
})(RewardStyle || (RewardStyle = {}));
/**
 * Sponsor type for tournament
 * @export
 * @enum {string}
 */
export var SponsorType;
(function (SponsorType) {
    SponsorType["HOST"] = "HOST";
    SponsorType["CONTESTANT"] = "CONTESTANT";
})(SponsorType || (SponsorType = {}));
/**
 * Available currencies for staking. Defaults to HPR
 * @export
 * @enum {string}
 */
export var StakeCurrency;
(function (StakeCurrency) {
    StakeCurrency["HPR"] = "HPR";
    StakeCurrency["GEM"] = "GEM";
})(StakeCurrency || (StakeCurrency = {}));
/**
 * Available currencies for reward. Defaults to GEM
 * @export
 * @enum {string}
 */
export var TaskRewardCurrency;
(function (TaskRewardCurrency) {
    TaskRewardCurrency["GEM"] = "GEM";
    TaskRewardCurrency["HPR"] = "HPR";
})(TaskRewardCurrency || (TaskRewardCurrency = {}));
/**
 * Supported task sub-types
 * @export
 * @enum {string}
 */
export var TaskSubType;
(function (TaskSubType) {
    TaskSubType["PRACTICE"] = "PRACTICE";
    TaskSubType["DUEL"] = "DUEL";
    TaskSubType["MULTI"] = "MULTI";
    TaskSubType["CHALLENGE"] = "CHALLENGE";
})(TaskSubType || (TaskSubType = {}));
/**
 * Supported task types
 * @export
 * @enum {string}
 */
export var TaskType;
(function (TaskType) {
    TaskType["SCORE"] = "SCORE";
    TaskType["SPEND"] = "SPEND";
    TaskType["GAME_FREQUENCY"] = "GAME_FREQUENCY";
    TaskType["TOP_UP"] = "TOP_UP";
    TaskType["WIN_GAME"] = "WIN_GAME";
    TaskType["REFER"] = "REFER";
    TaskType["INVITE"] = "INVITE";
    TaskType["INVITE_ACCEPTANCE"] = "INVITE_ACCEPTANCE";
})(TaskType || (TaskType = {}));
/**
 * Overall status of a tournament
 * @export
 * @enum {string}
 */
export var TournamentStatus;
(function (TournamentStatus) {
    TournamentStatus["DRAFT"] = "DRAFT";
    TournamentStatus["OPEN"] = "OPEN";
    TournamentStatus["LIVE"] = "LIVE";
    TournamentStatus["AWAITING_OPPONENT"] = "AWAITING_OPPONENT";
    TournamentStatus["ONGOING"] = "ONGOING";
    TournamentStatus["COMPLETED"] = "COMPLETED";
    TournamentStatus["SCHEDULED"] = "SCHEDULED";
    TournamentStatus["FORFEIT"] = "FORFEIT";
})(TournamentStatus || (TournamentStatus = {}));
/**
 * Types of tournament
 * @export
 * @enum {string}
 */
export var TournamentType;
(function (TournamentType) {
    TournamentType["DUEL"] = "DUEL";
    TournamentType["MULTI"] = "MULTI";
    TournamentType["CHALLENGE"] = "CHALLENGE";
})(TournamentType || (TournamentType = {}));
/**
 * Orientation of the game, defaults to PORTRAIT
 * @export
 * @enum {string}
 */
export var TournamentsSvcGameOrientation;
(function (TournamentsSvcGameOrientation) {
    TournamentsSvcGameOrientation["PORTRAIT"] = "PORTRAIT";
    TournamentsSvcGameOrientation["LANDSCAPE"] = "LANDSCAPE";
})(TournamentsSvcGameOrientation || (TournamentsSvcGameOrientation = {}));
/**
 * Available transaction currencies (internal + fiat)
 * @export
 * @enum {string}
 */
export var TransactionCurrency;
(function (TransactionCurrency) {
    TransactionCurrency["HPR"] = "HPR";
    TransactionCurrency["GEM"] = "GEM";
    TransactionCurrency["USD"] = "USD";
    TransactionCurrency["NGN"] = "NGN";
})(TransactionCurrency || (TransactionCurrency = {}));
/**
 * Status of transaction
 * @export
 * @enum {string}
 */
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TransactionStatus["FAILED"] = "FAILED";
    TransactionStatus["REJECTED"] = "REJECTED";
    TransactionStatus["SUCCESS"] = "SUCCESS";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * The type of a transaction
 * @export
 * @enum {string}
 */
export var TransactionType;
(function (TransactionType) {
    TransactionType["REWARD"] = "REWARD";
    TransactionType["REWARD_EXPIRY"] = "REWARD_EXPIRY";
    TransactionType["INTERNAL_DEBIT"] = "INTERNAL_DEBIT";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["STAKE"] = "STAKE";
    TransactionType["REVERSAL"] = "REVERSAL";
    TransactionType["TOPUP"] = "TOPUP";
    TransactionType["CASHOUT"] = "CASHOUT";
    TransactionType["CRYPTO_DEPOSIT"] = "CRYPTO_DEPOSIT";
    TransactionType["CRYPTO_WITHDRAWAL"] = "CRYPTO_WITHDRAWAL";
    TransactionType["GEM_SWAP"] = "GEM_SWAP";
})(TransactionType || (TransactionType = {}));
/**
 * User gameplay outcome of tournament
 * @export
 * @enum {string}
 */
export var UserGameplayOutcome;
(function (UserGameplayOutcome) {
    UserGameplayOutcome["W"] = "W";
    UserGameplayOutcome["L"] = "L";
    UserGameplayOutcome["T"] = "T";
})(UserGameplayOutcome || (UserGameplayOutcome = {}));
/**
    * @export
    * @enum {string}
    */
export var UserKycDocumentDataStatusEnum;
(function (UserKycDocumentDataStatusEnum) {
    UserKycDocumentDataStatusEnum["AVAILABLE"] = "AVAILABLE";
    UserKycDocumentDataStatusEnum["UNAVAILABLE"] = "UNAVAILABLE";
    UserKycDocumentDataStatusEnum["PENDING_DOWNLOAD"] = "PENDING_DOWNLOAD";
})(UserKycDocumentDataStatusEnum || (UserKycDocumentDataStatusEnum = {}));
/**
 * User tag or label to categorize users
 * @export
 * @enum {string}
 */
export var UserTag;
(function (UserTag) {
    UserTag["INFLUENCER"] = "INFLUENCER";
    UserTag["NONE"] = "NONE";
})(UserTag || (UserTag = {}));
/**
 * ActivitiesActivitiesClient - axios parameter creator
 * @export
 */
export const ActivitiesActivitiesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get user past activities
         * @summary Get user past activities
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {GameplayType} [type] Gameplay type defined in query
         * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserActivities: (page, limit, type, status, startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/activities/me/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ActivitiesActivitiesClient - functional programming interface
 * @export
 */
export const ActivitiesActivitiesClientFp = function (configuration) {
    const localVarAxiosParamCreator = ActivitiesActivitiesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get user past activities
         * @summary Get user past activities
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {GameplayType} [type] Gameplay type defined in query
         * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserActivities(page, limit, type, status, startDate, endDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserActivities(page, limit, type, status, startDate, endDate, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ActivitiesActivitiesClient.getUserActivities']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ActivitiesActivitiesClient - factory interface
 * @export
 */
export const ActivitiesActivitiesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ActivitiesActivitiesClientFp(configuration);
    return {
        /**
         * Get user past activities
         * @summary Get user past activities
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {GameplayType} [type] Gameplay type defined in query
         * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserActivities(page, limit, type, status, startDate, endDate, options) {
            return localVarFp.getUserActivities(page, limit, type, status, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ActivitiesActivitiesClient - object-oriented interface
 * @export
 * @class ActivitiesActivitiesClient
 * @extends {BaseAPI}
 */
export class ActivitiesActivitiesClient extends BaseAPI {
    /**
     * Get user past activities
     * @summary Get user past activities
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {GameplayType} [type] Gameplay type defined in query
     * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
     * @param {string} [startDate] Start date defined in query
     * @param {string} [endDate] End date defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesActivitiesClient
     */
    getUserActivities(page, limit, type, status, startDate, endDate, options) {
        return ActivitiesActivitiesClientFp(this.configuration).getUserActivities(page, limit, type, status, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ComplianceGeoLocationClient - axios parameter creator
 * @export
 */
export const ComplianceGeoLocationClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves a list of all restricted locations.
         * @summary fetch all restricted locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRestrictedLocations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/locations/restricted-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves geo-location data from ip address.
         * @summary Get User IP-based geo-location data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGeoLocationFromIp: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/locations/by-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Restrict geo locations for all level (Country, Region, SubRegion and City)
         * @summary Restrict geo locations
         * @param {GeoLocationDTO} geoLocationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyGeoRestriction: (geoLocationDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'geoLocationDTO' is not null or undefined
            assertParamExists('modifyGeoRestriction', 'geoLocationDTO', geoLocationDTO);
            const localVarPath = `/compliance/locations/restricted-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(geoLocationDTO, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Stores user geo-location data.
         * @summary Store User Location Data
         * @param {UserLocationDto} userLocationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeUserLocation: (userLocationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userLocationDto' is not null or undefined
            assertParamExists('storeUserLocation', 'userLocationDto', userLocationDto);
            const localVarPath = `/compliance/me/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userLocationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ComplianceGeoLocationClient - functional programming interface
 * @export
 */
export const ComplianceGeoLocationClientFp = function (configuration) {
    const localVarAxiosParamCreator = ComplianceGeoLocationClientAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves a list of all restricted locations.
         * @summary fetch all restricted locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRestrictedLocations(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchRestrictedLocations(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceGeoLocationClient.fetchRestrictedLocations']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieves geo-location data from ip address.
         * @summary Get User IP-based geo-location data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGeoLocationFromIp(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserGeoLocationFromIp(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceGeoLocationClient.getUserGeoLocationFromIp']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Restrict geo locations for all level (Country, Region, SubRegion and City)
         * @summary Restrict geo locations
         * @param {GeoLocationDTO} geoLocationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyGeoRestriction(geoLocationDTO, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.modifyGeoRestriction(geoLocationDTO, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceGeoLocationClient.modifyGeoRestriction']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Stores user geo-location data.
         * @summary Store User Location Data
         * @param {UserLocationDto} userLocationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeUserLocation(userLocationDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.storeUserLocation(userLocationDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceGeoLocationClient.storeUserLocation']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ComplianceGeoLocationClient - factory interface
 * @export
 */
export const ComplianceGeoLocationClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ComplianceGeoLocationClientFp(configuration);
    return {
        /**
         * Retrieves a list of all restricted locations.
         * @summary fetch all restricted locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRestrictedLocations(options) {
            return localVarFp.fetchRestrictedLocations(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves geo-location data from ip address.
         * @summary Get User IP-based geo-location data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGeoLocationFromIp(options) {
            return localVarFp.getUserGeoLocationFromIp(options).then((request) => request(axios, basePath));
        },
        /**
         * Restrict geo locations for all level (Country, Region, SubRegion and City)
         * @summary Restrict geo locations
         * @param {GeoLocationDTO} geoLocationDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyGeoRestriction(geoLocationDTO, options) {
            return localVarFp.modifyGeoRestriction(geoLocationDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Stores user geo-location data.
         * @summary Store User Location Data
         * @param {UserLocationDto} userLocationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeUserLocation(userLocationDto, options) {
            return localVarFp.storeUserLocation(userLocationDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ComplianceGeoLocationClient - object-oriented interface
 * @export
 * @class ComplianceGeoLocationClient
 * @extends {BaseAPI}
 */
export class ComplianceGeoLocationClient extends BaseAPI {
    /**
     * Retrieves a list of all restricted locations.
     * @summary fetch all restricted locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceGeoLocationClient
     */
    fetchRestrictedLocations(options) {
        return ComplianceGeoLocationClientFp(this.configuration).fetchRestrictedLocations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves geo-location data from ip address.
     * @summary Get User IP-based geo-location data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceGeoLocationClient
     */
    getUserGeoLocationFromIp(options) {
        return ComplianceGeoLocationClientFp(this.configuration).getUserGeoLocationFromIp(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Restrict geo locations for all level (Country, Region, SubRegion and City)
     * @summary Restrict geo locations
     * @param {GeoLocationDTO} geoLocationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceGeoLocationClient
     */
    modifyGeoRestriction(geoLocationDTO, options) {
        return ComplianceGeoLocationClientFp(this.configuration).modifyGeoRestriction(geoLocationDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Stores user geo-location data.
     * @summary Store User Location Data
     * @param {UserLocationDto} userLocationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceGeoLocationClient
     */
    storeUserLocation(userLocationDto, options) {
        return ComplianceGeoLocationClientFp(this.configuration).storeUserLocation(userLocationDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ComplianceInternalKycClient - axios parameter creator
 * @export
 */
export const ComplianceInternalKycClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Upload kyc verification data for user to manually verify user\'s kyc.
         * @summary Upload user kyc verification data
         * @param {KycDataUploadPayload} kycDataUploadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInternalKycData: (kycDataUploadPayload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'kycDataUploadPayload' is not null or undefined
            assertParamExists('uploadInternalKycData', 'kycDataUploadPayload', kycDataUploadPayload);
            const localVarPath = `/compliance/kyc/internal/upload-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(kycDataUploadPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ComplianceInternalKycClient - functional programming interface
 * @export
 */
export const ComplianceInternalKycClientFp = function (configuration) {
    const localVarAxiosParamCreator = ComplianceInternalKycClientAxiosParamCreator(configuration);
    return {
        /**
         * Upload kyc verification data for user to manually verify user\'s kyc.
         * @summary Upload user kyc verification data
         * @param {KycDataUploadPayload} kycDataUploadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInternalKycData(kycDataUploadPayload, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadInternalKycData(kycDataUploadPayload, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceInternalKycClient.uploadInternalKycData']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ComplianceInternalKycClient - factory interface
 * @export
 */
export const ComplianceInternalKycClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ComplianceInternalKycClientFp(configuration);
    return {
        /**
         * Upload kyc verification data for user to manually verify user\'s kyc.
         * @summary Upload user kyc verification data
         * @param {KycDataUploadPayload} kycDataUploadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInternalKycData(kycDataUploadPayload, options) {
            return localVarFp.uploadInternalKycData(kycDataUploadPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ComplianceInternalKycClient - object-oriented interface
 * @export
 * @class ComplianceInternalKycClient
 * @extends {BaseAPI}
 */
export class ComplianceInternalKycClient extends BaseAPI {
    /**
     * Upload kyc verification data for user to manually verify user\'s kyc.
     * @summary Upload user kyc verification data
     * @param {KycDataUploadPayload} kycDataUploadPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceInternalKycClient
     */
    uploadInternalKycData(kycDataUploadPayload, options) {
        return ComplianceInternalKycClientFp(this.configuration).uploadInternalKycData(kycDataUploadPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ComplianceKycsClient - axios parameter creator
 * @export
 */
export const ComplianceKycsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Abort ongoing kyc session
         * @summary Abort KYC
         * @param {AbortKycRequest} [abortKycRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMyKyc: (abortKycRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/me/kyc/abort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(abortKycRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create change email-address request via KYC
         * @summary Create change email-address request via KYC
         * @param {ChangeEmailRequestDto} [changeEmailRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChangeEmailRequestViaKyc: (changeEmailRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/me/request-email-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(changeEmailRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of Hyper supported Countries for KYC
         * @summary List of Supported countries for KYC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKycSupportedCountries: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/kyc/supported-countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get KYC status
         * @summary Get KYC status
         * @param {boolean} [strict] Indicates if KYC status will only be checked locally or also with the external source. When &#x60;strict&#x60; is false, check is scoped for local, else both local &amp; external source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyKycStatus: (strict, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/me/kyc/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve the KYC verification, age verification, and location restriction status for a user
         * @summary Get user verification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVerificationStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/me/verification/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate KYC (using external app - Onboard)
         * @summary Initiate KYC
         * @param {string} [country] User country
         * @param {InitiateKycRequestDto} [initiateKycRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateKyc: (country, initiateKycRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/me/kyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(initiateKycRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Check if KYC is required (using a system defined threshold & communication with user-service KYC)
         * @summary Check if KYC is required
         * @param {RequiresKycRequestDto} [requiresKycRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requiresKyc: (requiresKycRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/me/requires-kyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requiresKycRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Callback url to receive user kyc document data from onboard
         * @summary Callback url to receive user kyc document data
         * @param {string} id ID in query
         * @param {UserKycDocumentData} userKycDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveKycDocumentData: (id, userKycDocumentData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveKycDocumentData', 'id', id);
            // verify required parameter 'userKycDocumentData' is not null or undefined
            assertParamExists('retrieveKycDocumentData', 'userKycDocumentData', userKycDocumentData);
            const localVarPath = `/compliance/externals/kyc/onboard/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userKycDocumentData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of Hyper supported IDs for KYC
         * @summary List of Supported IDs for KYC
         * @param {string} countryCode Country code defined in path
         * @param {boolean} [isBiometric] Indicates if it should return document Ids for biometric verification
         * @param {boolean} [isInternal] Indicates whether the response should return id types from hyper internal kyc or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportedIds: (countryCode, isBiometric, isInternal, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('supportedIds', 'countryCode', countryCode);
            const localVarPath = `/compliance/supported-document-id-types/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isBiometric !== undefined) {
                localVarQueryParameter['isBiometric'] = isBiometric;
            }
            if (isInternal !== undefined) {
                localVarQueryParameter['isInternal'] = isInternal;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update kyc details (legal full-name & date-of-birth)
         * @summary Update kyc details
         * @param {UpdateKycDetailstDto} [updateKycDetailstDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKycDetails: (updateKycDetailstDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/compliance/me/kyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateKycDetailstDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ComplianceKycsClient - functional programming interface
 * @export
 */
export const ComplianceKycsClientFp = function (configuration) {
    const localVarAxiosParamCreator = ComplianceKycsClientAxiosParamCreator(configuration);
    return {
        /**
         * Abort ongoing kyc session
         * @summary Abort KYC
         * @param {AbortKycRequest} [abortKycRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMyKyc(abortKycRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.abortMyKyc(abortKycRequest, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.abortMyKyc']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Create change email-address request via KYC
         * @summary Create change email-address request via KYC
         * @param {ChangeEmailRequestDto} [changeEmailRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChangeEmailRequestViaKyc(changeEmailRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createChangeEmailRequestViaKyc(changeEmailRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.createChangeEmailRequestViaKyc']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get list of Hyper supported Countries for KYC
         * @summary List of Supported countries for KYC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKycSupportedCountries(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getKycSupportedCountries(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.getKycSupportedCountries']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get KYC status
         * @summary Get KYC status
         * @param {boolean} [strict] Indicates if KYC status will only be checked locally or also with the external source. When &#x60;strict&#x60; is false, check is scoped for local, else both local &amp; external source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyKycStatus(strict, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyKycStatus(strict, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.getMyKycStatus']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve the KYC verification, age verification, and location restriction status for a user
         * @summary Get user verification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVerificationStatus(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserVerificationStatus(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.getUserVerificationStatus']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initiate KYC (using external app - Onboard)
         * @summary Initiate KYC
         * @param {string} [country] User country
         * @param {InitiateKycRequestDto} [initiateKycRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateKyc(country, initiateKycRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiateKyc(country, initiateKycRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.initiateKyc']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Check if KYC is required (using a system defined threshold & communication with user-service KYC)
         * @summary Check if KYC is required
         * @param {RequiresKycRequestDto} [requiresKycRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requiresKyc(requiresKycRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requiresKyc(requiresKycRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.requiresKyc']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Callback url to receive user kyc document data from onboard
         * @summary Callback url to receive user kyc document data
         * @param {string} id ID in query
         * @param {UserKycDocumentData} userKycDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveKycDocumentData(id, userKycDocumentData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveKycDocumentData(id, userKycDocumentData, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.retrieveKycDocumentData']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get list of Hyper supported IDs for KYC
         * @summary List of Supported IDs for KYC
         * @param {string} countryCode Country code defined in path
         * @param {boolean} [isBiometric] Indicates if it should return document Ids for biometric verification
         * @param {boolean} [isInternal] Indicates whether the response should return id types from hyper internal kyc or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportedIds(countryCode, isBiometric, isInternal, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.supportedIds(countryCode, isBiometric, isInternal, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.supportedIds']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Update kyc details (legal full-name & date-of-birth)
         * @summary Update kyc details
         * @param {UpdateKycDetailstDto} [updateKycDetailstDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKycDetails(updateKycDetailstDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateKycDetails(updateKycDetailstDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ComplianceKycsClient.updateKycDetails']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ComplianceKycsClient - factory interface
 * @export
 */
export const ComplianceKycsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ComplianceKycsClientFp(configuration);
    return {
        /**
         * Abort ongoing kyc session
         * @summary Abort KYC
         * @param {AbortKycRequest} [abortKycRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortMyKyc(abortKycRequest, options) {
            return localVarFp.abortMyKyc(abortKycRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create change email-address request via KYC
         * @summary Create change email-address request via KYC
         * @param {ChangeEmailRequestDto} [changeEmailRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChangeEmailRequestViaKyc(changeEmailRequestDto, options) {
            return localVarFp.createChangeEmailRequestViaKyc(changeEmailRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of Hyper supported Countries for KYC
         * @summary List of Supported countries for KYC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKycSupportedCountries(options) {
            return localVarFp.getKycSupportedCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * Get KYC status
         * @summary Get KYC status
         * @param {boolean} [strict] Indicates if KYC status will only be checked locally or also with the external source. When &#x60;strict&#x60; is false, check is scoped for local, else both local &amp; external source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyKycStatus(strict, options) {
            return localVarFp.getMyKycStatus(strict, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the KYC verification, age verification, and location restriction status for a user
         * @summary Get user verification status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVerificationStatus(options) {
            return localVarFp.getUserVerificationStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate KYC (using external app - Onboard)
         * @summary Initiate KYC
         * @param {string} [country] User country
         * @param {InitiateKycRequestDto} [initiateKycRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateKyc(country, initiateKycRequestDto, options) {
            return localVarFp.initiateKyc(country, initiateKycRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if KYC is required (using a system defined threshold & communication with user-service KYC)
         * @summary Check if KYC is required
         * @param {RequiresKycRequestDto} [requiresKycRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requiresKyc(requiresKycRequestDto, options) {
            return localVarFp.requiresKyc(requiresKycRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Callback url to receive user kyc document data from onboard
         * @summary Callback url to receive user kyc document data
         * @param {string} id ID in query
         * @param {UserKycDocumentData} userKycDocumentData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveKycDocumentData(id, userKycDocumentData, options) {
            return localVarFp.retrieveKycDocumentData(id, userKycDocumentData, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of Hyper supported IDs for KYC
         * @summary List of Supported IDs for KYC
         * @param {string} countryCode Country code defined in path
         * @param {boolean} [isBiometric] Indicates if it should return document Ids for biometric verification
         * @param {boolean} [isInternal] Indicates whether the response should return id types from hyper internal kyc or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportedIds(countryCode, isBiometric, isInternal, options) {
            return localVarFp.supportedIds(countryCode, isBiometric, isInternal, options).then((request) => request(axios, basePath));
        },
        /**
         * Update kyc details (legal full-name & date-of-birth)
         * @summary Update kyc details
         * @param {UpdateKycDetailstDto} [updateKycDetailstDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKycDetails(updateKycDetailstDto, options) {
            return localVarFp.updateKycDetails(updateKycDetailstDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ComplianceKycsClient - object-oriented interface
 * @export
 * @class ComplianceKycsClient
 * @extends {BaseAPI}
 */
export class ComplianceKycsClient extends BaseAPI {
    /**
     * Abort ongoing kyc session
     * @summary Abort KYC
     * @param {AbortKycRequest} [abortKycRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    abortMyKyc(abortKycRequest, options) {
        return ComplianceKycsClientFp(this.configuration).abortMyKyc(abortKycRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create change email-address request via KYC
     * @summary Create change email-address request via KYC
     * @param {ChangeEmailRequestDto} [changeEmailRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    createChangeEmailRequestViaKyc(changeEmailRequestDto, options) {
        return ComplianceKycsClientFp(this.configuration).createChangeEmailRequestViaKyc(changeEmailRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of Hyper supported Countries for KYC
     * @summary List of Supported countries for KYC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    getKycSupportedCountries(options) {
        return ComplianceKycsClientFp(this.configuration).getKycSupportedCountries(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get KYC status
     * @summary Get KYC status
     * @param {boolean} [strict] Indicates if KYC status will only be checked locally or also with the external source. When &#x60;strict&#x60; is false, check is scoped for local, else both local &amp; external source.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    getMyKycStatus(strict, options) {
        return ComplianceKycsClientFp(this.configuration).getMyKycStatus(strict, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve the KYC verification, age verification, and location restriction status for a user
     * @summary Get user verification status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    getUserVerificationStatus(options) {
        return ComplianceKycsClientFp(this.configuration).getUserVerificationStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate KYC (using external app - Onboard)
     * @summary Initiate KYC
     * @param {string} [country] User country
     * @param {InitiateKycRequestDto} [initiateKycRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    initiateKyc(country, initiateKycRequestDto, options) {
        return ComplianceKycsClientFp(this.configuration).initiateKyc(country, initiateKycRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Check if KYC is required (using a system defined threshold & communication with user-service KYC)
     * @summary Check if KYC is required
     * @param {RequiresKycRequestDto} [requiresKycRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    requiresKyc(requiresKycRequestDto, options) {
        return ComplianceKycsClientFp(this.configuration).requiresKyc(requiresKycRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Callback url to receive user kyc document data from onboard
     * @summary Callback url to receive user kyc document data
     * @param {string} id ID in query
     * @param {UserKycDocumentData} userKycDocumentData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    retrieveKycDocumentData(id, userKycDocumentData, options) {
        return ComplianceKycsClientFp(this.configuration).retrieveKycDocumentData(id, userKycDocumentData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of Hyper supported IDs for KYC
     * @summary List of Supported IDs for KYC
     * @param {string} countryCode Country code defined in path
     * @param {boolean} [isBiometric] Indicates if it should return document Ids for biometric verification
     * @param {boolean} [isInternal] Indicates whether the response should return id types from hyper internal kyc or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    supportedIds(countryCode, isBiometric, isInternal, options) {
        return ComplianceKycsClientFp(this.configuration).supportedIds(countryCode, isBiometric, isInternal, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update kyc details (legal full-name & date-of-birth)
     * @summary Update kyc details
     * @param {UpdateKycDetailstDto} [updateKycDetailstDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceKycsClient
     */
    updateKycDetails(updateKycDetailstDto, options) {
        return ComplianceKycsClientFp(this.configuration).updateKycDetails(updateKycDetailstDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationsSocialsClient - axios parameter creator
 * @export
 */
export const ConfigurationsSocialsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a social link by Country code
         * @summary Get social link by Country code
         * @param {string} countryCode Country code defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialLinkByCountry: (countryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getSocialLinkByCountry', 'countryCode', countryCode);
            const localVarPath = `/configurations/social-links/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationsSocialsClient - functional programming interface
 * @export
 */
export const ConfigurationsSocialsClientFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationsSocialsClientAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a social link by Country code
         * @summary Get social link by Country code
         * @param {string} countryCode Country code defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialLinkByCountry(countryCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSocialLinkByCountry(countryCode, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ConfigurationsSocialsClient.getSocialLinkByCountry']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ConfigurationsSocialsClient - factory interface
 * @export
 */
export const ConfigurationsSocialsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationsSocialsClientFp(configuration);
    return {
        /**
         * Retrieve a social link by Country code
         * @summary Get social link by Country code
         * @param {string} countryCode Country code defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialLinkByCountry(countryCode, options) {
            return localVarFp.getSocialLinkByCountry(countryCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationsSocialsClient - object-oriented interface
 * @export
 * @class ConfigurationsSocialsClient
 * @extends {BaseAPI}
 */
export class ConfigurationsSocialsClient extends BaseAPI {
    /**
     * Retrieve a social link by Country code
     * @summary Get social link by Country code
     * @param {string} countryCode Country code defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsSocialsClient
     */
    getSocialLinkByCountry(countryCode, options) {
        return ConfigurationsSocialsClientFp(this.configuration).getSocialLinkByCountry(countryCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationsSupportedCountriesClient - axios parameter creator
 * @export
 */
export const ConfigurationsSupportedCountriesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get Country List
         * @summary Get Country List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configurations/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get Country By Code
         * @summary Get Country By Code
         * @param {string} countryCode Country code defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryByCode: (countryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getCountryByCode', 'countryCode', countryCode);
            const localVarPath = `/configurations/countries/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationsSupportedCountriesClient - functional programming interface
 * @export
 */
export const ConfigurationsSupportedCountriesClientFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationsSupportedCountriesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get Country List
         * @summary Get Country List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCountries(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ConfigurationsSupportedCountriesClient.getCountries']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get Country By Code
         * @summary Get Country By Code
         * @param {string} countryCode Country code defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryByCode(countryCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCountryByCode(countryCode, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ConfigurationsSupportedCountriesClient.getCountryByCode']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ConfigurationsSupportedCountriesClient - factory interface
 * @export
 */
export const ConfigurationsSupportedCountriesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationsSupportedCountriesClientFp(configuration);
    return {
        /**
         * Get Country List
         * @summary Get Country List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options) {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * Get Country By Code
         * @summary Get Country By Code
         * @param {string} countryCode Country code defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryByCode(countryCode, options) {
            return localVarFp.getCountryByCode(countryCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationsSupportedCountriesClient - object-oriented interface
 * @export
 * @class ConfigurationsSupportedCountriesClient
 * @extends {BaseAPI}
 */
export class ConfigurationsSupportedCountriesClient extends BaseAPI {
    /**
     * Get Country List
     * @summary Get Country List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsSupportedCountriesClient
     */
    getCountries(options) {
        return ConfigurationsSupportedCountriesClientFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get Country By Code
     * @summary Get Country By Code
     * @param {string} countryCode Country code defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsSupportedCountriesClient
     */
    getCountryByCode(countryCode, options) {
        return ConfigurationsSupportedCountriesClientFp(this.configuration).getCountryByCode(countryCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationsSupportedCurrenciesClient - axios parameter creator
 * @export
 */
export const ConfigurationsSupportedCurrenciesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get Currency List
         * @summary Get Currency List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configurations/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationsSupportedCurrenciesClient - functional programming interface
 * @export
 */
export const ConfigurationsSupportedCurrenciesClientFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationsSupportedCurrenciesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get Currency List
         * @summary Get Currency List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrencies(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ConfigurationsSupportedCurrenciesClient.getCurrencies']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ConfigurationsSupportedCurrenciesClient - factory interface
 * @export
 */
export const ConfigurationsSupportedCurrenciesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationsSupportedCurrenciesClientFp(configuration);
    return {
        /**
         * Get Currency List
         * @summary Get Currency List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(options) {
            return localVarFp.getCurrencies(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationsSupportedCurrenciesClient - object-oriented interface
 * @export
 * @class ConfigurationsSupportedCurrenciesClient
 * @extends {BaseAPI}
 */
export class ConfigurationsSupportedCurrenciesClient extends BaseAPI {
    /**
     * Get Currency List
     * @summary Get Currency List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsSupportedCurrenciesClient
     */
    getCurrencies(options) {
        return ConfigurationsSupportedCurrenciesClientFp(this.configuration).getCurrencies(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationsSupportedPhonesClient - axios parameter creator
 * @export
 */
export const ConfigurationsSupportedPhonesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a list of supported countries phone verification config.
         * @summary Supported countries configuration for phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneSupportedCountries: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configurations/phones/supported-countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationsSupportedPhonesClient - functional programming interface
 * @export
 */
export const ConfigurationsSupportedPhonesClientFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationsSupportedPhonesClientAxiosParamCreator(configuration);
    return {
        /**
         * Returns a list of supported countries phone verification config.
         * @summary Supported countries configuration for phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneSupportedCountries(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPhoneSupportedCountries(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ConfigurationsSupportedPhonesClient.getPhoneSupportedCountries']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ConfigurationsSupportedPhonesClient - factory interface
 * @export
 */
export const ConfigurationsSupportedPhonesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationsSupportedPhonesClientFp(configuration);
    return {
        /**
         * Returns a list of supported countries phone verification config.
         * @summary Supported countries configuration for phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPhoneSupportedCountries(options) {
            return localVarFp.getPhoneSupportedCountries(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationsSupportedPhonesClient - object-oriented interface
 * @export
 * @class ConfigurationsSupportedPhonesClient
 * @extends {BaseAPI}
 */
export class ConfigurationsSupportedPhonesClient extends BaseAPI {
    /**
     * Returns a list of supported countries phone verification config.
     * @summary Supported countries configuration for phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsSupportedPhonesClient
     */
    getPhoneSupportedCountries(options) {
        return ConfigurationsSupportedPhonesClientFp(this.configuration).getPhoneSupportedCountries(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FilesFilesClient - axios parameter creator
 * @export
 */
export const FilesFilesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get Uploaded Files Info
         * @summary Get Files Info
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {FileType} [type] Indicates the file-type to filter with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesInfo: (page, limit, sort, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FilesFilesClient - functional programming interface
 * @export
 */
export const FilesFilesClientFp = function (configuration) {
    const localVarAxiosParamCreator = FilesFilesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get Uploaded Files Info
         * @summary Get Files Info
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {FileType} [type] Indicates the file-type to filter with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesInfo(page, limit, sort, type, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFilesInfo(page, limit, sort, type, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['FilesFilesClient.getFilesInfo']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * FilesFilesClient - factory interface
 * @export
 */
export const FilesFilesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = FilesFilesClientFp(configuration);
    return {
        /**
         * Get Uploaded Files Info
         * @summary Get Files Info
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {FileType} [type] Indicates the file-type to filter with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilesInfo(page, limit, sort, type, options) {
            return localVarFp.getFilesInfo(page, limit, sort, type, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FilesFilesClient - object-oriented interface
 * @export
 * @class FilesFilesClient
 * @extends {BaseAPI}
 */
export class FilesFilesClient extends BaseAPI {
    /**
     * Get Uploaded Files Info
     * @summary Get Files Info
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {FileType} [type] Indicates the file-type to filter with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesFilesClient
     */
    getFilesInfo(page, limit, sort, type, options) {
        return FilesFilesClientFp(this.configuration).getFilesInfo(page, limit, sort, type, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GameplayLogsLogsClient - axios parameter creator
 * @export
 */
export const GameplayLogsLogsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Log gameplay event for authenticated and unauthenticated user
         * @summary Log Event
         * @param {string} entryId Game id defined in path
         * @param {GameplayLogRequest} [gameplayLogRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent: (entryId, gameplayLogRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('logEvent', 'entryId', entryId);
            const localVarPath = `/gameplay-logs/me/entries/{entryId}/events`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(gameplayLogRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GameplayLogsLogsClient - functional programming interface
 * @export
 */
export const GameplayLogsLogsClientFp = function (configuration) {
    const localVarAxiosParamCreator = GameplayLogsLogsClientAxiosParamCreator(configuration);
    return {
        /**
         * Log gameplay event for authenticated and unauthenticated user
         * @summary Log Event
         * @param {string} entryId Game id defined in path
         * @param {GameplayLogRequest} [gameplayLogRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent(entryId, gameplayLogRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logEvent(entryId, gameplayLogRequest, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GameplayLogsLogsClient.logEvent']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * GameplayLogsLogsClient - factory interface
 * @export
 */
export const GameplayLogsLogsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = GameplayLogsLogsClientFp(configuration);
    return {
        /**
         * Log gameplay event for authenticated and unauthenticated user
         * @summary Log Event
         * @param {string} entryId Game id defined in path
         * @param {GameplayLogRequest} [gameplayLogRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent(entryId, gameplayLogRequest, options) {
            return localVarFp.logEvent(entryId, gameplayLogRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GameplayLogsLogsClient - object-oriented interface
 * @export
 * @class GameplayLogsLogsClient
 * @extends {BaseAPI}
 */
export class GameplayLogsLogsClient extends BaseAPI {
    /**
     * Log gameplay event for authenticated and unauthenticated user
     * @summary Log Event
     * @param {string} entryId Game id defined in path
     * @param {GameplayLogRequest} [gameplayLogRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameplayLogsLogsClient
     */
    logEvent(entryId, gameplayLogRequest, options) {
        return GameplayLogsLogsClientFp(this.configuration).logEvent(entryId, gameplayLogRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GamesCategoriesClient - axios parameter creator
 * @export
 */
export const GamesCategoriesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a list of all game categories
         * @summary Get all game categories
         * @param {boolean} [all] Indicates if all items should be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameCategories: (all, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/games/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GamesCategoriesClient - functional programming interface
 * @export
 */
export const GamesCategoriesClientFp = function (configuration) {
    const localVarAxiosParamCreator = GamesCategoriesClientAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a list of all game categories
         * @summary Get all game categories
         * @param {boolean} [all] Indicates if all items should be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameCategories(all, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGameCategories(all, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesCategoriesClient.getGameCategories']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * GamesCategoriesClient - factory interface
 * @export
 */
export const GamesCategoriesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = GamesCategoriesClientFp(configuration);
    return {
        /**
         * Retrieve a list of all game categories
         * @summary Get all game categories
         * @param {boolean} [all] Indicates if all items should be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameCategories(all, options) {
            return localVarFp.getGameCategories(all, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GamesCategoriesClient - object-oriented interface
 * @export
 * @class GamesCategoriesClient
 * @extends {BaseAPI}
 */
export class GamesCategoriesClient extends BaseAPI {
    /**
     * Retrieve a list of all game categories
     * @summary Get all game categories
     * @param {boolean} [all] Indicates if all items should be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesCategoriesClient
     */
    getGameCategories(all, options) {
        return GamesCategoriesClientFp(this.configuration).getGameCategories(all, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GamesFavoritesClient - axios parameter creator
 * @export
 */
export const GamesFavoritesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get the list of favorite games for a user
         * @summary Get user\'s favorite games
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFavoriteGames: (limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/games/me/games/favorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create or update favorite status of a game for a user
         * @summary Create or update favorite game status
         * @param {string} gameId Game id defined in path
         * @param {FavoriteOptionsData} favoriteOptionsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFavoriteGame: (gameId, favoriteOptionsData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('upsertFavoriteGame', 'gameId', gameId);
            // verify required parameter 'favoriteOptionsData' is not null or undefined
            assertParamExists('upsertFavoriteGame', 'favoriteOptionsData', favoriteOptionsData);
            const localVarPath = `/games/me/games/{gameId}/favorite`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(favoriteOptionsData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GamesFavoritesClient - functional programming interface
 * @export
 */
export const GamesFavoritesClientFp = function (configuration) {
    const localVarAxiosParamCreator = GamesFavoritesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get the list of favorite games for a user
         * @summary Get user\'s favorite games
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFavoriteGames(limit, page, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserFavoriteGames(limit, page, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesFavoritesClient.getUserFavoriteGames']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Create or update favorite status of a game for a user
         * @summary Create or update favorite game status
         * @param {string} gameId Game id defined in path
         * @param {FavoriteOptionsData} favoriteOptionsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFavoriteGame(gameId, favoriteOptionsData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertFavoriteGame(gameId, favoriteOptionsData, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesFavoritesClient.upsertFavoriteGame']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * GamesFavoritesClient - factory interface
 * @export
 */
export const GamesFavoritesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = GamesFavoritesClientFp(configuration);
    return {
        /**
         * Get the list of favorite games for a user
         * @summary Get user\'s favorite games
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFavoriteGames(limit, page, options) {
            return localVarFp.getUserFavoriteGames(limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update favorite status of a game for a user
         * @summary Create or update favorite game status
         * @param {string} gameId Game id defined in path
         * @param {FavoriteOptionsData} favoriteOptionsData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertFavoriteGame(gameId, favoriteOptionsData, options) {
            return localVarFp.upsertFavoriteGame(gameId, favoriteOptionsData, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GamesFavoritesClient - object-oriented interface
 * @export
 * @class GamesFavoritesClient
 * @extends {BaseAPI}
 */
export class GamesFavoritesClient extends BaseAPI {
    /**
     * Get the list of favorite games for a user
     * @summary Get user\'s favorite games
     * @param {number} [limit] Number of items to be gotten per page
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesFavoritesClient
     */
    getUserFavoriteGames(limit, page, options) {
        return GamesFavoritesClientFp(this.configuration).getUserFavoriteGames(limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create or update favorite status of a game for a user
     * @summary Create or update favorite game status
     * @param {string} gameId Game id defined in path
     * @param {FavoriteOptionsData} favoriteOptionsData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesFavoritesClient
     */
    upsertFavoriteGame(gameId, favoriteOptionsData, options) {
        return GamesFavoritesClientFp(this.configuration).upsertFavoriteGame(gameId, favoriteOptionsData, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GamesGamesClient - axios parameter creator
 * @export
 */
export const GamesGamesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all games on the platform
         * @summary Get games
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {GameProvider} [provider] Query to specify that only games of a specific provider should be returned
         * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
         * @param {string} [category] Query to specify that only games of a specific category should be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGames: (page, limit, sort, provider, status, category, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/games`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get popular games
         * @summary Get popular games based on tournaments
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPopularGames: (limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/games/popular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get challenge invitation default game (to be used while creating a challenge-invitation)
         * @summary Get challenge invitation default game
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeInvitationDefaultGame: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/games/challenge-invitation/default-game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get game detail
         * @summary Get game detail
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameDetail: (gameId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('getGameDetail', 'gameId', gameId);
            const localVarPath = `/games/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get game detail by slug
         * @summary Get game detail by slug
         * @param {string} slug Game slug defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameDetailBySlug: (slug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getGameDetailBySlug', 'slug', slug);
            const localVarPath = `/games/slug/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get top games for current user based on user gameplay history
         * @summary Get top games
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopGames: (limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/games/me/top-games`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GamesGamesClient - functional programming interface
 * @export
 */
export const GamesGamesClientFp = function (configuration) {
    const localVarAxiosParamCreator = GamesGamesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get all games on the platform
         * @summary Get games
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {GameProvider} [provider] Query to specify that only games of a specific provider should be returned
         * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
         * @param {string} [category] Query to specify that only games of a specific category should be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGames(page, limit, sort, provider, status, category, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllGames(page, limit, sort, provider, status, category, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesGamesClient.getAllGames']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get popular games
         * @summary Get popular games based on tournaments
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPopularGames(limit, page, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllPopularGames(limit, page, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesGamesClient.getAllPopularGames']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get challenge invitation default game (to be used while creating a challenge-invitation)
         * @summary Get challenge invitation default game
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeInvitationDefaultGame(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChallengeInvitationDefaultGame(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesGamesClient.getChallengeInvitationDefaultGame']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get game detail
         * @summary Get game detail
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameDetail(gameId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGameDetail(gameId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesGamesClient.getGameDetail']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get game detail by slug
         * @summary Get game detail by slug
         * @param {string} slug Game slug defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameDetailBySlug(slug, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGameDetailBySlug(slug, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesGamesClient.getGameDetailBySlug']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get top games for current user based on user gameplay history
         * @summary Get top games
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopGames(limit, page, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyTopGames(limit, page, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesGamesClient.getMyTopGames']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * GamesGamesClient - factory interface
 * @export
 */
export const GamesGamesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = GamesGamesClientFp(configuration);
    return {
        /**
         * Get all games on the platform
         * @summary Get games
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {GameProvider} [provider] Query to specify that only games of a specific provider should be returned
         * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
         * @param {string} [category] Query to specify that only games of a specific category should be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllGames(page, limit, sort, provider, status, category, options) {
            return localVarFp.getAllGames(page, limit, sort, provider, status, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Get popular games
         * @summary Get popular games based on tournaments
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPopularGames(limit, page, options) {
            return localVarFp.getAllPopularGames(limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Get challenge invitation default game (to be used while creating a challenge-invitation)
         * @summary Get challenge invitation default game
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeInvitationDefaultGame(options) {
            return localVarFp.getChallengeInvitationDefaultGame(options).then((request) => request(axios, basePath));
        },
        /**
         * Get game detail
         * @summary Get game detail
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameDetail(gameId, options) {
            return localVarFp.getGameDetail(gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get game detail by slug
         * @summary Get game detail by slug
         * @param {string} slug Game slug defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameDetailBySlug(slug, options) {
            return localVarFp.getGameDetailBySlug(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Get top games for current user based on user gameplay history
         * @summary Get top games
         * @param {number} [limit] Number of items to be gotten per page
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopGames(limit, page, options) {
            return localVarFp.getMyTopGames(limit, page, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GamesGamesClient - object-oriented interface
 * @export
 * @class GamesGamesClient
 * @extends {BaseAPI}
 */
export class GamesGamesClient extends BaseAPI {
    /**
     * Get all games on the platform
     * @summary Get games
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {GameProvider} [provider] Query to specify that only games of a specific provider should be returned
     * @param {GameStatus} [status] Query to specify that only games of a specific status should be returned
     * @param {string} [category] Query to specify that only games of a specific category should be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesGamesClient
     */
    getAllGames(page, limit, sort, provider, status, category, options) {
        return GamesGamesClientFp(this.configuration).getAllGames(page, limit, sort, provider, status, category, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get popular games
     * @summary Get popular games based on tournaments
     * @param {number} [limit] Number of items to be gotten per page
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesGamesClient
     */
    getAllPopularGames(limit, page, options) {
        return GamesGamesClientFp(this.configuration).getAllPopularGames(limit, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get challenge invitation default game (to be used while creating a challenge-invitation)
     * @summary Get challenge invitation default game
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesGamesClient
     */
    getChallengeInvitationDefaultGame(options) {
        return GamesGamesClientFp(this.configuration).getChallengeInvitationDefaultGame(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get game detail
     * @summary Get game detail
     * @param {string} gameId Game id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesGamesClient
     */
    getGameDetail(gameId, options) {
        return GamesGamesClientFp(this.configuration).getGameDetail(gameId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get game detail by slug
     * @summary Get game detail by slug
     * @param {string} slug Game slug defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesGamesClient
     */
    getGameDetailBySlug(slug, options) {
        return GamesGamesClientFp(this.configuration).getGameDetailBySlug(slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get top games for current user based on user gameplay history
     * @summary Get top games
     * @param {number} [limit] Number of items to be gotten per page
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesGamesClient
     */
    getMyTopGames(limit, page, options) {
        return GamesGamesClientFp(this.configuration).getMyTopGames(limit, page, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GamesSharesClient - axios parameter creator
 * @export
 */
export const GamesSharesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a unique URL to share a game
         * @summary Create a game sharing link
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGameShareLink: (gameId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('createGameShareLink', 'gameId', gameId);
            const localVarPath = `/games/me/games/{gameId}/share`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Information about a game share link
         * @summary Game share link detail
         * @param {string} gameShareId Game Share Id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedGameDetail: (gameShareId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gameShareId' is not null or undefined
            assertParamExists('getSharedGameDetail', 'gameShareId', gameShareId);
            const localVarPath = `/games/share/{gameShareId}`
                .replace(`{${"gameShareId"}}`, encodeURIComponent(String(gameShareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GamesSharesClient - functional programming interface
 * @export
 */
export const GamesSharesClientFp = function (configuration) {
    const localVarAxiosParamCreator = GamesSharesClientAxiosParamCreator(configuration);
    return {
        /**
         * Create a unique URL to share a game
         * @summary Create a game sharing link
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGameShareLink(gameId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGameShareLink(gameId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesSharesClient.createGameShareLink']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Information about a game share link
         * @summary Game share link detail
         * @param {string} gameShareId Game Share Id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedGameDetail(gameShareId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSharedGameDetail(gameShareId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['GamesSharesClient.getSharedGameDetail']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * GamesSharesClient - factory interface
 * @export
 */
export const GamesSharesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = GamesSharesClientFp(configuration);
    return {
        /**
         * Create a unique URL to share a game
         * @summary Create a game sharing link
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGameShareLink(gameId, options) {
            return localVarFp.createGameShareLink(gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * Information about a game share link
         * @summary Game share link detail
         * @param {string} gameShareId Game Share Id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedGameDetail(gameShareId, options) {
            return localVarFp.getSharedGameDetail(gameShareId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GamesSharesClient - object-oriented interface
 * @export
 * @class GamesSharesClient
 * @extends {BaseAPI}
 */
export class GamesSharesClient extends BaseAPI {
    /**
     * Create a unique URL to share a game
     * @summary Create a game sharing link
     * @param {string} gameId Game id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesSharesClient
     */
    createGameShareLink(gameId, options) {
        return GamesSharesClientFp(this.configuration).createGameShareLink(gameId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Information about a game share link
     * @summary Game share link detail
     * @param {string} gameShareId Game Share Id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GamesSharesClient
     */
    getSharedGameDetail(gameShareId, options) {
        return GamesSharesClientFp(this.configuration).getSharedGameDetail(gameShareId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReferrersReferralsClient - axios parameter creator
 * @export
 */
export const ReferrersReferralsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Generate referral link to share with friends. It gets created if no previous referral link can be found for the user.
         * @summary Get my referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyReferralLink: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/referrers/me/referral/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all current users referrals
         * @summary Get referrals
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {boolean} [vested] Check for whether referrals have been vested or not
         * @param {boolean} [rewarded] Check for whether referrals have been rewarded or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRefferals: (page, limit, startDate, endDate, vested, rewarded, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/referrers/me/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            if (vested !== undefined) {
                localVarQueryParameter['vested'] = vested;
            }
            if (rewarded !== undefined) {
                localVarQueryParameter['rewarded'] = rewarded;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all current users total reward
         * @summary Get rewards
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRewards: (startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/referrers/me/rewards/total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get brief information of a specified referrer
         * @summary Get referrer info
         * @param {string} referrerId Referrer identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerInfo: (referrerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'referrerId' is not null or undefined
            assertParamExists('getReferrerInfo', 'referrerId', referrerId);
            const localVarPath = `/referrers/referrals/referrers/{referrerId}`
                .replace(`{${"referrerId"}}`, encodeURIComponent(String(referrerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all rewards
         * @summary Get total rewards
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRewards: (startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/referrers/rewards/total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate a referral
         * @summary Initiate a referral
         * @param {CreateReferralDto} [createReferralDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateReferral: (createReferralDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/referrers/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createReferralDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReferrersReferralsClient - functional programming interface
 * @export
 */
export const ReferrersReferralsClientFp = function (configuration) {
    const localVarAxiosParamCreator = ReferrersReferralsClientAxiosParamCreator(configuration);
    return {
        /**
         * Generate referral link to share with friends. It gets created if no previous referral link can be found for the user.
         * @summary Get my referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyReferralLink(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyReferralLink(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReferrersReferralsClient.getMyReferralLink']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all current users referrals
         * @summary Get referrals
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {boolean} [vested] Check for whether referrals have been vested or not
         * @param {boolean} [rewarded] Check for whether referrals have been rewarded or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRefferals(page, limit, startDate, endDate, vested, rewarded, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyRefferals(page, limit, startDate, endDate, vested, rewarded, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReferrersReferralsClient.getMyRefferals']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all current users total reward
         * @summary Get rewards
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRewards(startDate, endDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyRewards(startDate, endDate, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReferrersReferralsClient.getMyRewards']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get brief information of a specified referrer
         * @summary Get referrer info
         * @param {string} referrerId Referrer identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerInfo(referrerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getReferrerInfo(referrerId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReferrersReferralsClient.getReferrerInfo']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all rewards
         * @summary Get total rewards
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRewards(startDate, endDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTotalRewards(startDate, endDate, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReferrersReferralsClient.getTotalRewards']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initiate a referral
         * @summary Initiate a referral
         * @param {CreateReferralDto} [createReferralDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateReferral(createReferralDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiateReferral(createReferralDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ReferrersReferralsClient.initiateReferral']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ReferrersReferralsClient - factory interface
 * @export
 */
export const ReferrersReferralsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = ReferrersReferralsClientFp(configuration);
    return {
        /**
         * Generate referral link to share with friends. It gets created if no previous referral link can be found for the user.
         * @summary Get my referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyReferralLink(options) {
            return localVarFp.getMyReferralLink(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all current users referrals
         * @summary Get referrals
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {boolean} [vested] Check for whether referrals have been vested or not
         * @param {boolean} [rewarded] Check for whether referrals have been rewarded or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRefferals(page, limit, startDate, endDate, vested, rewarded, options) {
            return localVarFp.getMyRefferals(page, limit, startDate, endDate, vested, rewarded, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all current users total reward
         * @summary Get rewards
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRewards(startDate, endDate, options) {
            return localVarFp.getMyRewards(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brief information of a specified referrer
         * @summary Get referrer info
         * @param {string} referrerId Referrer identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerInfo(referrerId, options) {
            return localVarFp.getReferrerInfo(referrerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all rewards
         * @summary Get total rewards
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRewards(startDate, endDate, options) {
            return localVarFp.getTotalRewards(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate a referral
         * @summary Initiate a referral
         * @param {CreateReferralDto} [createReferralDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateReferral(createReferralDto, options) {
            return localVarFp.initiateReferral(createReferralDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReferrersReferralsClient - object-oriented interface
 * @export
 * @class ReferrersReferralsClient
 * @extends {BaseAPI}
 */
export class ReferrersReferralsClient extends BaseAPI {
    /**
     * Generate referral link to share with friends. It gets created if no previous referral link can be found for the user.
     * @summary Get my referral link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrersReferralsClient
     */
    getMyReferralLink(options) {
        return ReferrersReferralsClientFp(this.configuration).getMyReferralLink(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all current users referrals
     * @summary Get referrals
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [startDate] Start date defined in query
     * @param {string} [endDate] End date defined in query
     * @param {boolean} [vested] Check for whether referrals have been vested or not
     * @param {boolean} [rewarded] Check for whether referrals have been rewarded or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrersReferralsClient
     */
    getMyRefferals(page, limit, startDate, endDate, vested, rewarded, options) {
        return ReferrersReferralsClientFp(this.configuration).getMyRefferals(page, limit, startDate, endDate, vested, rewarded, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all current users total reward
     * @summary Get rewards
     * @param {string} [startDate] Start date defined in query
     * @param {string} [endDate] End date defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrersReferralsClient
     */
    getMyRewards(startDate, endDate, options) {
        return ReferrersReferralsClientFp(this.configuration).getMyRewards(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get brief information of a specified referrer
     * @summary Get referrer info
     * @param {string} referrerId Referrer identifier in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrersReferralsClient
     */
    getReferrerInfo(referrerId, options) {
        return ReferrersReferralsClientFp(this.configuration).getReferrerInfo(referrerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all rewards
     * @summary Get total rewards
     * @param {string} [startDate] Start date defined in query
     * @param {string} [endDate] End date defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrersReferralsClient
     */
    getTotalRewards(startDate, endDate, options) {
        return ReferrersReferralsClientFp(this.configuration).getTotalRewards(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate a referral
     * @summary Initiate a referral
     * @param {CreateReferralDto} [createReferralDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrersReferralsClient
     */
    initiateReferral(createReferralDto, options) {
        return ReferrersReferralsClientFp(this.configuration).initiateReferral(createReferralDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SocialsChallengeInvitationsClient - axios parameter creator
 * @export
 */
export const SocialsChallengeInvitationsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new invitation for friends to challenge current user
         * @summary Create challenge invitation
         * @param {CreateChallengeInvitationDto} [createChallengeInvitationDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChallengeInvitation: (createChallengeInvitationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/socials/me/challenges/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createChallengeInvitationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deactivate a specific invitation, only available to the creator of the invitation,  When this endpoint is called, the expiresAt field is updated to the current timestamp regardless of it\'s previous value, This makes the invitation immediately expire.
         * @summary Deactivate Invitation
         * @param {string} inviteId Invite id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateInvitation: (inviteId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('deactivateInvitation', 'inviteId', inviteId);
            const localVarPath = `/socials/me/challenges/invites/{inviteId}`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get detail of a specific invitation by the inviteId, endpoint is available to all registered user
         * @summary Get Invitation
         * @param {string} inviteId Invite id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationDetail: (inviteId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('getInvitationDetail', 'inviteId', inviteId);
            const localVarPath = `/socials/challenges/invites/{inviteId}`
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all invitations created by current user
         * @summary List my invitations
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations: (page, limit, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/socials/me/challenges/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SocialsChallengeInvitationsClient - functional programming interface
 * @export
 */
export const SocialsChallengeInvitationsClientFp = function (configuration) {
    const localVarAxiosParamCreator = SocialsChallengeInvitationsClientAxiosParamCreator(configuration);
    return {
        /**
         * Create a new invitation for friends to challenge current user
         * @summary Create challenge invitation
         * @param {CreateChallengeInvitationDto} [createChallengeInvitationDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChallengeInvitation(createChallengeInvitationDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createChallengeInvitation(createChallengeInvitationDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengeInvitationsClient.createChallengeInvitation']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Deactivate a specific invitation, only available to the creator of the invitation,  When this endpoint is called, the expiresAt field is updated to the current timestamp regardless of it\'s previous value, This makes the invitation immediately expire.
         * @summary Deactivate Invitation
         * @param {string} inviteId Invite id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateInvitation(inviteId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deactivateInvitation(inviteId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengeInvitationsClient.deactivateInvitation']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get detail of a specific invitation by the inviteId, endpoint is available to all registered user
         * @summary Get Invitation
         * @param {string} inviteId Invite id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationDetail(inviteId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvitationDetail(inviteId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengeInvitationsClient.getInvitationDetail']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all invitations created by current user
         * @summary List my invitations
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations(page, limit, sort, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyInvitations(page, limit, sort, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengeInvitationsClient.getMyInvitations']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * SocialsChallengeInvitationsClient - factory interface
 * @export
 */
export const SocialsChallengeInvitationsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialsChallengeInvitationsClientFp(configuration);
    return {
        /**
         * Create a new invitation for friends to challenge current user
         * @summary Create challenge invitation
         * @param {CreateChallengeInvitationDto} [createChallengeInvitationDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChallengeInvitation(createChallengeInvitationDto, options) {
            return localVarFp.createChallengeInvitation(createChallengeInvitationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a specific invitation, only available to the creator of the invitation,  When this endpoint is called, the expiresAt field is updated to the current timestamp regardless of it\'s previous value, This makes the invitation immediately expire.
         * @summary Deactivate Invitation
         * @param {string} inviteId Invite id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateInvitation(inviteId, options) {
            return localVarFp.deactivateInvitation(inviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detail of a specific invitation by the inviteId, endpoint is available to all registered user
         * @summary Get Invitation
         * @param {string} inviteId Invite id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationDetail(inviteId, options) {
            return localVarFp.getInvitationDetail(inviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all invitations created by current user
         * @summary List my invitations
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations(page, limit, sort, options) {
            return localVarFp.getMyInvitations(page, limit, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialsChallengeInvitationsClient - object-oriented interface
 * @export
 * @class SocialsChallengeInvitationsClient
 * @extends {BaseAPI}
 */
export class SocialsChallengeInvitationsClient extends BaseAPI {
    /**
     * Create a new invitation for friends to challenge current user
     * @summary Create challenge invitation
     * @param {CreateChallengeInvitationDto} [createChallengeInvitationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengeInvitationsClient
     */
    createChallengeInvitation(createChallengeInvitationDto, options) {
        return SocialsChallengeInvitationsClientFp(this.configuration).createChallengeInvitation(createChallengeInvitationDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deactivate a specific invitation, only available to the creator of the invitation,  When this endpoint is called, the expiresAt field is updated to the current timestamp regardless of it\'s previous value, This makes the invitation immediately expire.
     * @summary Deactivate Invitation
     * @param {string} inviteId Invite id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengeInvitationsClient
     */
    deactivateInvitation(inviteId, options) {
        return SocialsChallengeInvitationsClientFp(this.configuration).deactivateInvitation(inviteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get detail of a specific invitation by the inviteId, endpoint is available to all registered user
     * @summary Get Invitation
     * @param {string} inviteId Invite id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengeInvitationsClient
     */
    getInvitationDetail(inviteId, options) {
        return SocialsChallengeInvitationsClientFp(this.configuration).getInvitationDetail(inviteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all invitations created by current user
     * @summary List my invitations
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengeInvitationsClient
     */
    getMyInvitations(page, limit, sort, options) {
        return SocialsChallengeInvitationsClientFp(this.configuration).getMyInvitations(page, limit, sort, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SocialsChallengesClient - axios parameter creator
 * @export
 */
export const SocialsChallengesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Accept a challenge upon request, This endpoint can ONLY be used by the inviter
         * @summary Accept a challenge
         * @param {string} challengeId Challenge id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptChallenge: (challengeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('acceptChallenge', 'challengeId', challengeId);
            const localVarPath = `/socials/me/challenges/{challengeId}`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get challenge reward-multiplier (reward-amount = stake-amount X multiplier)
         * @summary Get challenge reward-multiplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeRewardMultiplier: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/socials/challenge/reward-multiplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all current user challenges
         * @summary List my challenges
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {string} [inviteId] Invite id defined in query
         * @param {ChallengeStatus} [status] Challenge status defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyChallenges: (page, limit, sort, inviteId, status, gameId, tournamentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/socials/me/challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (inviteId !== undefined) {
                localVarQueryParameter['inviteId'] = inviteId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }
            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all challenges that requires current user action
         * @summary List my pending challenges
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {string} [inviteId] Invite id defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPendingChallenges: (page, limit, sort, inviteId, gameId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/socials/me/challenges/pendings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (inviteId !== undefined) {
                localVarQueryParameter['inviteId'] = inviteId;
            }
            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate a challenge upon invitation, This endpoint can not be used by the inviter
         * @summary Challenge a user with their inviteId
         * @param {InitiateChallengeDto} [initiateChallengeDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateChallenge: (initiateChallengeDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/socials/me/challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(initiateChallengeDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Reject a challenge upon request, This endpoint can ONLY be used by the inviter
         * @summary Reject Challenge
         * @param {string} challengeId Challenge id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectChallenge: (challengeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('rejectChallenge', 'challengeId', challengeId);
            const localVarPath = `/socials/me/challenges/{challengeId}`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SocialsChallengesClient - functional programming interface
 * @export
 */
export const SocialsChallengesClientFp = function (configuration) {
    const localVarAxiosParamCreator = SocialsChallengesClientAxiosParamCreator(configuration);
    return {
        /**
         * Accept a challenge upon request, This endpoint can ONLY be used by the inviter
         * @summary Accept a challenge
         * @param {string} challengeId Challenge id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptChallenge(challengeId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.acceptChallenge(challengeId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengesClient.acceptChallenge']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get challenge reward-multiplier (reward-amount = stake-amount X multiplier)
         * @summary Get challenge reward-multiplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeRewardMultiplier(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChallengeRewardMultiplier(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengesClient.getChallengeRewardMultiplier']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all current user challenges
         * @summary List my challenges
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {string} [inviteId] Invite id defined in query
         * @param {ChallengeStatus} [status] Challenge status defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyChallenges(page, limit, sort, inviteId, status, gameId, tournamentId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyChallenges(page, limit, sort, inviteId, status, gameId, tournamentId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengesClient.getMyChallenges']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all challenges that requires current user action
         * @summary List my pending challenges
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {string} [inviteId] Invite id defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPendingChallenges(page, limit, sort, inviteId, gameId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyPendingChallenges(page, limit, sort, inviteId, gameId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengesClient.getMyPendingChallenges']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initiate a challenge upon invitation, This endpoint can not be used by the inviter
         * @summary Challenge a user with their inviteId
         * @param {InitiateChallengeDto} [initiateChallengeDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateChallenge(initiateChallengeDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiateChallenge(initiateChallengeDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengesClient.initiateChallenge']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Reject a challenge upon request, This endpoint can ONLY be used by the inviter
         * @summary Reject Challenge
         * @param {string} challengeId Challenge id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectChallenge(challengeId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rejectChallenge(challengeId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SocialsChallengesClient.rejectChallenge']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * SocialsChallengesClient - factory interface
 * @export
 */
export const SocialsChallengesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = SocialsChallengesClientFp(configuration);
    return {
        /**
         * Accept a challenge upon request, This endpoint can ONLY be used by the inviter
         * @summary Accept a challenge
         * @param {string} challengeId Challenge id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptChallenge(challengeId, options) {
            return localVarFp.acceptChallenge(challengeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get challenge reward-multiplier (reward-amount = stake-amount X multiplier)
         * @summary Get challenge reward-multiplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeRewardMultiplier(options) {
            return localVarFp.getChallengeRewardMultiplier(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all current user challenges
         * @summary List my challenges
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {string} [inviteId] Invite id defined in query
         * @param {ChallengeStatus} [status] Challenge status defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyChallenges(page, limit, sort, inviteId, status, gameId, tournamentId, options) {
            return localVarFp.getMyChallenges(page, limit, sort, inviteId, status, gameId, tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all challenges that requires current user action
         * @summary List my pending challenges
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {string} [inviteId] Invite id defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPendingChallenges(page, limit, sort, inviteId, gameId, options) {
            return localVarFp.getMyPendingChallenges(page, limit, sort, inviteId, gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate a challenge upon invitation, This endpoint can not be used by the inviter
         * @summary Challenge a user with their inviteId
         * @param {InitiateChallengeDto} [initiateChallengeDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateChallenge(initiateChallengeDto, options) {
            return localVarFp.initiateChallenge(initiateChallengeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Reject a challenge upon request, This endpoint can ONLY be used by the inviter
         * @summary Reject Challenge
         * @param {string} challengeId Challenge id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectChallenge(challengeId, options) {
            return localVarFp.rejectChallenge(challengeId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SocialsChallengesClient - object-oriented interface
 * @export
 * @class SocialsChallengesClient
 * @extends {BaseAPI}
 */
export class SocialsChallengesClient extends BaseAPI {
    /**
     * Accept a challenge upon request, This endpoint can ONLY be used by the inviter
     * @summary Accept a challenge
     * @param {string} challengeId Challenge id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengesClient
     */
    acceptChallenge(challengeId, options) {
        return SocialsChallengesClientFp(this.configuration).acceptChallenge(challengeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get challenge reward-multiplier (reward-amount = stake-amount X multiplier)
     * @summary Get challenge reward-multiplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengesClient
     */
    getChallengeRewardMultiplier(options) {
        return SocialsChallengesClientFp(this.configuration).getChallengeRewardMultiplier(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all current user challenges
     * @summary List my challenges
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {string} [inviteId] Invite id defined in query
     * @param {ChallengeStatus} [status] Challenge status defined in query
     * @param {string} [gameId] Game id defined in query
     * @param {string} [tournamentId] Tournament id defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengesClient
     */
    getMyChallenges(page, limit, sort, inviteId, status, gameId, tournamentId, options) {
        return SocialsChallengesClientFp(this.configuration).getMyChallenges(page, limit, sort, inviteId, status, gameId, tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all challenges that requires current user action
     * @summary List my pending challenges
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {string} [inviteId] Invite id defined in query
     * @param {string} [gameId] Game id defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengesClient
     */
    getMyPendingChallenges(page, limit, sort, inviteId, gameId, options) {
        return SocialsChallengesClientFp(this.configuration).getMyPendingChallenges(page, limit, sort, inviteId, gameId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate a challenge upon invitation, This endpoint can not be used by the inviter
     * @summary Challenge a user with their inviteId
     * @param {InitiateChallengeDto} [initiateChallengeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengesClient
     */
    initiateChallenge(initiateChallengeDto, options) {
        return SocialsChallengesClientFp(this.configuration).initiateChallenge(initiateChallengeDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Reject a challenge upon request, This endpoint can ONLY be used by the inviter
     * @summary Reject Challenge
     * @param {string} challengeId Challenge id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialsChallengesClient
     */
    rejectChallenge(challengeId, options) {
        return SocialsChallengesClientFp(this.configuration).rejectChallenge(challengeId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TasksDefaultClient - axios parameter creator
 * @export
 */
export const TasksDefaultClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get My Quest (includes assigned tasks)
         * @summary Get My Quest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyQuest: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks/me/quests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Mark `SHARE-REFERRER-LINK` as done
         * @summary Mark `SHARE-REFERRER-LINK` as done
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markShareReferredLinkAsDone: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks/me/tasks/share-referrer-link/mark-as-done`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TasksDefaultClient - functional programming interface
 * @export
 */
export const TasksDefaultClientFp = function (configuration) {
    const localVarAxiosParamCreator = TasksDefaultClientAxiosParamCreator(configuration);
    return {
        /**
         * Get My Quest (includes assigned tasks)
         * @summary Get My Quest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyQuest(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyQuest(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TasksDefaultClient.getMyQuest']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Mark `SHARE-REFERRER-LINK` as done
         * @summary Mark `SHARE-REFERRER-LINK` as done
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markShareReferredLinkAsDone(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markShareReferredLinkAsDone(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TasksDefaultClient.markShareReferredLinkAsDone']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TasksDefaultClient - factory interface
 * @export
 */
export const TasksDefaultClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TasksDefaultClientFp(configuration);
    return {
        /**
         * Get My Quest (includes assigned tasks)
         * @summary Get My Quest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyQuest(options) {
            return localVarFp.getMyQuest(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark `SHARE-REFERRER-LINK` as done
         * @summary Mark `SHARE-REFERRER-LINK` as done
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markShareReferredLinkAsDone(options) {
            return localVarFp.markShareReferredLinkAsDone(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TasksDefaultClient - object-oriented interface
 * @export
 * @class TasksDefaultClient
 * @extends {BaseAPI}
 */
export class TasksDefaultClient extends BaseAPI {
    /**
     * Get My Quest (includes assigned tasks)
     * @summary Get My Quest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksDefaultClient
     */
    getMyQuest(options) {
        return TasksDefaultClientFp(this.configuration).getMyQuest(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Mark `SHARE-REFERRER-LINK` as done
     * @summary Mark `SHARE-REFERRER-LINK` as done
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksDefaultClient
     */
    markShareReferredLinkAsDone(options) {
        return TasksDefaultClientFp(this.configuration).markShareReferredLinkAsDone(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TasksStreaksClient - axios parameter creator
 * @export
 */
export const TasksStreaksClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get Streaks, endpoint is only available to hyper gamers
         * @summary Get Streaks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableStreaks: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks/streaks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get My Next Streak Milestone (based on current streak count)
         * @summary Get My Next Streak Milestone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNextStreakMilestone: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks/me/streaks/next-milestone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get My Streak Status
         * @summary Get My Streak Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyStreakStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tasks/me/streak/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TasksStreaksClient - functional programming interface
 * @export
 */
export const TasksStreaksClientFp = function (configuration) {
    const localVarAxiosParamCreator = TasksStreaksClientAxiosParamCreator(configuration);
    return {
        /**
         * Get Streaks, endpoint is only available to hyper gamers
         * @summary Get Streaks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableStreaks(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableStreaks(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TasksStreaksClient.getAvailableStreaks']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get My Next Streak Milestone (based on current streak count)
         * @summary Get My Next Streak Milestone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNextStreakMilestone(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyNextStreakMilestone(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TasksStreaksClient.getMyNextStreakMilestone']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get My Streak Status
         * @summary Get My Streak Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyStreakStatus(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyStreakStatus(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TasksStreaksClient.getMyStreakStatus']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TasksStreaksClient - factory interface
 * @export
 */
export const TasksStreaksClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TasksStreaksClientFp(configuration);
    return {
        /**
         * Get Streaks, endpoint is only available to hyper gamers
         * @summary Get Streaks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableStreaks(options) {
            return localVarFp.getAvailableStreaks(options).then((request) => request(axios, basePath));
        },
        /**
         * Get My Next Streak Milestone (based on current streak count)
         * @summary Get My Next Streak Milestone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyNextStreakMilestone(options) {
            return localVarFp.getMyNextStreakMilestone(options).then((request) => request(axios, basePath));
        },
        /**
         * Get My Streak Status
         * @summary Get My Streak Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyStreakStatus(options) {
            return localVarFp.getMyStreakStatus(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TasksStreaksClient - object-oriented interface
 * @export
 * @class TasksStreaksClient
 * @extends {BaseAPI}
 */
export class TasksStreaksClient extends BaseAPI {
    /**
     * Get Streaks, endpoint is only available to hyper gamers
     * @summary Get Streaks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksStreaksClient
     */
    getAvailableStreaks(options) {
        return TasksStreaksClientFp(this.configuration).getAvailableStreaks(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get My Next Streak Milestone (based on current streak count)
     * @summary Get My Next Streak Milestone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksStreaksClient
     */
    getMyNextStreakMilestone(options) {
        return TasksStreaksClientFp(this.configuration).getMyNextStreakMilestone(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get My Streak Status
     * @summary Get My Streak Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksStreaksClient
     */
    getMyStreakStatus(options) {
        return TasksStreaksClientFp(this.configuration).getMyStreakStatus(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentsDefaultsClient - axios parameter creator
 * @export
 */
export const TournamentsDefaultsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Play practice for authenticated and unauthenticated user
         * @summary Play practice game
         * @param {PlayPracticeGameDto} [playPracticeGameDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playPracticeGame: (playPracticeGameDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/practice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(playPracticeGameDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentsDefaultsClient - functional programming interface
 * @export
 */
export const TournamentsDefaultsClientFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentsDefaultsClientAxiosParamCreator(configuration);
    return {
        /**
         * Play practice for authenticated and unauthenticated user
         * @summary Play practice game
         * @param {PlayPracticeGameDto} [playPracticeGameDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playPracticeGame(playPracticeGameDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.playPracticeGame(playPracticeGameDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsDefaultsClient.playPracticeGame']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TournamentsDefaultsClient - factory interface
 * @export
 */
export const TournamentsDefaultsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentsDefaultsClientFp(configuration);
    return {
        /**
         * Play practice for authenticated and unauthenticated user
         * @summary Play practice game
         * @param {PlayPracticeGameDto} [playPracticeGameDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playPracticeGame(playPracticeGameDto, options) {
            return localVarFp.playPracticeGame(playPracticeGameDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentsDefaultsClient - object-oriented interface
 * @export
 * @class TournamentsDefaultsClient
 * @extends {BaseAPI}
 */
export class TournamentsDefaultsClient extends BaseAPI {
    /**
     * Play practice for authenticated and unauthenticated user
     * @summary Play practice game
     * @param {PlayPracticeGameDto} [playPracticeGameDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsDefaultsClient
     */
    playPracticeGame(playPracticeGameDto, options) {
        return TournamentsDefaultsClientFp(this.configuration).playPracticeGame(playPracticeGameDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentsExternalsClient - axios parameter creator
 * @export
 */
export const TournamentsExternalsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Submit score endpoint, this is used by doondook to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Doondook submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doondookSubmitScore: (submitScoreDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/externals/doondook/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(submitScoreDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submit score endpoint, this is used by freakxapps to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary FreakXApps submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freakxappsSubmitScore: (submitScoreDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/externals/freakxapps/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(submitScoreDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get latest winners scores recorded for onboarding
         * @summary Get Latest Winners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestWinners: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/latest-winners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get user score for a specific tournament, query by user email.
         * @summary Get User Score in Tournament
         * @param {string} tournamentId Tournament id defined in path
         * @param {string} email The email of the user to query their score
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserScoreInTournament: (tournamentId, email, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getUserScoreInTournament', 'tournamentId', tournamentId);
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getUserScoreInTournament', 'email', email);
            const localVarPath = `/tournaments/externals/tournaments/{tournamentId}/participants`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSA submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergsaSubmitScore: (submitScoreDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/externals/hypergsa/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(submitScoreDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSB submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergsbSubmitScore: (submitScoreDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/externals/hypergsb/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(submitScoreDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSC submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergscSubmitScore: (submitScoreDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/externals/hypergsc/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(submitScoreDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Submit score endpoint, this is used by marketjs to communicate player\'s score to hyper tournament service. The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary MarketJs submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mjsSubmitScore: (submitScoreDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/externals/marketjs/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(submitScoreDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentsExternalsClient - functional programming interface
 * @export
 */
export const TournamentsExternalsClientFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentsExternalsClientAxiosParamCreator(configuration);
    return {
        /**
         * Submit score endpoint, this is used by doondook to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Doondook submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doondookSubmitScore(submitScoreDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.doondookSubmitScore(submitScoreDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.doondookSubmitScore']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Submit score endpoint, this is used by freakxapps to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary FreakXApps submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freakxappsSubmitScore(submitScoreDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.freakxappsSubmitScore(submitScoreDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.freakxappsSubmitScore']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get latest winners scores recorded for onboarding
         * @summary Get Latest Winners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestWinners(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestWinners(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.getLatestWinners']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get user score for a specific tournament, query by user email.
         * @summary Get User Score in Tournament
         * @param {string} tournamentId Tournament id defined in path
         * @param {string} email The email of the user to query their score
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserScoreInTournament(tournamentId, email, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserScoreInTournament(tournamentId, email, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.getUserScoreInTournament']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSA submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergsaSubmitScore(submitScoreDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hypergsaSubmitScore(submitScoreDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.hypergsaSubmitScore']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSB submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergsbSubmitScore(submitScoreDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hypergsbSubmitScore(submitScoreDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.hypergsbSubmitScore']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSC submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergscSubmitScore(submitScoreDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hypergscSubmitScore(submitScoreDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.hypergscSubmitScore']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Submit score endpoint, this is used by marketjs to communicate player\'s score to hyper tournament service. The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary MarketJs submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mjsSubmitScore(submitScoreDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mjsSubmitScore(submitScoreDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsExternalsClient.mjsSubmitScore']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TournamentsExternalsClient - factory interface
 * @export
 */
export const TournamentsExternalsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentsExternalsClientFp(configuration);
    return {
        /**
         * Submit score endpoint, this is used by doondook to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Doondook submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doondookSubmitScore(submitScoreDto, options) {
            return localVarFp.doondookSubmitScore(submitScoreDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit score endpoint, this is used by freakxapps to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary FreakXApps submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        freakxappsSubmitScore(submitScoreDto, options) {
            return localVarFp.freakxappsSubmitScore(submitScoreDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get latest winners scores recorded for onboarding
         * @summary Get Latest Winners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestWinners(options) {
            return localVarFp.getLatestWinners(options).then((request) => request(axios, basePath));
        },
        /**
         * Get user score for a specific tournament, query by user email.
         * @summary Get User Score in Tournament
         * @param {string} tournamentId Tournament id defined in path
         * @param {string} email The email of the user to query their score
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserScoreInTournament(tournamentId, email, options) {
            return localVarFp.getUserScoreInTournament(tournamentId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSA submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergsaSubmitScore(submitScoreDto, options) {
            return localVarFp.hypergsaSubmitScore(submitScoreDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSB submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergsbSubmitScore(submitScoreDto, options) {
            return localVarFp.hypergsbSubmitScore(submitScoreDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary Hyper GSC submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hypergscSubmitScore(submitScoreDto, options) {
            return localVarFp.hypergscSubmitScore(submitScoreDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit score endpoint, this is used by marketjs to communicate player\'s score to hyper tournament service. The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
         * @summary MarketJs submit score
         * @param {SubmitScoreDto} [submitScoreDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mjsSubmitScore(submitScoreDto, options) {
            return localVarFp.mjsSubmitScore(submitScoreDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentsExternalsClient - object-oriented interface
 * @export
 * @class TournamentsExternalsClient
 * @extends {BaseAPI}
 */
export class TournamentsExternalsClient extends BaseAPI {
    /**
     * Submit score endpoint, this is used by doondook to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
     * @summary Doondook submit score
     * @param {SubmitScoreDto} [submitScoreDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    doondookSubmitScore(submitScoreDto, options) {
        return TournamentsExternalsClientFp(this.configuration).doondookSubmitScore(submitScoreDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit score endpoint, this is used by freakxapps to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
     * @summary FreakXApps submit score
     * @param {SubmitScoreDto} [submitScoreDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    freakxappsSubmitScore(submitScoreDto, options) {
        return TournamentsExternalsClientFp(this.configuration).freakxappsSubmitScore(submitScoreDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get latest winners scores recorded for onboarding
     * @summary Get Latest Winners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    getLatestWinners(options) {
        return TournamentsExternalsClientFp(this.configuration).getLatestWinners(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get user score for a specific tournament, query by user email.
     * @summary Get User Score in Tournament
     * @param {string} tournamentId Tournament id defined in path
     * @param {string} email The email of the user to query their score
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    getUserScoreInTournament(tournamentId, email, options) {
        return TournamentsExternalsClientFp(this.configuration).getUserScoreInTournament(tournamentId, email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
     * @summary Hyper GSA submit score
     * @param {SubmitScoreDto} [submitScoreDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    hypergsaSubmitScore(submitScoreDto, options) {
        return TournamentsExternalsClientFp(this.configuration).hypergsaSubmitScore(submitScoreDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
     * @summary Hyper GSB submit score
     * @param {SubmitScoreDto} [submitScoreDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    hypergsbSubmitScore(submitScoreDto, options) {
        return TournamentsExternalsClientFp(this.configuration).hypergsbSubmitScore(submitScoreDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit score endpoint, this is used by hyper game developer to communicate player\'s score to hyper tournament service.  The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
     * @summary Hyper GSC submit score
     * @param {SubmitScoreDto} [submitScoreDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    hypergscSubmitScore(submitScoreDto, options) {
        return TournamentsExternalsClientFp(this.configuration).hypergscSubmitScore(submitScoreDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit score endpoint, this is used by marketjs to communicate player\'s score to hyper tournament service. The API key used for this request is separate from the API key for other service to service communication  and not generated by the service authenticator.
     * @summary MarketJs submit score
     * @param {SubmitScoreDto} [submitScoreDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsExternalsClient
     */
    mjsSubmitScore(submitScoreDto, options) {
        return TournamentsExternalsClientFp(this.configuration).mjsSubmitScore(submitScoreDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentsLeaderboardsClient - axios parameter creator
 * @export
 */
export const TournamentsLeaderboardsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get list of users according to ranking
         * @summary Get leaderboard
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [gameId] Game id defined in query
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {LeaderboardGroup} [type] Leaderboard group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderBoard: (page, limit, gameId, startDate, endDate, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get Multi-player Tournament Leaderboard
         * @summary Get Multi-player Tournament Leaderboard
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [withRequester] Filter to return the page where the requester can be found on leaderboard,  this parameter will ignore the page property if the requester has a position in the leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiplayerLeaderBoard: (tournamentId, page, limit, withRequester, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getMultiplayerLeaderBoard', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/multi-player/{tournamentId}/leaderboard`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (withRequester !== undefined) {
                localVarQueryParameter['withRequester'] = withRequester;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get My Multi-player Tournament Sub-Leaderboard
         * @summary Get My Multi-player Tournament Sub-Leaderboard
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyMultiplayerSubLeaderBoard: (tournamentId, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getMyMultiplayerSubLeaderBoard', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/me/multi-player/{tournamentId}/leaderboard`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentsLeaderboardsClient - functional programming interface
 * @export
 */
export const TournamentsLeaderboardsClientFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentsLeaderboardsClientAxiosParamCreator(configuration);
    return {
        /**
         * Get list of users according to ranking
         * @summary Get leaderboard
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [gameId] Game id defined in query
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {LeaderboardGroup} [type] Leaderboard group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderBoard(page, limit, gameId, startDate, endDate, type, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLeaderBoard(page, limit, gameId, startDate, endDate, type, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsLeaderboardsClient.getLeaderBoard']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get Multi-player Tournament Leaderboard
         * @summary Get Multi-player Tournament Leaderboard
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [withRequester] Filter to return the page where the requester can be found on leaderboard,  this parameter will ignore the page property if the requester has a position in the leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiplayerLeaderBoard(tournamentId, page, limit, withRequester, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMultiplayerLeaderBoard(tournamentId, page, limit, withRequester, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsLeaderboardsClient.getMultiplayerLeaderBoard']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get My Multi-player Tournament Sub-Leaderboard
         * @summary Get My Multi-player Tournament Sub-Leaderboard
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyMultiplayerSubLeaderBoard(tournamentId, limit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyMultiplayerSubLeaderBoard(tournamentId, limit, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsLeaderboardsClient.getMyMultiplayerSubLeaderBoard']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TournamentsLeaderboardsClient - factory interface
 * @export
 */
export const TournamentsLeaderboardsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentsLeaderboardsClientFp(configuration);
    return {
        /**
         * Get list of users according to ranking
         * @summary Get leaderboard
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [gameId] Game id defined in query
         * @param {string} [startDate] Start date defined in query
         * @param {string} [endDate] End date defined in query
         * @param {LeaderboardGroup} [type] Leaderboard group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderBoard(page, limit, gameId, startDate, endDate, type, options) {
            return localVarFp.getLeaderBoard(page, limit, gameId, startDate, endDate, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Multi-player Tournament Leaderboard
         * @summary Get Multi-player Tournament Leaderboard
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [withRequester] Filter to return the page where the requester can be found on leaderboard,  this parameter will ignore the page property if the requester has a position in the leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiplayerLeaderBoard(tournamentId, page, limit, withRequester, options) {
            return localVarFp.getMultiplayerLeaderBoard(tournamentId, page, limit, withRequester, options).then((request) => request(axios, basePath));
        },
        /**
         * Get My Multi-player Tournament Sub-Leaderboard
         * @summary Get My Multi-player Tournament Sub-Leaderboard
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyMultiplayerSubLeaderBoard(tournamentId, limit, options) {
            return localVarFp.getMyMultiplayerSubLeaderBoard(tournamentId, limit, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentsLeaderboardsClient - object-oriented interface
 * @export
 * @class TournamentsLeaderboardsClient
 * @extends {BaseAPI}
 */
export class TournamentsLeaderboardsClient extends BaseAPI {
    /**
     * Get list of users according to ranking
     * @summary Get leaderboard
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [gameId] Game id defined in query
     * @param {string} [startDate] Start date defined in query
     * @param {string} [endDate] End date defined in query
     * @param {LeaderboardGroup} [type] Leaderboard group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsLeaderboardsClient
     */
    getLeaderBoard(page, limit, gameId, startDate, endDate, type, options) {
        return TournamentsLeaderboardsClientFp(this.configuration).getLeaderBoard(page, limit, gameId, startDate, endDate, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get Multi-player Tournament Leaderboard
     * @summary Get Multi-player Tournament Leaderboard
     * @param {string} tournamentId Tournament id defined in path
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {boolean} [withRequester] Filter to return the page where the requester can be found on leaderboard,  this parameter will ignore the page property if the requester has a position in the leaderboard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsLeaderboardsClient
     */
    getMultiplayerLeaderBoard(tournamentId, page, limit, withRequester, options) {
        return TournamentsLeaderboardsClientFp(this.configuration).getMultiplayerLeaderBoard(tournamentId, page, limit, withRequester, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get My Multi-player Tournament Sub-Leaderboard
     * @summary Get My Multi-player Tournament Sub-Leaderboard
     * @param {string} tournamentId Tournament id defined in path
     * @param {number} [limit] Number of items to be gotten per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsLeaderboardsClient
     */
    getMyMultiplayerSubLeaderBoard(tournamentId, limit, options) {
        return TournamentsLeaderboardsClientFp(this.configuration).getMyMultiplayerSubLeaderBoard(tournamentId, limit, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentsLevelsClient - axios parameter creator
 * @export
 */
export const TournamentsLevelsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get gamer level for current user (based on user gameplay score history)
         * @summary Get gamer level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGamerLevel: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/gamer-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentsLevelsClient - functional programming interface
 * @export
 */
export const TournamentsLevelsClientFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentsLevelsClientAxiosParamCreator(configuration);
    return {
        /**
         * Get gamer level for current user (based on user gameplay score history)
         * @summary Get gamer level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGamerLevel(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyGamerLevel(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsLevelsClient.getMyGamerLevel']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TournamentsLevelsClient - factory interface
 * @export
 */
export const TournamentsLevelsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentsLevelsClientFp(configuration);
    return {
        /**
         * Get gamer level for current user (based on user gameplay score history)
         * @summary Get gamer level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGamerLevel(options) {
            return localVarFp.getMyGamerLevel(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentsLevelsClient - object-oriented interface
 * @export
 * @class TournamentsLevelsClient
 * @extends {BaseAPI}
 */
export class TournamentsLevelsClient extends BaseAPI {
    /**
     * Get gamer level for current user (based on user gameplay score history)
     * @summary Get gamer level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsLevelsClient
     */
    getMyGamerLevel(options) {
        return TournamentsLevelsClientFp(this.configuration).getMyGamerLevel(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentsStakeOptionsClient - axios parameter creator
 * @export
 */
export const TournamentsStakeOptionsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get stake options
         * @summary Get stake options
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStakeOptions: (currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/stake-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentsStakeOptionsClient - functional programming interface
 * @export
 */
export const TournamentsStakeOptionsClientFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentsStakeOptionsClientAxiosParamCreator(configuration);
    return {
        /**
         * Get stake options
         * @summary Get stake options
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStakeOptions(currency, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStakeOptions(currency, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsStakeOptionsClient.getStakeOptions']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TournamentsStakeOptionsClient - factory interface
 * @export
 */
export const TournamentsStakeOptionsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentsStakeOptionsClientFp(configuration);
    return {
        /**
         * Get stake options
         * @summary Get stake options
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStakeOptions(currency, options) {
            return localVarFp.getStakeOptions(currency, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentsStakeOptionsClient - object-oriented interface
 * @export
 * @class TournamentsStakeOptionsClient
 * @extends {BaseAPI}
 */
export class TournamentsStakeOptionsClient extends BaseAPI {
    /**
     * Get stake options
     * @summary Get stake options
     * @param {FiatCurrency} [currency] Fiat currency identifier in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsStakeOptionsClient
     */
    getStakeOptions(currency, options) {
        return TournamentsStakeOptionsClientFp(this.configuration).getStakeOptions(currency, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentsTournamentsClient - axios parameter creator
 * @export
 */
export const TournamentsTournamentsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Cancel tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour.
         * @summary Cancel entry
         * @param {string} entryId Game id defined in path
         * @param {CancelReason} [reason] Cancel reason defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTournamentEntry: (entryId, reason, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('cancelTournamentEntry', 'entryId', entryId);
            const localVarPath = `/tournaments/me/tournaments/entries/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Check if a user is allowed to play a specific tournament type
         * @summary Check Tournament Eligibility
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {string} [challengeInviteId] Challenge invite id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTournamentEligibility: (tournamentId, type, challengeInviteId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments/check-eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (challengeInviteId !== undefined) {
                localVarQueryParameter['challengeInviteId'] = challengeInviteId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enter PvP competition
         * @summary Enter Duel
         * @param {EnterDuelDto} [enterDuelDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterDuel: (enterDuelDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments/duels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(enterDuelDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enter live PvP competition
         * @summary Enter Live Duel
         * @param {EnterLiveDuelDto} [enterLiveDuelDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterLiveDuel: (enterLiveDuelDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments/duels/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(enterLiveDuelDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enter Platform Hosted Tournament (Multiplayer). This is used for all kind of entry, pre-stake, stake and re-stake
         * @summary Enter Platform Hosted Tournament
         * @param {EnterMultiplayerDto} [enterMultiplayerDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterMultiplayer: (enterMultiplayerDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments/multi-player`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(enterMultiplayerDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Forfeit tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour. Supports only DUEL & MULTIPLAYER
         * @summary Forfeit tournament entry
         * @param {string} entryId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forfeitTournamentEntry: (entryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('forfeitTournamentEntry', 'entryId', entryId);
            const localVarPath = `/tournaments/me/tournaments/entries/{entryId}/forfeit`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get duel recent-gamers summary for a game (includes gamers count & avatar-urls)
         * @summary Get duel recent-gamers summary by game
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuelRecentsGamersSummary: (gameId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('getDuelRecentsGamersSummary', 'gameId', gameId);
            const localVarPath = `/tournaments/games/{gameId}/duel/recent-gamers/summary`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the detail of an entry. The gameplay url is not added to the entry response if score has already been submitted for that entry
         * @summary Get Entry Detail
         * @param {string} entryId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryDetail: (entryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('getEntryDetail', 'entryId', entryId);
            const localVarPath = `/tournaments/me/tournaments/entries/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get Live Duels (assigned to me)
         * @summary Get Live Duels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDuels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments/duels/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the number of live duels (assigned to me)
         * @summary Get live duels count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDuelsCount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments/duels/live/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List all multi-player tournaments on the platform
         * @summary Get Multi-Player Tournaments
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [gameId] Game id defined in query
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiplayerTournaments: (page, limit, gameId, sort, statuses, currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/multi-player`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = Array.from(statuses);
            }
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get my duel opponent
         * @summary Get my duel opponent
         * @param {string} tournamentId Tournament id defined in path
         * @param {boolean} [fm] Fast-match indicator defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDuelOpponent: (tournamentId, fm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getMyDuelOpponent', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/me/duels/{tournamentId}/opponent`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (fm !== undefined) {
                localVarQueryParameter['fm'] = fm;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get paginated list of user entries, filterable by gameId and complete status. Default sorted by createdAt desc
         * @summary List user entries
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {boolean} [preStake] Filter to return only entries that score has not been submitted and was created prior to the tournament start time
         * @param {boolean} [submitted] Filter to return only submitted entries or only entries that have not been submitted, depending on the value
         * @param {boolean} [includeExpired] Filter to include expired entries in the response. &#x60;true&#x60; by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyEntries: (page, limit, tournamentId, type, gameId, preStake, submitted, includeExpired, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (tournamentId !== undefined) {
                localVarQueryParameter['tournamentId'] = tournamentId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }
            if (preStake !== undefined) {
                localVarQueryParameter['preStake'] = preStake;
            }
            if (submitted !== undefined) {
                localVarQueryParameter['submitted'] = submitted;
            }
            if (includeExpired !== undefined) {
                localVarQueryParameter['includeExpired'] = includeExpired;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get my gameplay latest results (from only DUEL & CHALLENGE gameplays)
         * @summary Get my gameplay latest results
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGameplayResults: (limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/gameplays/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of user tournaments, filterable by type and status
         * @summary List user tournaments
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTournaments: (page, limit, userCompleted, sort, type, statuses, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/me/tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (userCompleted !== undefined) {
                localVarQueryParameter['userCompleted'] = userCompleted;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = Array.from(statuses);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get detail of a tournament
         * @summary Get specific tournament
         * @param {string} tournamentId Tournament id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentDetail: (tournamentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getTournamentDetail', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/me/tournaments/{tournamentId}`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all participant for a specific tournament that requester is involved in
         * @summary Get tournament participants
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentParticipants: (tournamentId, page, limit, userCompleted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('getTournamentParticipants', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/me/tournaments/{tournamentId}/participants`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (userCompleted !== undefined) {
                localVarQueryParameter['userCompleted'] = userCompleted;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a list of active multi-player tournaments
         * @summary Get active tournaments by game
         * @param {string} [gameId] Game id defined in query
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveMultiTournaments: (gameId, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments/games/tournaments/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enable/Disable reminder for tournament (sends push-notification when tournament starts)
         * @summary Set reminder for multiplayer
         * @param {string} tournamentId Tournament id defined in path
         * @param {SetReminderDto} [setReminderDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMultiplayerReminder: (tournamentId, setReminderDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tournamentId' is not null or undefined
            assertParamExists('setMultiplayerReminder', 'tournamentId', tournamentId);
            const localVarPath = `/tournaments/me/multi-player/{tournamentId}/reminder`
                .replace(`{${"tournamentId"}}`, encodeURIComponent(String(tournamentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setReminderDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentsTournamentsClient - functional programming interface
 * @export
 */
export const TournamentsTournamentsClientFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentsTournamentsClientAxiosParamCreator(configuration);
    return {
        /**
         * Cancel tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour.
         * @summary Cancel entry
         * @param {string} entryId Game id defined in path
         * @param {CancelReason} [reason] Cancel reason defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTournamentEntry(entryId, reason, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelTournamentEntry(entryId, reason, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.cancelTournamentEntry']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Check if a user is allowed to play a specific tournament type
         * @summary Check Tournament Eligibility
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {string} [challengeInviteId] Challenge invite id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTournamentEligibility(tournamentId, type, challengeInviteId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkTournamentEligibility(tournamentId, type, challengeInviteId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.checkTournamentEligibility']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Enter PvP competition
         * @summary Enter Duel
         * @param {EnterDuelDto} [enterDuelDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterDuel(enterDuelDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enterDuel(enterDuelDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.enterDuel']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Enter live PvP competition
         * @summary Enter Live Duel
         * @param {EnterLiveDuelDto} [enterLiveDuelDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterLiveDuel(enterLiveDuelDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enterLiveDuel(enterLiveDuelDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.enterLiveDuel']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Enter Platform Hosted Tournament (Multiplayer). This is used for all kind of entry, pre-stake, stake and re-stake
         * @summary Enter Platform Hosted Tournament
         * @param {EnterMultiplayerDto} [enterMultiplayerDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterMultiplayer(enterMultiplayerDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enterMultiplayer(enterMultiplayerDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.enterMultiplayer']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Forfeit tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour. Supports only DUEL & MULTIPLAYER
         * @summary Forfeit tournament entry
         * @param {string} entryId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forfeitTournamentEntry(entryId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.forfeitTournamentEntry(entryId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.forfeitTournamentEntry']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get duel recent-gamers summary for a game (includes gamers count & avatar-urls)
         * @summary Get duel recent-gamers summary by game
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuelRecentsGamersSummary(gameId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDuelRecentsGamersSummary(gameId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getDuelRecentsGamersSummary']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get the detail of an entry. The gameplay url is not added to the entry response if score has already been submitted for that entry
         * @summary Get Entry Detail
         * @param {string} entryId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryDetail(entryId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEntryDetail(entryId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getEntryDetail']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get Live Duels (assigned to me)
         * @summary Get Live Duels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDuels(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLiveDuels(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getLiveDuels']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get the number of live duels (assigned to me)
         * @summary Get live duels count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDuelsCount(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLiveDuelsCount(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getLiveDuelsCount']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * List all multi-player tournaments on the platform
         * @summary Get Multi-Player Tournaments
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [gameId] Game id defined in query
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiplayerTournaments(page, limit, gameId, sort, statuses, currency, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMultiplayerTournaments(page, limit, gameId, sort, statuses, currency, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getMultiplayerTournaments']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get my duel opponent
         * @summary Get my duel opponent
         * @param {string} tournamentId Tournament id defined in path
         * @param {boolean} [fm] Fast-match indicator defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDuelOpponent(tournamentId, fm, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyDuelOpponent(tournamentId, fm, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getMyDuelOpponent']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get paginated list of user entries, filterable by gameId and complete status. Default sorted by createdAt desc
         * @summary List user entries
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {boolean} [preStake] Filter to return only entries that score has not been submitted and was created prior to the tournament start time
         * @param {boolean} [submitted] Filter to return only submitted entries or only entries that have not been submitted, depending on the value
         * @param {boolean} [includeExpired] Filter to include expired entries in the response. &#x60;true&#x60; by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyEntries(page, limit, tournamentId, type, gameId, preStake, submitted, includeExpired, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyEntries(page, limit, tournamentId, type, gameId, preStake, submitted, includeExpired, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getMyEntries']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get my gameplay latest results (from only DUEL & CHALLENGE gameplays)
         * @summary Get my gameplay latest results
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGameplayResults(limit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyGameplayResults(limit, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getMyGameplayResults']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get list of user tournaments, filterable by type and status
         * @summary List user tournaments
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTournaments(page, limit, userCompleted, sort, type, statuses, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyTournaments(page, limit, userCompleted, sort, type, statuses, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getMyTournaments']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get detail of a tournament
         * @summary Get specific tournament
         * @param {string} tournamentId Tournament id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentDetail(tournamentId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournamentDetail(tournamentId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getTournamentDetail']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all participant for a specific tournament that requester is involved in
         * @summary Get tournament participants
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentParticipants(tournamentId, page, limit, userCompleted, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournamentParticipants(tournamentId, page, limit, userCompleted, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.getTournamentParticipants']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a list of active multi-player tournaments
         * @summary Get active tournaments by game
         * @param {string} [gameId] Game id defined in query
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveMultiTournaments(gameId, page, limit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listActiveMultiTournaments(gameId, page, limit, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.listActiveMultiTournaments']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Enable/Disable reminder for tournament (sends push-notification when tournament starts)
         * @summary Set reminder for multiplayer
         * @param {string} tournamentId Tournament id defined in path
         * @param {SetReminderDto} [setReminderDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMultiplayerReminder(tournamentId, setReminderDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setMultiplayerReminder(tournamentId, setReminderDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TournamentsTournamentsClient.setMultiplayerReminder']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TournamentsTournamentsClient - factory interface
 * @export
 */
export const TournamentsTournamentsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentsTournamentsClientFp(configuration);
    return {
        /**
         * Cancel tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour.
         * @summary Cancel entry
         * @param {string} entryId Game id defined in path
         * @param {CancelReason} [reason] Cancel reason defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTournamentEntry(entryId, reason, options) {
            return localVarFp.cancelTournamentEntry(entryId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if a user is allowed to play a specific tournament type
         * @summary Check Tournament Eligibility
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {string} [challengeInviteId] Challenge invite id defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkTournamentEligibility(tournamentId, type, challengeInviteId, options) {
            return localVarFp.checkTournamentEligibility(tournamentId, type, challengeInviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enter PvP competition
         * @summary Enter Duel
         * @param {EnterDuelDto} [enterDuelDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterDuel(enterDuelDto, options) {
            return localVarFp.enterDuel(enterDuelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Enter live PvP competition
         * @summary Enter Live Duel
         * @param {EnterLiveDuelDto} [enterLiveDuelDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterLiveDuel(enterLiveDuelDto, options) {
            return localVarFp.enterLiveDuel(enterLiveDuelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Enter Platform Hosted Tournament (Multiplayer). This is used for all kind of entry, pre-stake, stake and re-stake
         * @summary Enter Platform Hosted Tournament
         * @param {EnterMultiplayerDto} [enterMultiplayerDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterMultiplayer(enterMultiplayerDto, options) {
            return localVarFp.enterMultiplayer(enterMultiplayerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Forfeit tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour. Supports only DUEL & MULTIPLAYER
         * @summary Forfeit tournament entry
         * @param {string} entryId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forfeitTournamentEntry(entryId, options) {
            return localVarFp.forfeitTournamentEntry(entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get duel recent-gamers summary for a game (includes gamers count & avatar-urls)
         * @summary Get duel recent-gamers summary by game
         * @param {string} gameId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuelRecentsGamersSummary(gameId, options) {
            return localVarFp.getDuelRecentsGamersSummary(gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the detail of an entry. The gameplay url is not added to the entry response if score has already been submitted for that entry
         * @summary Get Entry Detail
         * @param {string} entryId Game id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryDetail(entryId, options) {
            return localVarFp.getEntryDetail(entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Live Duels (assigned to me)
         * @summary Get Live Duels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDuels(options) {
            return localVarFp.getLiveDuels(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the number of live duels (assigned to me)
         * @summary Get live duels count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiveDuelsCount(options) {
            return localVarFp.getLiveDuelsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * List all multi-player tournaments on the platform
         * @summary Get Multi-Player Tournaments
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [gameId] Game id defined in query
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiplayerTournaments(page, limit, gameId, sort, statuses, currency, options) {
            return localVarFp.getMultiplayerTournaments(page, limit, gameId, sort, statuses, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Get my duel opponent
         * @summary Get my duel opponent
         * @param {string} tournamentId Tournament id defined in path
         * @param {boolean} [fm] Fast-match indicator defined in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDuelOpponent(tournamentId, fm, options) {
            return localVarFp.getMyDuelOpponent(tournamentId, fm, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of user entries, filterable by gameId and complete status. Default sorted by createdAt desc
         * @summary List user entries
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [tournamentId] Tournament id defined in query
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {string} [gameId] Game id defined in query
         * @param {boolean} [preStake] Filter to return only entries that score has not been submitted and was created prior to the tournament start time
         * @param {boolean} [submitted] Filter to return only submitted entries or only entries that have not been submitted, depending on the value
         * @param {boolean} [includeExpired] Filter to include expired entries in the response. &#x60;true&#x60; by default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyEntries(page, limit, tournamentId, type, gameId, preStake, submitted, includeExpired, options) {
            return localVarFp.getMyEntries(page, limit, tournamentId, type, gameId, preStake, submitted, includeExpired, options).then((request) => request(axios, basePath));
        },
        /**
         * Get my gameplay latest results (from only DUEL & CHALLENGE gameplays)
         * @summary Get my gameplay latest results
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGameplayResults(limit, options) {
            return localVarFp.getMyGameplayResults(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of user tournaments, filterable by type and status
         * @summary List user tournaments
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {TournamentType} [type] Tournament type defined in query
         * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTournaments(page, limit, userCompleted, sort, type, statuses, options) {
            return localVarFp.getMyTournaments(page, limit, userCompleted, sort, type, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detail of a tournament
         * @summary Get specific tournament
         * @param {string} tournamentId Tournament id defined in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentDetail(tournamentId, options) {
            return localVarFp.getTournamentDetail(tournamentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all participant for a specific tournament that requester is involved in
         * @summary Get tournament participants
         * @param {string} tournamentId Tournament id defined in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentParticipants(tournamentId, page, limit, userCompleted, options) {
            return localVarFp.getTournamentParticipants(tournamentId, page, limit, userCompleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of active multi-player tournaments
         * @summary Get active tournaments by game
         * @param {string} [gameId] Game id defined in query
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveMultiTournaments(gameId, page, limit, options) {
            return localVarFp.listActiveMultiTournaments(gameId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable/Disable reminder for tournament (sends push-notification when tournament starts)
         * @summary Set reminder for multiplayer
         * @param {string} tournamentId Tournament id defined in path
         * @param {SetReminderDto} [setReminderDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMultiplayerReminder(tournamentId, setReminderDto, options) {
            return localVarFp.setMultiplayerReminder(tournamentId, setReminderDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentsTournamentsClient - object-oriented interface
 * @export
 * @class TournamentsTournamentsClient
 * @extends {BaseAPI}
 */
export class TournamentsTournamentsClient extends BaseAPI {
    /**
     * Cancel tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour.
     * @summary Cancel entry
     * @param {string} entryId Game id defined in path
     * @param {CancelReason} [reason] Cancel reason defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    cancelTournamentEntry(entryId, reason, options) {
        return TournamentsTournamentsClientFp(this.configuration).cancelTournamentEntry(entryId, reason, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Check if a user is allowed to play a specific tournament type
     * @summary Check Tournament Eligibility
     * @param {string} [tournamentId] Tournament id defined in query
     * @param {TournamentType} [type] Tournament type defined in query
     * @param {string} [challengeInviteId] Challenge invite id defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    checkTournamentEligibility(tournamentId, type, challengeInviteId, options) {
        return TournamentsTournamentsClientFp(this.configuration).checkTournamentEligibility(tournamentId, type, challengeInviteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enter PvP competition
     * @summary Enter Duel
     * @param {EnterDuelDto} [enterDuelDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    enterDuel(enterDuelDto, options) {
        return TournamentsTournamentsClientFp(this.configuration).enterDuel(enterDuelDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enter live PvP competition
     * @summary Enter Live Duel
     * @param {EnterLiveDuelDto} [enterLiveDuelDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    enterLiveDuel(enterLiveDuelDto, options) {
        return TournamentsTournamentsClientFp(this.configuration).enterLiveDuel(enterLiveDuelDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enter Platform Hosted Tournament (Multiplayer). This is used for all kind of entry, pre-stake, stake and re-stake
     * @summary Enter Platform Hosted Tournament
     * @param {EnterMultiplayerDto} [enterMultiplayerDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    enterMultiplayer(enterMultiplayerDto, options) {
        return TournamentsTournamentsClientFp(this.configuration).enterMultiplayer(enterMultiplayerDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Forfeit tournament entry if the user (requester) score has not been submitted for the entry and entry is within an hour. Supports only DUEL & MULTIPLAYER
     * @summary Forfeit tournament entry
     * @param {string} entryId Game id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    forfeitTournamentEntry(entryId, options) {
        return TournamentsTournamentsClientFp(this.configuration).forfeitTournamentEntry(entryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get duel recent-gamers summary for a game (includes gamers count & avatar-urls)
     * @summary Get duel recent-gamers summary by game
     * @param {string} gameId Game id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getDuelRecentsGamersSummary(gameId, options) {
        return TournamentsTournamentsClientFp(this.configuration).getDuelRecentsGamersSummary(gameId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the detail of an entry. The gameplay url is not added to the entry response if score has already been submitted for that entry
     * @summary Get Entry Detail
     * @param {string} entryId Game id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getEntryDetail(entryId, options) {
        return TournamentsTournamentsClientFp(this.configuration).getEntryDetail(entryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get Live Duels (assigned to me)
     * @summary Get Live Duels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getLiveDuels(options) {
        return TournamentsTournamentsClientFp(this.configuration).getLiveDuels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the number of live duels (assigned to me)
     * @summary Get live duels count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getLiveDuelsCount(options) {
        return TournamentsTournamentsClientFp(this.configuration).getLiveDuelsCount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List all multi-player tournaments on the platform
     * @summary Get Multi-Player Tournaments
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [gameId] Game id defined in query
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
     * @param {FiatCurrency} [currency] Fiat currency identifier in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getMultiplayerTournaments(page, limit, gameId, sort, statuses, currency, options) {
        return TournamentsTournamentsClientFp(this.configuration).getMultiplayerTournaments(page, limit, gameId, sort, statuses, currency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get my duel opponent
     * @summary Get my duel opponent
     * @param {string} tournamentId Tournament id defined in path
     * @param {boolean} [fm] Fast-match indicator defined in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getMyDuelOpponent(tournamentId, fm, options) {
        return TournamentsTournamentsClientFp(this.configuration).getMyDuelOpponent(tournamentId, fm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get paginated list of user entries, filterable by gameId and complete status. Default sorted by createdAt desc
     * @summary List user entries
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [tournamentId] Tournament id defined in query
     * @param {TournamentType} [type] Tournament type defined in query
     * @param {string} [gameId] Game id defined in query
     * @param {boolean} [preStake] Filter to return only entries that score has not been submitted and was created prior to the tournament start time
     * @param {boolean} [submitted] Filter to return only submitted entries or only entries that have not been submitted, depending on the value
     * @param {boolean} [includeExpired] Filter to include expired entries in the response. &#x60;true&#x60; by default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getMyEntries(page, limit, tournamentId, type, gameId, preStake, submitted, includeExpired, options) {
        return TournamentsTournamentsClientFp(this.configuration).getMyEntries(page, limit, tournamentId, type, gameId, preStake, submitted, includeExpired, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get my gameplay latest results (from only DUEL & CHALLENGE gameplays)
     * @summary Get my gameplay latest results
     * @param {number} [limit] Number of items to be gotten per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getMyGameplayResults(limit, options) {
        return TournamentsTournamentsClientFp(this.configuration).getMyGameplayResults(limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of user tournaments, filterable by type and status
     * @summary List user tournaments
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {TournamentType} [type] Tournament type defined in query
     * @param {Array<TournamentStatus>} [statuses] Statuses to filter with in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getMyTournaments(page, limit, userCompleted, sort, type, statuses, options) {
        return TournamentsTournamentsClientFp(this.configuration).getMyTournaments(page, limit, userCompleted, sort, type, statuses, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get detail of a tournament
     * @summary Get specific tournament
     * @param {string} tournamentId Tournament id defined in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getTournamentDetail(tournamentId, options) {
        return TournamentsTournamentsClientFp(this.configuration).getTournamentDetail(tournamentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all participant for a specific tournament that requester is involved in
     * @summary Get tournament participants
     * @param {string} tournamentId Tournament id defined in path
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {boolean} [userCompleted] Query to specify the completion status of user in the tournament
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    getTournamentParticipants(tournamentId, page, limit, userCompleted, options) {
        return TournamentsTournamentsClientFp(this.configuration).getTournamentParticipants(tournamentId, page, limit, userCompleted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of active multi-player tournaments
     * @summary Get active tournaments by game
     * @param {string} [gameId] Game id defined in query
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    listActiveMultiTournaments(gameId, page, limit, options) {
        return TournamentsTournamentsClientFp(this.configuration).listActiveMultiTournaments(gameId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enable/Disable reminder for tournament (sends push-notification when tournament starts)
     * @summary Set reminder for multiplayer
     * @param {string} tournamentId Tournament id defined in path
     * @param {SetReminderDto} [setReminderDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsTournamentsClient
     */
    setMultiplayerReminder(tournamentId, setReminderDto, options) {
        return TournamentsTournamentsClientFp(this.configuration).setMultiplayerReminder(tournamentId, setReminderDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserNotificationsRegistrationsClient - axios parameter creator
 * @export
 */
export const UserNotificationsRegistrationsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Register a user\'s device to receive push notifications
         * @summary Register device for push notifications
         * @param {string} userId The id of user in path
         * @param {DevicePushRegistrationRequest} [devicePushRegistrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMyDevicePushToken: (userId, devicePushRegistrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('registerMyDevicePushToken', 'userId', userId);
            const localVarPath = `/user-notifications/services/users/{userId}/notifications/push/register`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication authToken required
            yield setApiKeyToObject(localVarHeaderParameter, "x-auth-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(devicePushRegistrationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserNotificationsRegistrationsClient - functional programming interface
 * @export
 */
export const UserNotificationsRegistrationsClientFp = function (configuration) {
    const localVarAxiosParamCreator = UserNotificationsRegistrationsClientAxiosParamCreator(configuration);
    return {
        /**
         * Register a user\'s device to receive push notifications
         * @summary Register device for push notifications
         * @param {string} userId The id of user in path
         * @param {DevicePushRegistrationRequest} [devicePushRegistrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMyDevicePushToken(userId, devicePushRegistrationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerMyDevicePushToken(userId, devicePushRegistrationRequest, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UserNotificationsRegistrationsClient.registerMyDevicePushToken']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UserNotificationsRegistrationsClient - factory interface
 * @export
 */
export const UserNotificationsRegistrationsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = UserNotificationsRegistrationsClientFp(configuration);
    return {
        /**
         * Register a user\'s device to receive push notifications
         * @summary Register device for push notifications
         * @param {string} userId The id of user in path
         * @param {DevicePushRegistrationRequest} [devicePushRegistrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMyDevicePushToken(userId, devicePushRegistrationRequest, options) {
            return localVarFp.registerMyDevicePushToken(userId, devicePushRegistrationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserNotificationsRegistrationsClient - object-oriented interface
 * @export
 * @class UserNotificationsRegistrationsClient
 * @extends {BaseAPI}
 */
export class UserNotificationsRegistrationsClient extends BaseAPI {
    /**
     * Register a user\'s device to receive push notifications
     * @summary Register device for push notifications
     * @param {string} userId The id of user in path
     * @param {DevicePushRegistrationRequest} [devicePushRegistrationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsRegistrationsClient
     */
    registerMyDevicePushToken(userId, devicePushRegistrationRequest, options) {
        return UserNotificationsRegistrationsClientFp(this.configuration).registerMyDevicePushToken(userId, devicePushRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersAccountsClient - axios parameter creator
 * @export
 */
export const UsersAccountsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Change current user username
         * @summary Change username
         * @param {ChangeUsernameDto} [changeUsernameDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUsername: (changeUsernameDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(changeUsernameDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Check if username is taken
         * @summary Check if username is taken
         * @param {string} username The username to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUsernameAvailability: (username, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('checkUsernameAvailability', 'username', username);
            const localVarPath = `/users/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Confirm phone number change. This will be done after sending a verification request
         * @summary Confirm phone number change
         * @param {ConfirmPhoneNumberRequestDto} [confirmPhoneNumberRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPhoneNumberVerification: (confirmPhoneNumberRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/verify-phone-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(confirmPhoneNumberRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete the gamer profile of active user
         * @summary Delete user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the profile of active user
         * @summary Get gamer profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetches the onboarding state of active user.
         * @summary Get user onboarding state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOnboardingState: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/onboarding/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initialise phone number verification
         * @summary Initialise phone number verification
         * @param {UpdatePhoneNumberRequestDto} [updatePhoneNumberRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPhoneNumberVerification: (updatePhoneNumberRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/verify-phone-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePhoneNumberRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Register current users country
         * @summary Register country
         * @param {RegisterCountryDto} [registerCountryDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCountry: (registerCountryDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/geo-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerCountryDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the profile of active user
         * @summary Update user
         * @param {UpdateUserDto} [updateUserDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: (updateUserDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upserts the onboarding state of active user.
         * @summary Update user onboarding state
         * @param {OnboardingState} [onboardingState]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOnboardingState: (onboardingState, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/onboarding/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingState, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upload user avatar
         * @summary Upload avatar
         * @param {File} picture The image in png format
         * @param {string} [label] The label placed on the avatar, this is only valid for predefine avatar upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar: (picture, label, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'picture' is not null or undefined
            assertParamExists('uploadUserAvatar', 'picture', picture);
            const localVarPath = `/users/me/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (picture !== undefined) {
                localVarFormParams.append('picture', picture);
            }
            if (label !== undefined) {
                localVarFormParams.append('label', label);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Change user email using email OTP
         * @summary Change user email using email OTP
         * @param {VerifyEmailOtpDto} [verifyEmailOtpDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailChangeRequest: (verifyEmailOtpDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/verify-email-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailOtpDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersAccountsClient - functional programming interface
 * @export
 */
export const UsersAccountsClientFp = function (configuration) {
    const localVarAxiosParamCreator = UsersAccountsClientAxiosParamCreator(configuration);
    return {
        /**
         * Change current user username
         * @summary Change username
         * @param {ChangeUsernameDto} [changeUsernameDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUsername(changeUsernameDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeUsername(changeUsernameDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.changeUsername']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Check if username is taken
         * @summary Check if username is taken
         * @param {string} username The username to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUsernameAvailability(username, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkUsernameAvailability(username, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.checkUsernameAvailability']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Confirm phone number change. This will be done after sending a verification request
         * @summary Confirm phone number change
         * @param {ConfirmPhoneNumberRequestDto} [confirmPhoneNumberRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPhoneNumberVerification(confirmPhoneNumberRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmPhoneNumberVerification(confirmPhoneNumberRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.confirmPhoneNumberVerification']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Delete the gamer profile of active user
         * @summary Delete user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMyAccount(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.deleteMyAccount']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get the profile of active user
         * @summary Get gamer profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveUserProfile(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.getActiveUserProfile']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Fetches the onboarding state of active user.
         * @summary Get user onboarding state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOnboardingState(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserOnboardingState(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.getUserOnboardingState']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initialise phone number verification
         * @summary Initialise phone number verification
         * @param {UpdatePhoneNumberRequestDto} [updatePhoneNumberRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPhoneNumberVerification(updatePhoneNumberRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initPhoneNumberVerification(updatePhoneNumberRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.initPhoneNumberVerification']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Register current users country
         * @summary Register country
         * @param {RegisterCountryDto} [registerCountryDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCountry(registerCountryDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerCountry(registerCountryDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.registerCountry']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Update the profile of active user
         * @summary Update user
         * @param {UpdateUserDto} [updateUserDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(updateUserDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUser(updateUserDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.updateUser']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Upserts the onboarding state of active user.
         * @summary Update user onboarding state
         * @param {OnboardingState} [onboardingState]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOnboardingState(onboardingState, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserOnboardingState(onboardingState, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.updateUserOnboardingState']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Upload user avatar
         * @summary Upload avatar
         * @param {File} picture The image in png format
         * @param {string} [label] The label placed on the avatar, this is only valid for predefine avatar upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar(picture, label, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadUserAvatar(picture, label, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.uploadUserAvatar']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Change user email using email OTP
         * @summary Change user email using email OTP
         * @param {VerifyEmailOtpDto} [verifyEmailOtpDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailChangeRequest(verifyEmailOtpDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyEmailChangeRequest(verifyEmailOtpDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAccountsClient.verifyEmailChangeRequest']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UsersAccountsClient - factory interface
 * @export
 */
export const UsersAccountsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersAccountsClientFp(configuration);
    return {
        /**
         * Change current user username
         * @summary Change username
         * @param {ChangeUsernameDto} [changeUsernameDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUsername(changeUsernameDto, options) {
            return localVarFp.changeUsername(changeUsernameDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if username is taken
         * @summary Check if username is taken
         * @param {string} username The username to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUsernameAvailability(username, options) {
            return localVarFp.checkUsernameAvailability(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm phone number change. This will be done after sending a verification request
         * @summary Confirm phone number change
         * @param {ConfirmPhoneNumberRequestDto} [confirmPhoneNumberRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPhoneNumberVerification(confirmPhoneNumberRequestDto, options) {
            return localVarFp.confirmPhoneNumberVerification(confirmPhoneNumberRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the gamer profile of active user
         * @summary Delete user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount(options) {
            return localVarFp.deleteMyAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the profile of active user
         * @summary Get gamer profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile(options) {
            return localVarFp.getActiveUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the onboarding state of active user.
         * @summary Get user onboarding state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOnboardingState(options) {
            return localVarFp.getUserOnboardingState(options).then((request) => request(axios, basePath));
        },
        /**
         * Initialise phone number verification
         * @summary Initialise phone number verification
         * @param {UpdatePhoneNumberRequestDto} [updatePhoneNumberRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPhoneNumberVerification(updatePhoneNumberRequestDto, options) {
            return localVarFp.initPhoneNumberVerification(updatePhoneNumberRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Register current users country
         * @summary Register country
         * @param {RegisterCountryDto} [registerCountryDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCountry(registerCountryDto, options) {
            return localVarFp.registerCountry(registerCountryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the profile of active user
         * @summary Update user
         * @param {UpdateUserDto} [updateUserDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(updateUserDto, options) {
            return localVarFp.updateUser(updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Upserts the onboarding state of active user.
         * @summary Update user onboarding state
         * @param {OnboardingState} [onboardingState]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserOnboardingState(onboardingState, options) {
            return localVarFp.updateUserOnboardingState(onboardingState, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload user avatar
         * @summary Upload avatar
         * @param {File} picture The image in png format
         * @param {string} [label] The label placed on the avatar, this is only valid for predefine avatar upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserAvatar(picture, label, options) {
            return localVarFp.uploadUserAvatar(picture, label, options).then((request) => request(axios, basePath));
        },
        /**
         * Change user email using email OTP
         * @summary Change user email using email OTP
         * @param {VerifyEmailOtpDto} [verifyEmailOtpDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailChangeRequest(verifyEmailOtpDto, options) {
            return localVarFp.verifyEmailChangeRequest(verifyEmailOtpDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersAccountsClient - object-oriented interface
 * @export
 * @class UsersAccountsClient
 * @extends {BaseAPI}
 */
export class UsersAccountsClient extends BaseAPI {
    /**
     * Change current user username
     * @summary Change username
     * @param {ChangeUsernameDto} [changeUsernameDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    changeUsername(changeUsernameDto, options) {
        return UsersAccountsClientFp(this.configuration).changeUsername(changeUsernameDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Check if username is taken
     * @summary Check if username is taken
     * @param {string} username The username to check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    checkUsernameAvailability(username, options) {
        return UsersAccountsClientFp(this.configuration).checkUsernameAvailability(username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Confirm phone number change. This will be done after sending a verification request
     * @summary Confirm phone number change
     * @param {ConfirmPhoneNumberRequestDto} [confirmPhoneNumberRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    confirmPhoneNumberVerification(confirmPhoneNumberRequestDto, options) {
        return UsersAccountsClientFp(this.configuration).confirmPhoneNumberVerification(confirmPhoneNumberRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete the gamer profile of active user
     * @summary Delete user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    deleteMyAccount(options) {
        return UsersAccountsClientFp(this.configuration).deleteMyAccount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the profile of active user
     * @summary Get gamer profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    getActiveUserProfile(options) {
        return UsersAccountsClientFp(this.configuration).getActiveUserProfile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetches the onboarding state of active user.
     * @summary Get user onboarding state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    getUserOnboardingState(options) {
        return UsersAccountsClientFp(this.configuration).getUserOnboardingState(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initialise phone number verification
     * @summary Initialise phone number verification
     * @param {UpdatePhoneNumberRequestDto} [updatePhoneNumberRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    initPhoneNumberVerification(updatePhoneNumberRequestDto, options) {
        return UsersAccountsClientFp(this.configuration).initPhoneNumberVerification(updatePhoneNumberRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Register current users country
     * @summary Register country
     * @param {RegisterCountryDto} [registerCountryDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    registerCountry(registerCountryDto, options) {
        return UsersAccountsClientFp(this.configuration).registerCountry(registerCountryDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the profile of active user
     * @summary Update user
     * @param {UpdateUserDto} [updateUserDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    updateUser(updateUserDto, options) {
        return UsersAccountsClientFp(this.configuration).updateUser(updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upserts the onboarding state of active user.
     * @summary Update user onboarding state
     * @param {OnboardingState} [onboardingState]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    updateUserOnboardingState(onboardingState, options) {
        return UsersAccountsClientFp(this.configuration).updateUserOnboardingState(onboardingState, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload user avatar
     * @summary Upload avatar
     * @param {File} picture The image in png format
     * @param {string} [label] The label placed on the avatar, this is only valid for predefine avatar upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    uploadUserAvatar(picture, label, options) {
        return UsersAccountsClientFp(this.configuration).uploadUserAvatar(picture, label, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change user email using email OTP
     * @summary Change user email using email OTP
     * @param {VerifyEmailOtpDto} [verifyEmailOtpDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAccountsClient
     */
    verifyEmailChangeRequest(verifyEmailOtpDto, options) {
        return UsersAccountsClientFp(this.configuration).verifyEmailChangeRequest(verifyEmailOtpDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersAuthsClient - axios parameter creator
 * @export
 */
export const UsersAuthsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a redirect url to initialize authentication
         * @summary Oauth Init
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {OAuthInitRequestDto} [oAuthInitRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOauth: (provider, oAuthInitRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('initOauth', 'provider', provider);
            const localVarPath = `/users/auth/{provider}/init`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthInitRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This destroys both access token and refresh token
         * @summary Log user out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Once the code is verified and an accessToken/idToken is gotten, user will be redirected to the redirectUrl provided at the init stage (`/auth/{provider}/init`). The redirection will have a data query, which is the base64 encoded value of the auth object with the properties `idToken` and `provider`.
         * @summary Oauth Callback
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {string} [code] The auth code from the provider
         * @param {string} [error] The auth error from the provider. This is mostly due to users declining provider permissions
         * @param {string} [state] The state that was initially sent to the provider
         * @param {{ [key: string]: any; }} [params] To allow for dynamic queries that are specific to provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthInitCallback: (provider, code, error, state, params, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('oauthInitCallback', 'provider', provider);
            const localVarPath = `/users/auth/{provider}/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (params !== undefined) {
                for (const [key, value] of Object.entries(params)) {
                    localVarQueryParameter[key] = value;
                }
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Refresh auth tokens using the refresh token supplied as bearerToken header,  and it responds with a new access token and refresh token.
         * @summary Refresh tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/auth/refresh-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Single Sign-On
         * @summary Oauth Verify
         * @param {OAuthRequestDto} [oAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOauth: (oAuthRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/auth/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersAuthsClient - functional programming interface
 * @export
 */
export const UsersAuthsClientFp = function (configuration) {
    const localVarAxiosParamCreator = UsersAuthsClientAxiosParamCreator(configuration);
    return {
        /**
         * Returns a redirect url to initialize authentication
         * @summary Oauth Init
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {OAuthInitRequestDto} [oAuthInitRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOauth(provider, oAuthInitRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initOauth(provider, oAuthInitRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAuthsClient.initOauth']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * This destroys both access token and refresh token
         * @summary Log user out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logout(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAuthsClient.logout']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Once the code is verified and an accessToken/idToken is gotten, user will be redirected to the redirectUrl provided at the init stage (`/auth/{provider}/init`). The redirection will have a data query, which is the base64 encoded value of the auth object with the properties `idToken` and `provider`.
         * @summary Oauth Callback
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {string} [code] The auth code from the provider
         * @param {string} [error] The auth error from the provider. This is mostly due to users declining provider permissions
         * @param {string} [state] The state that was initially sent to the provider
         * @param {{ [key: string]: any; }} [params] To allow for dynamic queries that are specific to provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthInitCallback(provider, code, error, state, params, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauthInitCallback(provider, code, error, state, params, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAuthsClient.oauthInitCallback']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Refresh auth tokens using the refresh token supplied as bearerToken header,  and it responds with a new access token and refresh token.
         * @summary Refresh tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshTokens(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAuthsClient.refreshTokens']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Single Sign-On
         * @summary Oauth Verify
         * @param {OAuthRequestDto} [oAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOauth(oAuthRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyOauth(oAuthRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAuthsClient.verifyOauth']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UsersAuthsClient - factory interface
 * @export
 */
export const UsersAuthsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersAuthsClientFp(configuration);
    return {
        /**
         * Returns a redirect url to initialize authentication
         * @summary Oauth Init
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {OAuthInitRequestDto} [oAuthInitRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initOauth(provider, oAuthInitRequestDto, options) {
            return localVarFp.initOauth(provider, oAuthInitRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * This destroys both access token and refresh token
         * @summary Log user out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Once the code is verified and an accessToken/idToken is gotten, user will be redirected to the redirectUrl provided at the init stage (`/auth/{provider}/init`). The redirection will have a data query, which is the base64 encoded value of the auth object with the properties `idToken` and `provider`.
         * @summary Oauth Callback
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {string} [code] The auth code from the provider
         * @param {string} [error] The auth error from the provider. This is mostly due to users declining provider permissions
         * @param {string} [state] The state that was initially sent to the provider
         * @param {{ [key: string]: any; }} [params] To allow for dynamic queries that are specific to provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthInitCallback(provider, code, error, state, params, options) {
            return localVarFp.oauthInitCallback(provider, code, error, state, params, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh auth tokens using the refresh token supplied as bearerToken header,  and it responds with a new access token and refresh token.
         * @summary Refresh tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(options) {
            return localVarFp.refreshTokens(options).then((request) => request(axios, basePath));
        },
        /**
         * Single Sign-On
         * @summary Oauth Verify
         * @param {OAuthRequestDto} [oAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOauth(oAuthRequestDto, options) {
            return localVarFp.verifyOauth(oAuthRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersAuthsClient - object-oriented interface
 * @export
 * @class UsersAuthsClient
 * @extends {BaseAPI}
 */
export class UsersAuthsClient extends BaseAPI {
    /**
     * Returns a redirect url to initialize authentication
     * @summary Oauth Init
     * @param {string} provider Provider property in path (case insensitive value of the provider)
     * @param {OAuthInitRequestDto} [oAuthInitRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAuthsClient
     */
    initOauth(provider, oAuthInitRequestDto, options) {
        return UsersAuthsClientFp(this.configuration).initOauth(provider, oAuthInitRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This destroys both access token and refresh token
     * @summary Log user out
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAuthsClient
     */
    logout(options) {
        return UsersAuthsClientFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Once the code is verified and an accessToken/idToken is gotten, user will be redirected to the redirectUrl provided at the init stage (`/auth/{provider}/init`). The redirection will have a data query, which is the base64 encoded value of the auth object with the properties `idToken` and `provider`.
     * @summary Oauth Callback
     * @param {string} provider Provider property in path (case insensitive value of the provider)
     * @param {string} [code] The auth code from the provider
     * @param {string} [error] The auth error from the provider. This is mostly due to users declining provider permissions
     * @param {string} [state] The state that was initially sent to the provider
     * @param {{ [key: string]: any; }} [params] To allow for dynamic queries that are specific to provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAuthsClient
     */
    oauthInitCallback(provider, code, error, state, params, options) {
        return UsersAuthsClientFp(this.configuration).oauthInitCallback(provider, code, error, state, params, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Refresh auth tokens using the refresh token supplied as bearerToken header,  and it responds with a new access token and refresh token.
     * @summary Refresh tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAuthsClient
     */
    refreshTokens(options) {
        return UsersAuthsClientFp(this.configuration).refreshTokens(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Single Sign-On
     * @summary Oauth Verify
     * @param {OAuthRequestDto} [oAuthRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAuthsClient
     */
    verifyOauth(oAuthRequestDto, options) {
        return UsersAuthsClientFp(this.configuration).verifyOauth(oAuthRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersAvatarsClient - axios parameter creator
 * @export
 */
export const UsersAvatarsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get available avatars
         * @summary Get available avatars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAvatars: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/avatars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersAvatarsClient - functional programming interface
 * @export
 */
export const UsersAvatarsClientFp = function (configuration) {
    const localVarAxiosParamCreator = UsersAvatarsClientAxiosParamCreator(configuration);
    return {
        /**
         * Get available avatars
         * @summary Get available avatars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAvatars(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableAvatars(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersAvatarsClient.getAvailableAvatars']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UsersAvatarsClient - factory interface
 * @export
 */
export const UsersAvatarsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersAvatarsClientFp(configuration);
    return {
        /**
         * Get available avatars
         * @summary Get available avatars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableAvatars(options) {
            return localVarFp.getAvailableAvatars(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersAvatarsClient - object-oriented interface
 * @export
 * @class UsersAvatarsClient
 * @extends {BaseAPI}
 */
export class UsersAvatarsClient extends BaseAPI {
    /**
     * Get available avatars
     * @summary Get available avatars
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAvatarsClient
     */
    getAvailableAvatars(options) {
        return UsersAvatarsClientFp(this.configuration).getAvailableAvatars(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersConnectionsClient - axios parameter creator
 * @export
 */
export const UsersConnectionsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Connect social profile to find friends
         * @summary Connect social profile
         * @param {OAuthRequestDto} [oAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectSocialProfile: (oAuthRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/social-connects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(oAuthRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Disconnects app from access to friends list on selected social account
         * @summary Revoke app\'s access to connect with social account
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSocialConnect: (provider, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('disconnectSocialConnect', 'provider', provider);
            const localVarPath = `/users/me/social-connects/{provider}/disconnect`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetches imported connections of a user.
         * @summary Get user connections
         * @param {string} connectionSource Connection source in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConnections: (connectionSource, page, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'connectionSource' is not null or undefined
            assertParamExists('getMyConnections', 'connectionSource', connectionSource);
            const localVarPath = `/users/me/{connectionSource}/connections`
                .replace(`{${"connectionSource"}}`, encodeURIComponent(String(connectionSource)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * A list of social profile connection status for finding friend
         * @summary Social profile connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialProfileConnectionStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/social-connects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Imports a user\'s phone connections
         * @summary Import a user\'s phone contacts
         * @param {PhoneContactRequestDto} [phoneContactRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMyPhoneConnections: (phoneContactRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/phone/connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(phoneContactRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Imports a user\'s connections from the selected provider
         * @summary Import a user\'s social connections
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMySocialConnections: (provider, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('importMySocialConnections', 'provider', provider);
            const localVarPath = `/users/me/social-connects/{provider}/connections`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a redirect url to initialize social connect
         * @summary Connect social profile initialization
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {SocialConnectInitRequestDto} [socialConnectInitRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSocialConnect: (provider, socialConnectInitRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('initSocialConnect', 'provider', provider);
            const localVarPath = `/users/me/social-connects/{provider}/init`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(socialConnectInitRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersConnectionsClient - functional programming interface
 * @export
 */
export const UsersConnectionsClientFp = function (configuration) {
    const localVarAxiosParamCreator = UsersConnectionsClientAxiosParamCreator(configuration);
    return {
        /**
         * Connect social profile to find friends
         * @summary Connect social profile
         * @param {OAuthRequestDto} [oAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectSocialProfile(oAuthRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.connectSocialProfile(oAuthRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersConnectionsClient.connectSocialProfile']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Disconnects app from access to friends list on selected social account
         * @summary Revoke app\'s access to connect with social account
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSocialConnect(provider, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.disconnectSocialConnect(provider, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersConnectionsClient.disconnectSocialConnect']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Fetches imported connections of a user.
         * @summary Get user connections
         * @param {string} connectionSource Connection source in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConnections(connectionSource, page, limit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyConnections(connectionSource, page, limit, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersConnectionsClient.getMyConnections']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * A list of social profile connection status for finding friend
         * @summary Social profile connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialProfileConnectionStatus(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSocialProfileConnectionStatus(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersConnectionsClient.getSocialProfileConnectionStatus']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Imports a user\'s phone connections
         * @summary Import a user\'s phone contacts
         * @param {PhoneContactRequestDto} [phoneContactRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMyPhoneConnections(phoneContactRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importMyPhoneConnections(phoneContactRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersConnectionsClient.importMyPhoneConnections']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Imports a user\'s connections from the selected provider
         * @summary Import a user\'s social connections
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMySocialConnections(provider, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importMySocialConnections(provider, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersConnectionsClient.importMySocialConnections']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Returns a redirect url to initialize social connect
         * @summary Connect social profile initialization
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {SocialConnectInitRequestDto} [socialConnectInitRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSocialConnect(provider, socialConnectInitRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initSocialConnect(provider, socialConnectInitRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersConnectionsClient.initSocialConnect']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UsersConnectionsClient - factory interface
 * @export
 */
export const UsersConnectionsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersConnectionsClientFp(configuration);
    return {
        /**
         * Connect social profile to find friends
         * @summary Connect social profile
         * @param {OAuthRequestDto} [oAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectSocialProfile(oAuthRequestDto, options) {
            return localVarFp.connectSocialProfile(oAuthRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnects app from access to friends list on selected social account
         * @summary Revoke app\'s access to connect with social account
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSocialConnect(provider, options) {
            return localVarFp.disconnectSocialConnect(provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches imported connections of a user.
         * @summary Get user connections
         * @param {string} connectionSource Connection source in path
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConnections(connectionSource, page, limit, options) {
            return localVarFp.getMyConnections(connectionSource, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * A list of social profile connection status for finding friend
         * @summary Social profile connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialProfileConnectionStatus(options) {
            return localVarFp.getSocialProfileConnectionStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Imports a user\'s phone connections
         * @summary Import a user\'s phone contacts
         * @param {PhoneContactRequestDto} [phoneContactRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMyPhoneConnections(phoneContactRequestDto, options) {
            return localVarFp.importMyPhoneConnections(phoneContactRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Imports a user\'s connections from the selected provider
         * @summary Import a user\'s social connections
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMySocialConnections(provider, options) {
            return localVarFp.importMySocialConnections(provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a redirect url to initialize social connect
         * @summary Connect social profile initialization
         * @param {string} provider Provider property in path (case insensitive value of the provider)
         * @param {SocialConnectInitRequestDto} [socialConnectInitRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSocialConnect(provider, socialConnectInitRequestDto, options) {
            return localVarFp.initSocialConnect(provider, socialConnectInitRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersConnectionsClient - object-oriented interface
 * @export
 * @class UsersConnectionsClient
 * @extends {BaseAPI}
 */
export class UsersConnectionsClient extends BaseAPI {
    /**
     * Connect social profile to find friends
     * @summary Connect social profile
     * @param {OAuthRequestDto} [oAuthRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersConnectionsClient
     */
    connectSocialProfile(oAuthRequestDto, options) {
        return UsersConnectionsClientFp(this.configuration).connectSocialProfile(oAuthRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Disconnects app from access to friends list on selected social account
     * @summary Revoke app\'s access to connect with social account
     * @param {string} provider Provider property in path (case insensitive value of the provider)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersConnectionsClient
     */
    disconnectSocialConnect(provider, options) {
        return UsersConnectionsClientFp(this.configuration).disconnectSocialConnect(provider, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetches imported connections of a user.
     * @summary Get user connections
     * @param {string} connectionSource Connection source in path
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersConnectionsClient
     */
    getMyConnections(connectionSource, page, limit, options) {
        return UsersConnectionsClientFp(this.configuration).getMyConnections(connectionSource, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * A list of social profile connection status for finding friend
     * @summary Social profile connection status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersConnectionsClient
     */
    getSocialProfileConnectionStatus(options) {
        return UsersConnectionsClientFp(this.configuration).getSocialProfileConnectionStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Imports a user\'s phone connections
     * @summary Import a user\'s phone contacts
     * @param {PhoneContactRequestDto} [phoneContactRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersConnectionsClient
     */
    importMyPhoneConnections(phoneContactRequestDto, options) {
        return UsersConnectionsClientFp(this.configuration).importMyPhoneConnections(phoneContactRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Imports a user\'s connections from the selected provider
     * @summary Import a user\'s social connections
     * @param {string} provider Provider property in path (case insensitive value of the provider)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersConnectionsClient
     */
    importMySocialConnections(provider, options) {
        return UsersConnectionsClientFp(this.configuration).importMySocialConnections(provider, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a redirect url to initialize social connect
     * @summary Connect social profile initialization
     * @param {string} provider Provider property in path (case insensitive value of the provider)
     * @param {SocialConnectInitRequestDto} [socialConnectInitRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersConnectionsClient
     */
    initSocialConnect(provider, socialConnectInitRequestDto, options) {
        return UsersConnectionsClientFp(this.configuration).initSocialConnect(provider, socialConnectInitRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersNotificationsClient - axios parameter creator
 * @export
 */
export const UsersNotificationsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Register a users\' device to receive push notifications
         * @summary Register device for push notifications
         * @param {PushRegistrationRequest} [pushRegistrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMyDevice: (pushRegistrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/notifications/push/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(pushRegistrationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Send otp to User
         * @summary Send otp to user
         * @param {SendOtpDto} [sendOtpDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtpToUser: (sendOtpDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/email-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendOtpDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersNotificationsClient - functional programming interface
 * @export
 */
export const UsersNotificationsClientFp = function (configuration) {
    const localVarAxiosParamCreator = UsersNotificationsClientAxiosParamCreator(configuration);
    return {
        /**
         * Register a users\' device to receive push notifications
         * @summary Register device for push notifications
         * @param {PushRegistrationRequest} [pushRegistrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMyDevice(pushRegistrationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerMyDevice(pushRegistrationRequest, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersNotificationsClient.registerMyDevice']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Send otp to User
         * @summary Send otp to user
         * @param {SendOtpDto} [sendOtpDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtpToUser(sendOtpDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendOtpToUser(sendOtpDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersNotificationsClient.sendOtpToUser']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UsersNotificationsClient - factory interface
 * @export
 */
export const UsersNotificationsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersNotificationsClientFp(configuration);
    return {
        /**
         * Register a users\' device to receive push notifications
         * @summary Register device for push notifications
         * @param {PushRegistrationRequest} [pushRegistrationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMyDevice(pushRegistrationRequest, options) {
            return localVarFp.registerMyDevice(pushRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send otp to User
         * @summary Send otp to user
         * @param {SendOtpDto} [sendOtpDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtpToUser(sendOtpDto, options) {
            return localVarFp.sendOtpToUser(sendOtpDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersNotificationsClient - object-oriented interface
 * @export
 * @class UsersNotificationsClient
 * @extends {BaseAPI}
 */
export class UsersNotificationsClient extends BaseAPI {
    /**
     * Register a users\' device to receive push notifications
     * @summary Register device for push notifications
     * @param {PushRegistrationRequest} [pushRegistrationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersNotificationsClient
     */
    registerMyDevice(pushRegistrationRequest, options) {
        return UsersNotificationsClientFp(this.configuration).registerMyDevice(pushRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send otp to User
     * @summary Send otp to user
     * @param {SendOtpDto} [sendOtpDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersNotificationsClient
     */
    sendOtpToUser(sendOtpDto, options) {
        return UsersNotificationsClientFp(this.configuration).sendOtpToUser(sendOtpDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersPreferencesClient - axios parameter creator
 * @export
 */
export const UsersPreferencesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get User Preference
         * @summary Get a user\'s preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPreference: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update User Preference
         * @summary Update a user\'s preference
         * @param {UserPreferenceDto} [userPreferenceDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyPreference: (userPreferenceDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userPreferenceDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersPreferencesClient - functional programming interface
 * @export
 */
export const UsersPreferencesClientFp = function (configuration) {
    const localVarAxiosParamCreator = UsersPreferencesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get User Preference
         * @summary Get a user\'s preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPreference(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyPreference(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersPreferencesClient.getMyPreference']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Update User Preference
         * @summary Update a user\'s preference
         * @param {UserPreferenceDto} [userPreferenceDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyPreference(userPreferenceDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyPreference(userPreferenceDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersPreferencesClient.updateMyPreference']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UsersPreferencesClient - factory interface
 * @export
 */
export const UsersPreferencesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersPreferencesClientFp(configuration);
    return {
        /**
         * Get User Preference
         * @summary Get a user\'s preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPreference(options) {
            return localVarFp.getMyPreference(options).then((request) => request(axios, basePath));
        },
        /**
         * Update User Preference
         * @summary Update a user\'s preference
         * @param {UserPreferenceDto} [userPreferenceDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyPreference(userPreferenceDto, options) {
            return localVarFp.updateMyPreference(userPreferenceDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersPreferencesClient - object-oriented interface
 * @export
 * @class UsersPreferencesClient
 * @extends {BaseAPI}
 */
export class UsersPreferencesClient extends BaseAPI {
    /**
     * Get User Preference
     * @summary Get a user\'s preference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersPreferencesClient
     */
    getMyPreference(options) {
        return UsersPreferencesClientFp(this.configuration).getMyPreference(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update User Preference
     * @summary Update a user\'s preference
     * @param {UserPreferenceDto} [userPreferenceDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersPreferencesClient
     */
    updateMyPreference(userPreferenceDto, options) {
        return UsersPreferencesClientFp(this.configuration).updateMyPreference(userPreferenceDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsAccountsClient - axios parameter creator
 * @export
 */
export const WalletsAccountsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all wallets for current user
         * @summary Get current user wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMyWallets: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get cryptocurrency USD tokens & networks
         * @summary Get cryptocurrency USD tokens & networks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetNetworkTokens: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/assets/network-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get deposit address of an asset on a specified network for current user
         * @summary Get deposit address
         * @param {string} tokenNetworkCode Code for the token vs network support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositAddress: (tokenNetworkCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tokenNetworkCode' is not null or undefined
            assertParamExists('getDepositAddress', 'tokenNetworkCode', tokenNetworkCode);
            const localVarPath = `/wallets/me/deposit-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (tokenNetworkCode !== undefined) {
                localVarQueryParameter['tokenNetworkCode'] = tokenNetworkCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsAccountsClient - functional programming interface
 * @export
 */
export const WalletsAccountsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsAccountsClientAxiosParamCreator(configuration);
    return {
        /**
         * Get all wallets for current user
         * @summary Get current user wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMyWallets(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllMyWallets(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsAccountsClient.getAllMyWallets']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get cryptocurrency USD tokens & networks
         * @summary Get cryptocurrency USD tokens & networks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetNetworkTokens(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssetNetworkTokens(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsAccountsClient.getAssetNetworkTokens']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get deposit address of an asset on a specified network for current user
         * @summary Get deposit address
         * @param {string} tokenNetworkCode Code for the token vs network support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositAddress(tokenNetworkCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDepositAddress(tokenNetworkCode, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsAccountsClient.getDepositAddress']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsAccountsClient - factory interface
 * @export
 */
export const WalletsAccountsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsAccountsClientFp(configuration);
    return {
        /**
         * Get all wallets for current user
         * @summary Get current user wallets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMyWallets(options) {
            return localVarFp.getAllMyWallets(options).then((request) => request(axios, basePath));
        },
        /**
         * Get cryptocurrency USD tokens & networks
         * @summary Get cryptocurrency USD tokens & networks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetNetworkTokens(options) {
            return localVarFp.getAssetNetworkTokens(options).then((request) => request(axios, basePath));
        },
        /**
         * Get deposit address of an asset on a specified network for current user
         * @summary Get deposit address
         * @param {string} tokenNetworkCode Code for the token vs network support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositAddress(tokenNetworkCode, options) {
            return localVarFp.getDepositAddress(tokenNetworkCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsAccountsClient - object-oriented interface
 * @export
 * @class WalletsAccountsClient
 * @extends {BaseAPI}
 */
export class WalletsAccountsClient extends BaseAPI {
    /**
     * Get all wallets for current user
     * @summary Get current user wallets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsAccountsClient
     */
    getAllMyWallets(options) {
        return WalletsAccountsClientFp(this.configuration).getAllMyWallets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get cryptocurrency USD tokens & networks
     * @summary Get cryptocurrency USD tokens & networks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsAccountsClient
     */
    getAssetNetworkTokens(options) {
        return WalletsAccountsClientFp(this.configuration).getAssetNetworkTokens(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get deposit address of an asset on a specified network for current user
     * @summary Get deposit address
     * @param {string} tokenNetworkCode Code for the token vs network support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsAccountsClient
     */
    getDepositAddress(tokenNetworkCode, options) {
        return WalletsAccountsClientFp(this.configuration).getDepositAddress(tokenNetworkCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsBankAccountsClient - axios parameter creator
 * @export
 */
export const WalletsBankAccountsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Add payout account
         * @summary Connect account
         * @param {ConnectPayoutAccountRequestDto} [connectPayoutAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPayoutAccount: (connectPayoutAccountRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/payouts/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(connectPayoutAccountRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a specific bank account for current user
         * @summary Delete bank account
         * @param {string} accountId Bank account identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyBankAccount: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteMyBankAccount', 'accountId', accountId);
            const localVarPath = `/wallets/me/bank-accounts/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all bank accounts for current user
         * @summary List user bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBankAccounts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/bank-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of payout accounts of a user
         * @summary Get payout accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutAccounts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/payouts/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generate authorization link to connect payment account
         * @summary Initiate authorization to connect payment account
         * @param {string} provider Payment provider in path
         * @param {AccountAuthRequestDto} [accountAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAccountAuth: (provider, accountAuthRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('initiateAccountAuth', 'provider', provider);
            const localVarPath = `/wallets/me/accounts/{provider}/initiate`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accountAuthRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Query bank details and save information locally when confirm is set to true.
         * @summary Query Bank Account
         * @param {boolean} [confirm] Query to specify if user has confirmed that the account is valid.  When this query is set, the account will be saved against the user and an id will be assigned to the account
         * @param {QueryBankAccountRequestDto} [queryBankAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryBankAccountDetails: (confirm, queryBankAccountRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/bank-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (confirm !== undefined) {
                localVarQueryParameter['confirm'] = confirm;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(queryBankAccountRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Remove payout account details
         * @summary Remove payout account
         * @param {string} payoutAccountId Payout account identifier
         * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePayoutAccount: (payoutAccountId, payoutAccountType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payoutAccountId' is not null or undefined
            assertParamExists('removePayoutAccount', 'payoutAccountId', payoutAccountId);
            // verify required parameter 'payoutAccountType' is not null or undefined
            assertParamExists('removePayoutAccount', 'payoutAccountType', payoutAccountType);
            const localVarPath = `/wallets/me/payouts/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payoutAccountId !== undefined) {
                localVarQueryParameter['payoutAccountId'] = payoutAccountId;
            }
            if (payoutAccountType !== undefined) {
                localVarQueryParameter['payoutAccountType'] = payoutAccountType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update bank account, only isDefault property can be updated
         * @summary Update bank account
         * @param {string} accountId Bank account identifier in path
         * @param {UpdateBankAccountRequestDto} [updateBankAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBankAccount: (accountId, updateBankAccountRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateMyBankAccount', 'accountId', accountId);
            const localVarPath = `/wallets/me/bank-accounts/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateBankAccountRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update account details such as alias, name on card, etc
         * @summary Update payout account
         * @param {string} payoutAccountId Payout account identifier
         * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
         * @param {UpdatePayoutAccountRequestDto} [updatePayoutAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutAccount: (payoutAccountId, payoutAccountType, updatePayoutAccountRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'payoutAccountId' is not null or undefined
            assertParamExists('updatePayoutAccount', 'payoutAccountId', payoutAccountId);
            // verify required parameter 'payoutAccountType' is not null or undefined
            assertParamExists('updatePayoutAccount', 'payoutAccountType', payoutAccountType);
            const localVarPath = `/wallets/me/payouts/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (payoutAccountId !== undefined) {
                localVarQueryParameter['payoutAccountId'] = payoutAccountId;
            }
            if (payoutAccountType !== undefined) {
                localVarQueryParameter['payoutAccountType'] = payoutAccountType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePayoutAccountRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsBankAccountsClient - functional programming interface
 * @export
 */
export const WalletsBankAccountsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsBankAccountsClientAxiosParamCreator(configuration);
    return {
        /**
         * Add payout account
         * @summary Connect account
         * @param {ConnectPayoutAccountRequestDto} [connectPayoutAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPayoutAccount(connectPayoutAccountRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.connectPayoutAccount(connectPayoutAccountRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.connectPayoutAccount']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Delete a specific bank account for current user
         * @summary Delete bank account
         * @param {string} accountId Bank account identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyBankAccount(accountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMyBankAccount(accountId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.deleteMyBankAccount']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get all bank accounts for current user
         * @summary List user bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBankAccounts(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyBankAccounts(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.getMyBankAccounts']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Returns a list of payout accounts of a user
         * @summary Get payout accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutAccounts(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPayoutAccounts(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.getPayoutAccounts']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Generate authorization link to connect payment account
         * @summary Initiate authorization to connect payment account
         * @param {string} provider Payment provider in path
         * @param {AccountAuthRequestDto} [accountAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAccountAuth(provider, accountAuthRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiateAccountAuth(provider, accountAuthRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.initiateAccountAuth']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Query bank details and save information locally when confirm is set to true.
         * @summary Query Bank Account
         * @param {boolean} [confirm] Query to specify if user has confirmed that the account is valid.  When this query is set, the account will be saved against the user and an id will be assigned to the account
         * @param {QueryBankAccountRequestDto} [queryBankAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryBankAccountDetails(confirm, queryBankAccountRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryBankAccountDetails(confirm, queryBankAccountRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.queryBankAccountDetails']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Remove payout account details
         * @summary Remove payout account
         * @param {string} payoutAccountId Payout account identifier
         * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePayoutAccount(payoutAccountId, payoutAccountType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removePayoutAccount(payoutAccountId, payoutAccountType, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.removePayoutAccount']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Update bank account, only isDefault property can be updated
         * @summary Update bank account
         * @param {string} accountId Bank account identifier in path
         * @param {UpdateBankAccountRequestDto} [updateBankAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBankAccount(accountId, updateBankAccountRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMyBankAccount(accountId, updateBankAccountRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.updateMyBankAccount']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Update account details such as alias, name on card, etc
         * @summary Update payout account
         * @param {string} payoutAccountId Payout account identifier
         * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
         * @param {UpdatePayoutAccountRequestDto} [updatePayoutAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutAccount(payoutAccountId, payoutAccountType, updatePayoutAccountRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePayoutAccount(payoutAccountId, payoutAccountType, updatePayoutAccountRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsBankAccountsClient.updatePayoutAccount']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsBankAccountsClient - factory interface
 * @export
 */
export const WalletsBankAccountsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsBankAccountsClientFp(configuration);
    return {
        /**
         * Add payout account
         * @summary Connect account
         * @param {ConnectPayoutAccountRequestDto} [connectPayoutAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectPayoutAccount(connectPayoutAccountRequestDto, options) {
            return localVarFp.connectPayoutAccount(connectPayoutAccountRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a specific bank account for current user
         * @summary Delete bank account
         * @param {string} accountId Bank account identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyBankAccount(accountId, options) {
            return localVarFp.deleteMyBankAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all bank accounts for current user
         * @summary List user bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBankAccounts(options) {
            return localVarFp.getMyBankAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of payout accounts of a user
         * @summary Get payout accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayoutAccounts(options) {
            return localVarFp.getPayoutAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Generate authorization link to connect payment account
         * @summary Initiate authorization to connect payment account
         * @param {string} provider Payment provider in path
         * @param {AccountAuthRequestDto} [accountAuthRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateAccountAuth(provider, accountAuthRequestDto, options) {
            return localVarFp.initiateAccountAuth(provider, accountAuthRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Query bank details and save information locally when confirm is set to true.
         * @summary Query Bank Account
         * @param {boolean} [confirm] Query to specify if user has confirmed that the account is valid.  When this query is set, the account will be saved against the user and an id will be assigned to the account
         * @param {QueryBankAccountRequestDto} [queryBankAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryBankAccountDetails(confirm, queryBankAccountRequestDto, options) {
            return localVarFp.queryBankAccountDetails(confirm, queryBankAccountRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove payout account details
         * @summary Remove payout account
         * @param {string} payoutAccountId Payout account identifier
         * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePayoutAccount(payoutAccountId, payoutAccountType, options) {
            return localVarFp.removePayoutAccount(payoutAccountId, payoutAccountType, options).then((request) => request(axios, basePath));
        },
        /**
         * Update bank account, only isDefault property can be updated
         * @summary Update bank account
         * @param {string} accountId Bank account identifier in path
         * @param {UpdateBankAccountRequestDto} [updateBankAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyBankAccount(accountId, updateBankAccountRequestDto, options) {
            return localVarFp.updateMyBankAccount(accountId, updateBankAccountRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update account details such as alias, name on card, etc
         * @summary Update payout account
         * @param {string} payoutAccountId Payout account identifier
         * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
         * @param {UpdatePayoutAccountRequestDto} [updatePayoutAccountRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayoutAccount(payoutAccountId, payoutAccountType, updatePayoutAccountRequestDto, options) {
            return localVarFp.updatePayoutAccount(payoutAccountId, payoutAccountType, updatePayoutAccountRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsBankAccountsClient - object-oriented interface
 * @export
 * @class WalletsBankAccountsClient
 * @extends {BaseAPI}
 */
export class WalletsBankAccountsClient extends BaseAPI {
    /**
     * Add payout account
     * @summary Connect account
     * @param {ConnectPayoutAccountRequestDto} [connectPayoutAccountRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    connectPayoutAccount(connectPayoutAccountRequestDto, options) {
        return WalletsBankAccountsClientFp(this.configuration).connectPayoutAccount(connectPayoutAccountRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a specific bank account for current user
     * @summary Delete bank account
     * @param {string} accountId Bank account identifier in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    deleteMyBankAccount(accountId, options) {
        return WalletsBankAccountsClientFp(this.configuration).deleteMyBankAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all bank accounts for current user
     * @summary List user bank accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    getMyBankAccounts(options) {
        return WalletsBankAccountsClientFp(this.configuration).getMyBankAccounts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of payout accounts of a user
     * @summary Get payout accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    getPayoutAccounts(options) {
        return WalletsBankAccountsClientFp(this.configuration).getPayoutAccounts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generate authorization link to connect payment account
     * @summary Initiate authorization to connect payment account
     * @param {string} provider Payment provider in path
     * @param {AccountAuthRequestDto} [accountAuthRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    initiateAccountAuth(provider, accountAuthRequestDto, options) {
        return WalletsBankAccountsClientFp(this.configuration).initiateAccountAuth(provider, accountAuthRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Query bank details and save information locally when confirm is set to true.
     * @summary Query Bank Account
     * @param {boolean} [confirm] Query to specify if user has confirmed that the account is valid.  When this query is set, the account will be saved against the user and an id will be assigned to the account
     * @param {QueryBankAccountRequestDto} [queryBankAccountRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    queryBankAccountDetails(confirm, queryBankAccountRequestDto, options) {
        return WalletsBankAccountsClientFp(this.configuration).queryBankAccountDetails(confirm, queryBankAccountRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove payout account details
     * @summary Remove payout account
     * @param {string} payoutAccountId Payout account identifier
     * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    removePayoutAccount(payoutAccountId, payoutAccountType, options) {
        return WalletsBankAccountsClientFp(this.configuration).removePayoutAccount(payoutAccountId, payoutAccountType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update bank account, only isDefault property can be updated
     * @summary Update bank account
     * @param {string} accountId Bank account identifier in path
     * @param {UpdateBankAccountRequestDto} [updateBankAccountRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    updateMyBankAccount(accountId, updateBankAccountRequestDto, options) {
        return WalletsBankAccountsClientFp(this.configuration).updateMyBankAccount(accountId, updateBankAccountRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update account details such as alias, name on card, etc
     * @summary Update payout account
     * @param {string} payoutAccountId Payout account identifier
     * @param {PayoutAccountTypeQueryPayoutAccountTypeEnum} payoutAccountType Payout account type
     * @param {UpdatePayoutAccountRequestDto} [updatePayoutAccountRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsBankAccountsClient
     */
    updatePayoutAccount(payoutAccountId, payoutAccountType, updatePayoutAccountRequestDto, options) {
        return WalletsBankAccountsClientFp(this.configuration).updatePayoutAccount(payoutAccountId, payoutAccountType, updatePayoutAccountRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsDebtsClient - axios parameter creator
 * @export
 */
export const WalletsDebtsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets a user\'s debt summary.
         * @summary Get a user\'s debt summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDebtSummary: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/debts/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Resolve an authenticated user\'s debts, this will attempt to pay all pending debts a user has
         * @summary Resolve an authenticated user\'s debt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveMyDebt: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/debts/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsDebtsClient - functional programming interface
 * @export
 */
export const WalletsDebtsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsDebtsClientAxiosParamCreator(configuration);
    return {
        /**
         * Gets a user\'s debt summary.
         * @summary Get a user\'s debt summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDebtSummary(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserDebtSummary(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsDebtsClient.getUserDebtSummary']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Resolve an authenticated user\'s debts, this will attempt to pay all pending debts a user has
         * @summary Resolve an authenticated user\'s debt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveMyDebt(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveMyDebt(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsDebtsClient.resolveMyDebt']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsDebtsClient - factory interface
 * @export
 */
export const WalletsDebtsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsDebtsClientFp(configuration);
    return {
        /**
         * Gets a user\'s debt summary.
         * @summary Get a user\'s debt summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDebtSummary(options) {
            return localVarFp.getUserDebtSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve an authenticated user\'s debts, this will attempt to pay all pending debts a user has
         * @summary Resolve an authenticated user\'s debt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveMyDebt(options) {
            return localVarFp.resolveMyDebt(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsDebtsClient - object-oriented interface
 * @export
 * @class WalletsDebtsClient
 * @extends {BaseAPI}
 */
export class WalletsDebtsClient extends BaseAPI {
    /**
     * Gets a user\'s debt summary.
     * @summary Get a user\'s debt summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsDebtsClient
     */
    getUserDebtSummary(options) {
        return WalletsDebtsClientFp(this.configuration).getUserDebtSummary(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resolve an authenticated user\'s debts, this will attempt to pay all pending debts a user has
     * @summary Resolve an authenticated user\'s debt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsDebtsClient
     */
    resolveMyDebt(options) {
        return WalletsDebtsClientFp(this.configuration).resolveMyDebt(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsExchangeRatesClient - axios parameter creator
 * @export
 */
export const WalletsExchangeRatesClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get currency exchange-rate (between HPR & USD pairs). `sourceCurrencyQuery` defaults `HPR` if not provided
         * @summary Get currency exchange-rate
         * @param {Currency} [currency] Currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyExchangeRate: (currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/exchange-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsExchangeRatesClient - functional programming interface
 * @export
 */
export const WalletsExchangeRatesClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsExchangeRatesClientAxiosParamCreator(configuration);
    return {
        /**
         * Get currency exchange-rate (between HPR & USD pairs). `sourceCurrencyQuery` defaults `HPR` if not provided
         * @summary Get currency exchange-rate
         * @param {Currency} [currency] Currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyExchangeRate(currency, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrencyExchangeRate(currency, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsExchangeRatesClient.getCurrencyExchangeRate']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsExchangeRatesClient - factory interface
 * @export
 */
export const WalletsExchangeRatesClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsExchangeRatesClientFp(configuration);
    return {
        /**
         * Get currency exchange-rate (between HPR & USD pairs). `sourceCurrencyQuery` defaults `HPR` if not provided
         * @summary Get currency exchange-rate
         * @param {Currency} [currency] Currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyExchangeRate(currency, options) {
            return localVarFp.getCurrencyExchangeRate(currency, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsExchangeRatesClient - object-oriented interface
 * @export
 * @class WalletsExchangeRatesClient
 * @extends {BaseAPI}
 */
export class WalletsExchangeRatesClient extends BaseAPI {
    /**
     * Get currency exchange-rate (between HPR & USD pairs). `sourceCurrencyQuery` defaults `HPR` if not provided
     * @summary Get currency exchange-rate
     * @param {Currency} [currency] Currency identifier in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsExchangeRatesClient
     */
    getCurrencyExchangeRate(currency, options) {
        return WalletsExchangeRatesClientFp(this.configuration).getCurrencyExchangeRate(currency, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsFiatChannelsClient - axios parameter creator
 * @export
 */
export const WalletsFiatChannelsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get fiat-channel cashout rates (default currency is NGN) and withdrawal limits
         * @summary Get fiat-channel cashout rates and withdrawal limits
         * @param {string} [transferSpeed]
         * @param {number} [hprAmount]
         * @param {PaymentProviderQueryProviderEnum} [provider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatChannelCashoutRates: (transferSpeed, hprAmount, provider, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/fiat-channels/cashout/rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (transferSpeed !== undefined) {
                localVarQueryParameter['transferSpeed'] = transferSpeed;
            }
            if (hprAmount !== undefined) {
                localVarQueryParameter['hprAmount'] = hprAmount;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get supported fiat channels
         * @summary Get supported fiat channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatChannels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/fiat-channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get fiat-channel supported-banks
         * @summary Get fiat-channel supported-banks
         * @param {string} [countryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatSupportedBanks: (countryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/fiat-channels/supported-banks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate fiat-channel deposit
         * @summary Initiate fiat-channel deposit
         * @param {InitiateFiatChannelDepositDto} [initiateFiatChannelDepositDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateFiatChannelDeposit: (initiateFiatChannelDepositDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/fiat-channels/deposit/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(initiateFiatChannelDepositDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate fiat-channel withdrawal
         * @summary Initiate fiat-channel withdrawal
         * @param {InitiateFiatChannelWithdrawalDto} [initiateFiatChannelWithdrawalDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateFiatChannelWithdrawal: (initiateFiatChannelWithdrawalDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/fiat-channels/withdrawal/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(initiateFiatChannelWithdrawalDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsFiatChannelsClient - functional programming interface
 * @export
 */
export const WalletsFiatChannelsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsFiatChannelsClientAxiosParamCreator(configuration);
    return {
        /**
         * Get fiat-channel cashout rates (default currency is NGN) and withdrawal limits
         * @summary Get fiat-channel cashout rates and withdrawal limits
         * @param {string} [transferSpeed]
         * @param {number} [hprAmount]
         * @param {PaymentProviderQueryProviderEnum} [provider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatChannelCashoutRates(transferSpeed, hprAmount, provider, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFiatChannelCashoutRates(transferSpeed, hprAmount, provider, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsFiatChannelsClient.getFiatChannelCashoutRates']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get supported fiat channels
         * @summary Get supported fiat channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatChannels(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFiatChannels(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsFiatChannelsClient.getFiatChannels']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get fiat-channel supported-banks
         * @summary Get fiat-channel supported-banks
         * @param {string} [countryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatSupportedBanks(countryCode, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFiatSupportedBanks(countryCode, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsFiatChannelsClient.getFiatSupportedBanks']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initiate fiat-channel deposit
         * @summary Initiate fiat-channel deposit
         * @param {InitiateFiatChannelDepositDto} [initiateFiatChannelDepositDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateFiatChannelDeposit(initiateFiatChannelDepositDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiateFiatChannelDeposit(initiateFiatChannelDepositDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsFiatChannelsClient.initiateFiatChannelDeposit']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initiate fiat-channel withdrawal
         * @summary Initiate fiat-channel withdrawal
         * @param {InitiateFiatChannelWithdrawalDto} [initiateFiatChannelWithdrawalDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateFiatChannelWithdrawal(initiateFiatChannelWithdrawalDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiateFiatChannelWithdrawal(initiateFiatChannelWithdrawalDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsFiatChannelsClient.initiateFiatChannelWithdrawal']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsFiatChannelsClient - factory interface
 * @export
 */
export const WalletsFiatChannelsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsFiatChannelsClientFp(configuration);
    return {
        /**
         * Get fiat-channel cashout rates (default currency is NGN) and withdrawal limits
         * @summary Get fiat-channel cashout rates and withdrawal limits
         * @param {string} [transferSpeed]
         * @param {number} [hprAmount]
         * @param {PaymentProviderQueryProviderEnum} [provider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatChannelCashoutRates(transferSpeed, hprAmount, provider, options) {
            return localVarFp.getFiatChannelCashoutRates(transferSpeed, hprAmount, provider, options).then((request) => request(axios, basePath));
        },
        /**
         * Get supported fiat channels
         * @summary Get supported fiat channels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatChannels(options) {
            return localVarFp.getFiatChannels(options).then((request) => request(axios, basePath));
        },
        /**
         * Get fiat-channel supported-banks
         * @summary Get fiat-channel supported-banks
         * @param {string} [countryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatSupportedBanks(countryCode, options) {
            return localVarFp.getFiatSupportedBanks(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate fiat-channel deposit
         * @summary Initiate fiat-channel deposit
         * @param {InitiateFiatChannelDepositDto} [initiateFiatChannelDepositDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateFiatChannelDeposit(initiateFiatChannelDepositDto, options) {
            return localVarFp.initiateFiatChannelDeposit(initiateFiatChannelDepositDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate fiat-channel withdrawal
         * @summary Initiate fiat-channel withdrawal
         * @param {InitiateFiatChannelWithdrawalDto} [initiateFiatChannelWithdrawalDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateFiatChannelWithdrawal(initiateFiatChannelWithdrawalDto, options) {
            return localVarFp.initiateFiatChannelWithdrawal(initiateFiatChannelWithdrawalDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsFiatChannelsClient - object-oriented interface
 * @export
 * @class WalletsFiatChannelsClient
 * @extends {BaseAPI}
 */
export class WalletsFiatChannelsClient extends BaseAPI {
    /**
     * Get fiat-channel cashout rates (default currency is NGN) and withdrawal limits
     * @summary Get fiat-channel cashout rates and withdrawal limits
     * @param {string} [transferSpeed]
     * @param {number} [hprAmount]
     * @param {PaymentProviderQueryProviderEnum} [provider]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsFiatChannelsClient
     */
    getFiatChannelCashoutRates(transferSpeed, hprAmount, provider, options) {
        return WalletsFiatChannelsClientFp(this.configuration).getFiatChannelCashoutRates(transferSpeed, hprAmount, provider, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get supported fiat channels
     * @summary Get supported fiat channels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsFiatChannelsClient
     */
    getFiatChannels(options) {
        return WalletsFiatChannelsClientFp(this.configuration).getFiatChannels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get fiat-channel supported-banks
     * @summary Get fiat-channel supported-banks
     * @param {string} [countryCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsFiatChannelsClient
     */
    getFiatSupportedBanks(countryCode, options) {
        return WalletsFiatChannelsClientFp(this.configuration).getFiatSupportedBanks(countryCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate fiat-channel deposit
     * @summary Initiate fiat-channel deposit
     * @param {InitiateFiatChannelDepositDto} [initiateFiatChannelDepositDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsFiatChannelsClient
     */
    initiateFiatChannelDeposit(initiateFiatChannelDepositDto, options) {
        return WalletsFiatChannelsClientFp(this.configuration).initiateFiatChannelDeposit(initiateFiatChannelDepositDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate fiat-channel withdrawal
     * @summary Initiate fiat-channel withdrawal
     * @param {InitiateFiatChannelWithdrawalDto} [initiateFiatChannelWithdrawalDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsFiatChannelsClient
     */
    initiateFiatChannelWithdrawal(initiateFiatChannelWithdrawalDto, options) {
        return WalletsFiatChannelsClientFp(this.configuration).initiateFiatChannelWithdrawal(initiateFiatChannelWithdrawalDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsGemsClient - axios parameter creator
 * @export
 */
export const WalletsGemsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Claim an available GEM swap offer
         * @summary Claim a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimGemSwapOffer: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('claimGemSwapOffer', 'offerId', offerId);
            const localVarPath = `/wallets/me/gem/offers/{offerId}/claim`
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the available GEM Swap Offers
         * @summary Get the available GEM Swap offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGemOffers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/gem/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the cooldown timer for a GEM swap Offer
         * @summary Get the cooldown timer for a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimerForGemOffer: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('getTimerForGemOffer', 'offerId', offerId);
            const localVarPath = `/wallets/me/gem/offers/{offerId}/timer`
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the available GEM Swap Offers for a user
         * @summary Get the available GEM Swap offers for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGemOffers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/gem/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get My wallet GEM
         * @summary Get My wallet GEM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletGem: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/wallet/gem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Skip the cooldown timer for a GEM swap offer
         * @summary Skip the cooldown timer on a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipTimerForGemSwap: (offerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('skipTimerForGemSwap', 'offerId', offerId);
            const localVarPath = `/wallets/me/gem/offers/{offerId}/timer/skip`
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsGemsClient - functional programming interface
 * @export
 */
export const WalletsGemsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsGemsClientAxiosParamCreator(configuration);
    return {
        /**
         * Claim an available GEM swap offer
         * @summary Claim a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimGemSwapOffer(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.claimGemSwapOffer(offerId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsGemsClient.claimGemSwapOffer']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get the available GEM Swap Offers
         * @summary Get the available GEM Swap offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGemOffers(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGemOffers(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsGemsClient.getGemOffers']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get the cooldown timer for a GEM swap Offer
         * @summary Get the cooldown timer for a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimerForGemOffer(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTimerForGemOffer(offerId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsGemsClient.getTimerForGemOffer']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get the available GEM Swap Offers for a user
         * @summary Get the available GEM Swap offers for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGemOffers(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserGemOffers(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsGemsClient.getUserGemOffers']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get My wallet GEM
         * @summary Get My wallet GEM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletGem(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWalletGem(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsGemsClient.getWalletGem']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Skip the cooldown timer for a GEM swap offer
         * @summary Skip the cooldown timer on a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipTimerForGemSwap(offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.skipTimerForGemSwap(offerId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsGemsClient.skipTimerForGemSwap']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsGemsClient - factory interface
 * @export
 */
export const WalletsGemsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsGemsClientFp(configuration);
    return {
        /**
         * Claim an available GEM swap offer
         * @summary Claim a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimGemSwapOffer(offerId, options) {
            return localVarFp.claimGemSwapOffer(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the available GEM Swap Offers
         * @summary Get the available GEM Swap offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGemOffers(options) {
            return localVarFp.getGemOffers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the cooldown timer for a GEM swap Offer
         * @summary Get the cooldown timer for a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimerForGemOffer(offerId, options) {
            return localVarFp.getTimerForGemOffer(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the available GEM Swap Offers for a user
         * @summary Get the available GEM Swap offers for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGemOffers(options) {
            return localVarFp.getUserGemOffers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get My wallet GEM
         * @summary Get My wallet GEM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletGem(options) {
            return localVarFp.getWalletGem(options).then((request) => request(axios, basePath));
        },
        /**
         * Skip the cooldown timer for a GEM swap offer
         * @summary Skip the cooldown timer on a GEM swap offer
         * @param {string} offerId Offer id in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipTimerForGemSwap(offerId, options) {
            return localVarFp.skipTimerForGemSwap(offerId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsGemsClient - object-oriented interface
 * @export
 * @class WalletsGemsClient
 * @extends {BaseAPI}
 */
export class WalletsGemsClient extends BaseAPI {
    /**
     * Claim an available GEM swap offer
     * @summary Claim a GEM swap offer
     * @param {string} offerId Offer id in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsGemsClient
     */
    claimGemSwapOffer(offerId, options) {
        return WalletsGemsClientFp(this.configuration).claimGemSwapOffer(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the available GEM Swap Offers
     * @summary Get the available GEM Swap offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsGemsClient
     */
    getGemOffers(options) {
        return WalletsGemsClientFp(this.configuration).getGemOffers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the cooldown timer for a GEM swap Offer
     * @summary Get the cooldown timer for a GEM swap offer
     * @param {string} offerId Offer id in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsGemsClient
     */
    getTimerForGemOffer(offerId, options) {
        return WalletsGemsClientFp(this.configuration).getTimerForGemOffer(offerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the available GEM Swap Offers for a user
     * @summary Get the available GEM Swap offers for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsGemsClient
     */
    getUserGemOffers(options) {
        return WalletsGemsClientFp(this.configuration).getUserGemOffers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get My wallet GEM
     * @summary Get My wallet GEM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsGemsClient
     */
    getWalletGem(options) {
        return WalletsGemsClientFp(this.configuration).getWalletGem(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Skip the cooldown timer for a GEM swap offer
     * @summary Skip the cooldown timer on a GEM swap offer
     * @param {string} offerId Offer id in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsGemsClient
     */
    skipTimerForGemSwap(offerId, options) {
        return WalletsGemsClientFp(this.configuration).skipTimerForGemSwap(offerId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsPaymentsClient - axios parameter creator
 * @export
 */
export const WalletsPaymentsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Confirm Payment has been received
         * @summary Confirm Payment has been received
         * @param {string} provider Payment provider in path
         * @param {ConfirmPaymentRequestBody} [confirmPaymentRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPayment: (provider, confirmPaymentRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('confirmPayment', 'provider', provider);
            const localVarPath = `/wallets/payments/{provider}/confirm`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(confirmPaymentRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate a payment and return a payment link
         * @summary Initiate a payment and return a payment link
         * @param {InitiatePaymentRequestBody} [initiatePaymentRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePayment: (initiatePaymentRequestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/payments/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(initiatePaymentRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Approve Paystack Transfer
         * @summary Approve Paystack Transfer
         * @param {{ [key: string]: any; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paystackApproveTransfer: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/payments/paystack/approve-transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsPaymentsClient - functional programming interface
 * @export
 */
export const WalletsPaymentsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsPaymentsClientAxiosParamCreator(configuration);
    return {
        /**
         * Confirm Payment has been received
         * @summary Confirm Payment has been received
         * @param {string} provider Payment provider in path
         * @param {ConfirmPaymentRequestBody} [confirmPaymentRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPayment(provider, confirmPaymentRequestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmPayment(provider, confirmPaymentRequestBody, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsPaymentsClient.confirmPayment']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initiate a payment and return a payment link
         * @summary Initiate a payment and return a payment link
         * @param {InitiatePaymentRequestBody} [initiatePaymentRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePayment(initiatePaymentRequestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiatePayment(initiatePaymentRequestBody, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsPaymentsClient.initiatePayment']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Approve Paystack Transfer
         * @summary Approve Paystack Transfer
         * @param {{ [key: string]: any; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paystackApproveTransfer(requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paystackApproveTransfer(requestBody, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsPaymentsClient.paystackApproveTransfer']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsPaymentsClient - factory interface
 * @export
 */
export const WalletsPaymentsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsPaymentsClientFp(configuration);
    return {
        /**
         * Confirm Payment has been received
         * @summary Confirm Payment has been received
         * @param {string} provider Payment provider in path
         * @param {ConfirmPaymentRequestBody} [confirmPaymentRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPayment(provider, confirmPaymentRequestBody, options) {
            return localVarFp.confirmPayment(provider, confirmPaymentRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate a payment and return a payment link
         * @summary Initiate a payment and return a payment link
         * @param {InitiatePaymentRequestBody} [initiatePaymentRequestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePayment(initiatePaymentRequestBody, options) {
            return localVarFp.initiatePayment(initiatePaymentRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve Paystack Transfer
         * @summary Approve Paystack Transfer
         * @param {{ [key: string]: any; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paystackApproveTransfer(requestBody, options) {
            return localVarFp.paystackApproveTransfer(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsPaymentsClient - object-oriented interface
 * @export
 * @class WalletsPaymentsClient
 * @extends {BaseAPI}
 */
export class WalletsPaymentsClient extends BaseAPI {
    /**
     * Confirm Payment has been received
     * @summary Confirm Payment has been received
     * @param {string} provider Payment provider in path
     * @param {ConfirmPaymentRequestBody} [confirmPaymentRequestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsPaymentsClient
     */
    confirmPayment(provider, confirmPaymentRequestBody, options) {
        return WalletsPaymentsClientFp(this.configuration).confirmPayment(provider, confirmPaymentRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate a payment and return a payment link
     * @summary Initiate a payment and return a payment link
     * @param {InitiatePaymentRequestBody} [initiatePaymentRequestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsPaymentsClient
     */
    initiatePayment(initiatePaymentRequestBody, options) {
        return WalletsPaymentsClientFp(this.configuration).initiatePayment(initiatePaymentRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Approve Paystack Transfer
     * @summary Approve Paystack Transfer
     * @param {{ [key: string]: any; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsPaymentsClient
     */
    paystackApproveTransfer(requestBody, options) {
        return WalletsPaymentsClientFp(this.configuration).paystackApproveTransfer(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsPlansClient - axios parameter creator
 * @export
 */
export const WalletsPlansClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * List HPR purchase plans
         * @summary List HPR purchase plans
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHprPurchasePlans: (page, limit, sort, currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsPlansClient - functional programming interface
 * @export
 */
export const WalletsPlansClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsPlansClientAxiosParamCreator(configuration);
    return {
        /**
         * List HPR purchase plans
         * @summary List HPR purchase plans
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHprPurchasePlans(page, limit, sort, currency, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listHprPurchasePlans(page, limit, sort, currency, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsPlansClient.listHprPurchasePlans']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsPlansClient - factory interface
 * @export
 */
export const WalletsPlansClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsPlansClientFp(configuration);
    return {
        /**
         * List HPR purchase plans
         * @summary List HPR purchase plans
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
         * @param {FiatCurrency} [currency] Fiat currency identifier in query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHprPurchasePlans(page, limit, sort, currency, options) {
            return localVarFp.listHprPurchasePlans(page, limit, sort, currency, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsPlansClient - object-oriented interface
 * @export
 * @class WalletsPlansClient
 * @extends {BaseAPI}
 */
export class WalletsPlansClient extends BaseAPI {
    /**
     * List HPR purchase plans
     * @summary List HPR purchase plans
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {string} [sort] Sort string used to sort various fields in &#x60;asc&#x60; or &#x60;desc&#x60; order. E.g. &#x60;name:asc,createdAt:desc&#x60;
     * @param {FiatCurrency} [currency] Fiat currency identifier in query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsPlansClient
     */
    listHprPurchasePlans(page, limit, sort, currency, options) {
        return WalletsPlansClientFp(this.configuration).listHprPurchasePlans(page, limit, sort, currency, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WalletsTransactionsClient - axios parameter creator
 * @export
 */
export const WalletsTransactionsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * Cash out HPR to USD
         * @summary Cash out HPR
         * @param {CashOutRequestDto} [cashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashOutHpr: (cashOutRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/transactions/cash-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cashOutRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Cashout with USD payment provider
         * @summary Cashout with USD payment provider
         * @param {string} provider Usd payment provider in path
         * @param {UsdCashOutRequestDto} [usdCashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashoutUsd: (provider, usdCashOutRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('cashoutUsd', 'provider', provider);
            const localVarPath = `/wallets/me/fiat-channels/{provider}/cashout`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(usdCashOutRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Cashout with fiat-channel (HPR -> FIAT-CURRENCY like NGN)
         * @summary Cashout with fiat-channel
         * @param {FiatCashOutRequestDto} [fiatCashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashoutWithFiatChannel: (fiatCashOutRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/fiat-channels/cashout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(fiatCashOutRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get wallet fiat transactions for current user
         * @summary Get current user fiat-transaction history
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {Array<FiatCurrency>} [fiatCurrencies] Currencies to filter with in query
         * @param {TransactionType} [transactionType] Transaction type query
         * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
         * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyFiatTransactionHistory: (page, limit, fiatCurrencies, transactionType, startTs, endTs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/fiat-channels/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (fiatCurrencies) {
                localVarQueryParameter['fiatCurrencies'] = Array.from(fiatCurrencies);
            }
            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }
            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }
            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get wallet revertible transaction for current user
         * @summary Get current user revertible transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRevertibleTransaction: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/transactions/revertible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get my topUp state
         * @summary Get my topUp state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopupState: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/transactions/top-up/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves the transaction details for a transaction by the transaction Id
         * @summary To get the transaction details for a single transaction
         * @param {string} transactionId Transaction identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTransactionDetail: (transactionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getMyTransactionDetail', 'transactionId', transactionId);
            const localVarPath = `/wallets/me/transactions/history/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get wallet transactions for current user
         * @summary Get current user transaction history
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {Array<Currency>} [currencies] Currencies to filter with in query
         * @param {TransactionType} [transactionType] Transaction type query
         * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
         * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTransactionHistory: (page, limit, currencies, transactionType, startTs, endTs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/transactions/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (currencies) {
                localVarQueryParameter['currencies'] = Array.from(currencies);
            }
            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }
            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = startTs;
            }
            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = endTs;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiate withdrawal to a blockchain address
         * @summary Withdraw to blockchain address
         * @param {InitiateWithdrawalDto} [initiateWithdrawalDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateWithdrawal: (initiateWithdrawalDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/transactions/withdraw`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(initiateWithdrawalDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Revert HPR top up to USD
         * @summary Revert HPR top up
         * @param {string} transactionId Transaction identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertHprTopUp: (transactionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('revertHprTopUp', 'transactionId', transactionId);
            const localVarPath = `/wallets/me/transactions/{transactionId}/revert`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Top up HPR with USD
         * @summary Top up HPR
         * @param {TopUpRequestDto} [topUpRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topUpHpr: (topUpRequestDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/wallets/me/transactions/top-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerToken required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(topUpRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WalletsTransactionsClient - functional programming interface
 * @export
 */
export const WalletsTransactionsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WalletsTransactionsClientAxiosParamCreator(configuration);
    return {
        /**
         * Cash out HPR to USD
         * @summary Cash out HPR
         * @param {CashOutRequestDto} [cashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashOutHpr(cashOutRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cashOutHpr(cashOutRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.cashOutHpr']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Cashout with USD payment provider
         * @summary Cashout with USD payment provider
         * @param {string} provider Usd payment provider in path
         * @param {UsdCashOutRequestDto} [usdCashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashoutUsd(provider, usdCashOutRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cashoutUsd(provider, usdCashOutRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.cashoutUsd']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Cashout with fiat-channel (HPR -> FIAT-CURRENCY like NGN)
         * @summary Cashout with fiat-channel
         * @param {FiatCashOutRequestDto} [fiatCashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashoutWithFiatChannel(fiatCashOutRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cashoutWithFiatChannel(fiatCashOutRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.cashoutWithFiatChannel']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get wallet fiat transactions for current user
         * @summary Get current user fiat-transaction history
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {Array<FiatCurrency>} [fiatCurrencies] Currencies to filter with in query
         * @param {TransactionType} [transactionType] Transaction type query
         * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
         * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyFiatTransactionHistory(page, limit, fiatCurrencies, transactionType, startTs, endTs, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyFiatTransactionHistory(page, limit, fiatCurrencies, transactionType, startTs, endTs, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.getMyFiatTransactionHistory']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get wallet revertible transaction for current user
         * @summary Get current user revertible transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRevertibleTransaction(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyRevertibleTransaction(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.getMyRevertibleTransaction']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get my topUp state
         * @summary Get my topUp state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopupState(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyTopupState(options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.getMyTopupState']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieves the transaction details for a transaction by the transaction Id
         * @summary To get the transaction details for a single transaction
         * @param {string} transactionId Transaction identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTransactionDetail(transactionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyTransactionDetail(transactionId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.getMyTransactionDetail']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Get wallet transactions for current user
         * @summary Get current user transaction history
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {Array<Currency>} [currencies] Currencies to filter with in query
         * @param {TransactionType} [transactionType] Transaction type query
         * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
         * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTransactionHistory(page, limit, currencies, transactionType, startTs, endTs, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyTransactionHistory(page, limit, currencies, transactionType, startTs, endTs, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.getMyTransactionHistory']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Initiate withdrawal to a blockchain address
         * @summary Withdraw to blockchain address
         * @param {InitiateWithdrawalDto} [initiateWithdrawalDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateWithdrawal(initiateWithdrawalDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.initiateWithdrawal(initiateWithdrawalDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.initiateWithdrawal']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Revert HPR top up to USD
         * @summary Revert HPR top up
         * @param {string} transactionId Transaction identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertHprTopUp(transactionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revertHprTopUp(transactionId, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.revertHprTopUp']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Top up HPR with USD
         * @summary Top up HPR
         * @param {TopUpRequestDto} [topUpRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topUpHpr(topUpRequestDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.topUpHpr(topUpRequestDto, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WalletsTransactionsClient.topUpHpr']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WalletsTransactionsClient - factory interface
 * @export
 */
export const WalletsTransactionsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletsTransactionsClientFp(configuration);
    return {
        /**
         * Cash out HPR to USD
         * @summary Cash out HPR
         * @param {CashOutRequestDto} [cashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashOutHpr(cashOutRequestDto, options) {
            return localVarFp.cashOutHpr(cashOutRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Cashout with USD payment provider
         * @summary Cashout with USD payment provider
         * @param {string} provider Usd payment provider in path
         * @param {UsdCashOutRequestDto} [usdCashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashoutUsd(provider, usdCashOutRequestDto, options) {
            return localVarFp.cashoutUsd(provider, usdCashOutRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Cashout with fiat-channel (HPR -> FIAT-CURRENCY like NGN)
         * @summary Cashout with fiat-channel
         * @param {FiatCashOutRequestDto} [fiatCashOutRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashoutWithFiatChannel(fiatCashOutRequestDto, options) {
            return localVarFp.cashoutWithFiatChannel(fiatCashOutRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get wallet fiat transactions for current user
         * @summary Get current user fiat-transaction history
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {Array<FiatCurrency>} [fiatCurrencies] Currencies to filter with in query
         * @param {TransactionType} [transactionType] Transaction type query
         * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
         * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyFiatTransactionHistory(page, limit, fiatCurrencies, transactionType, startTs, endTs, options) {
            return localVarFp.getMyFiatTransactionHistory(page, limit, fiatCurrencies, transactionType, startTs, endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * Get wallet revertible transaction for current user
         * @summary Get current user revertible transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRevertibleTransaction(options) {
            return localVarFp.getMyRevertibleTransaction(options).then((request) => request(axios, basePath));
        },
        /**
         * Get my topUp state
         * @summary Get my topUp state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTopupState(options) {
            return localVarFp.getMyTopupState(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the transaction details for a transaction by the transaction Id
         * @summary To get the transaction details for a single transaction
         * @param {string} transactionId Transaction identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTransactionDetail(transactionId, options) {
            return localVarFp.getMyTransactionDetail(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get wallet transactions for current user
         * @summary Get current user transaction history
         * @param {number} [page] Page to be gotten based on size parameters
         * @param {number} [limit] Number of items to be gotten per page
         * @param {Array<Currency>} [currencies] Currencies to filter with in query
         * @param {TransactionType} [transactionType] Transaction type query
         * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
         * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTransactionHistory(page, limit, currencies, transactionType, startTs, endTs, options) {
            return localVarFp.getMyTransactionHistory(page, limit, currencies, transactionType, startTs, endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate withdrawal to a blockchain address
         * @summary Withdraw to blockchain address
         * @param {InitiateWithdrawalDto} [initiateWithdrawalDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateWithdrawal(initiateWithdrawalDto, options) {
            return localVarFp.initiateWithdrawal(initiateWithdrawalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Revert HPR top up to USD
         * @summary Revert HPR top up
         * @param {string} transactionId Transaction identifier in path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revertHprTopUp(transactionId, options) {
            return localVarFp.revertHprTopUp(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Top up HPR with USD
         * @summary Top up HPR
         * @param {TopUpRequestDto} [topUpRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topUpHpr(topUpRequestDto, options) {
            return localVarFp.topUpHpr(topUpRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletsTransactionsClient - object-oriented interface
 * @export
 * @class WalletsTransactionsClient
 * @extends {BaseAPI}
 */
export class WalletsTransactionsClient extends BaseAPI {
    /**
     * Cash out HPR to USD
     * @summary Cash out HPR
     * @param {CashOutRequestDto} [cashOutRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    cashOutHpr(cashOutRequestDto, options) {
        return WalletsTransactionsClientFp(this.configuration).cashOutHpr(cashOutRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cashout with USD payment provider
     * @summary Cashout with USD payment provider
     * @param {string} provider Usd payment provider in path
     * @param {UsdCashOutRequestDto} [usdCashOutRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    cashoutUsd(provider, usdCashOutRequestDto, options) {
        return WalletsTransactionsClientFp(this.configuration).cashoutUsd(provider, usdCashOutRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cashout with fiat-channel (HPR -> FIAT-CURRENCY like NGN)
     * @summary Cashout with fiat-channel
     * @param {FiatCashOutRequestDto} [fiatCashOutRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    cashoutWithFiatChannel(fiatCashOutRequestDto, options) {
        return WalletsTransactionsClientFp(this.configuration).cashoutWithFiatChannel(fiatCashOutRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get wallet fiat transactions for current user
     * @summary Get current user fiat-transaction history
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {Array<FiatCurrency>} [fiatCurrencies] Currencies to filter with in query
     * @param {TransactionType} [transactionType] Transaction type query
     * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
     * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    getMyFiatTransactionHistory(page, limit, fiatCurrencies, transactionType, startTs, endTs, options) {
        return WalletsTransactionsClientFp(this.configuration).getMyFiatTransactionHistory(page, limit, fiatCurrencies, transactionType, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get wallet revertible transaction for current user
     * @summary Get current user revertible transaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    getMyRevertibleTransaction(options) {
        return WalletsTransactionsClientFp(this.configuration).getMyRevertibleTransaction(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get my topUp state
     * @summary Get my topUp state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    getMyTopupState(options) {
        return WalletsTransactionsClientFp(this.configuration).getMyTopupState(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the transaction details for a transaction by the transaction Id
     * @summary To get the transaction details for a single transaction
     * @param {string} transactionId Transaction identifier in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    getMyTransactionDetail(transactionId, options) {
        return WalletsTransactionsClientFp(this.configuration).getMyTransactionDetail(transactionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get wallet transactions for current user
     * @summary Get current user transaction history
     * @param {number} [page] Page to be gotten based on size parameters
     * @param {number} [limit] Number of items to be gotten per page
     * @param {Array<Currency>} [currencies] Currencies to filter with in query
     * @param {TransactionType} [transactionType] Transaction type query
     * @param {number} [startTs] Start timestamp (inclusive) in Unix Epoch. Data before this timestamp will not be returned.
     * @param {number} [endTs] End timestamp (exclusive) in Unix Epoch. Data on or after this timestamp will not be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    getMyTransactionHistory(page, limit, currencies, transactionType, startTs, endTs, options) {
        return WalletsTransactionsClientFp(this.configuration).getMyTransactionHistory(page, limit, currencies, transactionType, startTs, endTs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiate withdrawal to a blockchain address
     * @summary Withdraw to blockchain address
     * @param {InitiateWithdrawalDto} [initiateWithdrawalDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    initiateWithdrawal(initiateWithdrawalDto, options) {
        return WalletsTransactionsClientFp(this.configuration).initiateWithdrawal(initiateWithdrawalDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Revert HPR top up to USD
     * @summary Revert HPR top up
     * @param {string} transactionId Transaction identifier in path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    revertHprTopUp(transactionId, options) {
        return WalletsTransactionsClientFp(this.configuration).revertHprTopUp(transactionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Top up HPR with USD
     * @summary Top up HPR
     * @param {TopUpRequestDto} [topUpRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WalletsTransactionsClient
     */
    topUpHpr(topUpRequestDto, options) {
        return WalletsTransactionsClientFp(this.configuration).topUpHpr(topUpRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WebhooksWalletsClient - axios parameter creator
 * @export
 */
export const WebhooksWalletsClientAxiosParamCreator = function (configuration) {
    return {
        /**
         * This endpoint is for receiving notification for coinflow transactions
         * @summary Coinflow Transaction Webhook
         * @param {CoinflowTransactionData} [coinflowTransactionData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coinflowTransactionNotification: (coinflowTransactionData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/webhooks/wallets/coinflow/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(coinflowTransactionData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is for receiving notification for lift completed transactions
         * @summary Lift Transaction Webhook
         * @param {LiftTransaction} [liftTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liftTransactionNotification: (liftTransaction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/webhooks/wallets/lift/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(liftTransaction, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is for receiving notification for paypal transactions
         * @summary Paypal Transaction Webhook
         * @param {PaypalTransaction} [paypalTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paypalTransactionNotification: (paypalTransaction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/webhooks/wallets/paypal/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(paypalTransaction, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is for receiving notification for paystack transactions
         * @summary Paystack Transaction Webhook
         * @param {PaystackTransaction} [paystackTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paystackTransactionNotification: (paystackTransaction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/webhooks/wallets/paystack/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(paystackTransaction, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is for receiving notification for vella completed transactions
         * @summary Vella Transaction Webhook
         * @param {VellaTransaction} [vellaTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vellaTransactionNotification: (vellaTransaction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/webhooks/wallets/vella/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(vellaTransaction, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WebhooksWalletsClient - functional programming interface
 * @export
 */
export const WebhooksWalletsClientFp = function (configuration) {
    const localVarAxiosParamCreator = WebhooksWalletsClientAxiosParamCreator(configuration);
    return {
        /**
         * This endpoint is for receiving notification for coinflow transactions
         * @summary Coinflow Transaction Webhook
         * @param {CoinflowTransactionData} [coinflowTransactionData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coinflowTransactionNotification(coinflowTransactionData, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.coinflowTransactionNotification(coinflowTransactionData, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WebhooksWalletsClient.coinflowTransactionNotification']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * This endpoint is for receiving notification for lift completed transactions
         * @summary Lift Transaction Webhook
         * @param {LiftTransaction} [liftTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liftTransactionNotification(liftTransaction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.liftTransactionNotification(liftTransaction, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WebhooksWalletsClient.liftTransactionNotification']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * This endpoint is for receiving notification for paypal transactions
         * @summary Paypal Transaction Webhook
         * @param {PaypalTransaction} [paypalTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paypalTransactionNotification(paypalTransaction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paypalTransactionNotification(paypalTransaction, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WebhooksWalletsClient.paypalTransactionNotification']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * This endpoint is for receiving notification for paystack transactions
         * @summary Paystack Transaction Webhook
         * @param {PaystackTransaction} [paystackTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paystackTransactionNotification(paystackTransaction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paystackTransactionNotification(paystackTransaction, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WebhooksWalletsClient.paystackTransactionNotification']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * This endpoint is for receiving notification for vella completed transactions
         * @summary Vella Transaction Webhook
         * @param {VellaTransaction} [vellaTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vellaTransactionNotification(vellaTransaction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.vellaTransactionNotification(vellaTransaction, options);
                // Changed index to srvIndex to avoid parameter name clash
                const srvIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WebhooksWalletsClient.vellaTransactionNotification']) === null || _b === void 0 ? void 0 : _b[srvIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WebhooksWalletsClient - factory interface
 * @export
 */
export const WebhooksWalletsClientFactory = function (configuration, basePath, axios) {
    const localVarFp = WebhooksWalletsClientFp(configuration);
    return {
        /**
         * This endpoint is for receiving notification for coinflow transactions
         * @summary Coinflow Transaction Webhook
         * @param {CoinflowTransactionData} [coinflowTransactionData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coinflowTransactionNotification(coinflowTransactionData, options) {
            return localVarFp.coinflowTransactionNotification(coinflowTransactionData, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is for receiving notification for lift completed transactions
         * @summary Lift Transaction Webhook
         * @param {LiftTransaction} [liftTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liftTransactionNotification(liftTransaction, options) {
            return localVarFp.liftTransactionNotification(liftTransaction, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is for receiving notification for paypal transactions
         * @summary Paypal Transaction Webhook
         * @param {PaypalTransaction} [paypalTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paypalTransactionNotification(paypalTransaction, options) {
            return localVarFp.paypalTransactionNotification(paypalTransaction, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is for receiving notification for paystack transactions
         * @summary Paystack Transaction Webhook
         * @param {PaystackTransaction} [paystackTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paystackTransactionNotification(paystackTransaction, options) {
            return localVarFp.paystackTransactionNotification(paystackTransaction, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is for receiving notification for vella completed transactions
         * @summary Vella Transaction Webhook
         * @param {VellaTransaction} [vellaTransaction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vellaTransactionNotification(vellaTransaction, options) {
            return localVarFp.vellaTransactionNotification(vellaTransaction, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WebhooksWalletsClient - object-oriented interface
 * @export
 * @class WebhooksWalletsClient
 * @extends {BaseAPI}
 */
export class WebhooksWalletsClient extends BaseAPI {
    /**
     * This endpoint is for receiving notification for coinflow transactions
     * @summary Coinflow Transaction Webhook
     * @param {CoinflowTransactionData} [coinflowTransactionData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksWalletsClient
     */
    coinflowTransactionNotification(coinflowTransactionData, options) {
        return WebhooksWalletsClientFp(this.configuration).coinflowTransactionNotification(coinflowTransactionData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint is for receiving notification for lift completed transactions
     * @summary Lift Transaction Webhook
     * @param {LiftTransaction} [liftTransaction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksWalletsClient
     */
    liftTransactionNotification(liftTransaction, options) {
        return WebhooksWalletsClientFp(this.configuration).liftTransactionNotification(liftTransaction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint is for receiving notification for paypal transactions
     * @summary Paypal Transaction Webhook
     * @param {PaypalTransaction} [paypalTransaction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksWalletsClient
     */
    paypalTransactionNotification(paypalTransaction, options) {
        return WebhooksWalletsClientFp(this.configuration).paypalTransactionNotification(paypalTransaction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint is for receiving notification for paystack transactions
     * @summary Paystack Transaction Webhook
     * @param {PaystackTransaction} [paystackTransaction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksWalletsClient
     */
    paystackTransactionNotification(paystackTransaction, options) {
        return WebhooksWalletsClientFp(this.configuration).paystackTransactionNotification(paystackTransaction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint is for receiving notification for vella completed transactions
     * @summary Vella Transaction Webhook
     * @param {VellaTransaction} [vellaTransaction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksWalletsClient
     */
    vellaTransactionNotification(vellaTransaction, options) {
        return WebhooksWalletsClientFp(this.configuration).vellaTransactionNotification(vellaTransaction, options).then((request) => request(this.axios, this.basePath));
    }
}
export default {};
